import * as t from "maptalks";

import { Coordinate as e, Util as i, Point as s, Polygon as n, Extent as r, Map as h, renderer as o } from "maptalks";

import * as a from "@maptalks/reshader.gl";

import { mat4 as l, vec3 as c, vec2 as u, mat3 as f, quat as d, earcut as m, vec4 as g } from "@maptalks/reshader.gl";

export { earcut } from "@maptalks/reshader.gl";

import { GLContext as p } from "@maptalks/fusiongl";

export { GLContext } from "@maptalks/fusiongl";

import w, { createREGL as v } from "@maptalks/regl";

function _(t) {
    return t && t.t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}

var y = {
    exports: {}
}, b = {
    exports: {}
}, x = function(t) {
    return !(!t || "string" == typeof t) && (t instanceof Array || Array.isArray(t) || t.length >= 0 && (t.splice instanceof Function || Object.getOwnPropertyDescriptor(t, t.length - 1) && "String" !== t.constructor.name));
}, M = Array.prototype.concat, S = Array.prototype.slice, C = b.exports = function(t) {
    for (var e = [], i = 0, s = t.length; i < s; i++) {
        var n = t[i];
        x(n) ? e = M.call(e, S.call(n)) : e.push(n);
    }
    return e;
};

C.wrap = function(t) {
    return function() {
        return t(C(arguments));
    };
};

var k = b.exports, T = {
    "aliceblue": [ 240, 248, 255 ],
    "antiquewhite": [ 250, 235, 215 ],
    "aqua": [ 0, 255, 255 ],
    "aquamarine": [ 127, 255, 212 ],
    "azure": [ 240, 255, 255 ],
    "beige": [ 245, 245, 220 ],
    "bisque": [ 255, 228, 196 ],
    "black": [ 0, 0, 0 ],
    "blanchedalmond": [ 255, 235, 205 ],
    "blue": [ 0, 0, 255 ],
    "blueviolet": [ 138, 43, 226 ],
    "brown": [ 165, 42, 42 ],
    "burlywood": [ 222, 184, 135 ],
    "cadetblue": [ 95, 158, 160 ],
    "chartreuse": [ 127, 255, 0 ],
    "chocolate": [ 210, 105, 30 ],
    "coral": [ 255, 127, 80 ],
    "cornflowerblue": [ 100, 149, 237 ],
    "cornsilk": [ 255, 248, 220 ],
    "crimson": [ 220, 20, 60 ],
    "cyan": [ 0, 255, 255 ],
    "darkblue": [ 0, 0, 139 ],
    "darkcyan": [ 0, 139, 139 ],
    "darkgoldenrod": [ 184, 134, 11 ],
    "darkgray": [ 169, 169, 169 ],
    "darkgreen": [ 0, 100, 0 ],
    "darkgrey": [ 169, 169, 169 ],
    "darkkhaki": [ 189, 183, 107 ],
    "darkmagenta": [ 139, 0, 139 ],
    "darkolivegreen": [ 85, 107, 47 ],
    "darkorange": [ 255, 140, 0 ],
    "darkorchid": [ 153, 50, 204 ],
    "darkred": [ 139, 0, 0 ],
    "darksalmon": [ 233, 150, 122 ],
    "darkseagreen": [ 143, 188, 143 ],
    "darkslateblue": [ 72, 61, 139 ],
    "darkslategray": [ 47, 79, 79 ],
    "darkslategrey": [ 47, 79, 79 ],
    "darkturquoise": [ 0, 206, 209 ],
    "darkviolet": [ 148, 0, 211 ],
    "deeppink": [ 255, 20, 147 ],
    "deepskyblue": [ 0, 191, 255 ],
    "dimgray": [ 105, 105, 105 ],
    "dimgrey": [ 105, 105, 105 ],
    "dodgerblue": [ 30, 144, 255 ],
    "firebrick": [ 178, 34, 34 ],
    "floralwhite": [ 255, 250, 240 ],
    "forestgreen": [ 34, 139, 34 ],
    "fuchsia": [ 255, 0, 255 ],
    "gainsboro": [ 220, 220, 220 ],
    "ghostwhite": [ 248, 248, 255 ],
    "gold": [ 255, 215, 0 ],
    "goldenrod": [ 218, 165, 32 ],
    "gray": [ 128, 128, 128 ],
    "green": [ 0, 128, 0 ],
    "greenyellow": [ 173, 255, 47 ],
    "grey": [ 128, 128, 128 ],
    "honeydew": [ 240, 255, 240 ],
    "hotpink": [ 255, 105, 180 ],
    "indianred": [ 205, 92, 92 ],
    "indigo": [ 75, 0, 130 ],
    "ivory": [ 255, 255, 240 ],
    "khaki": [ 240, 230, 140 ],
    "lavender": [ 230, 230, 250 ],
    "lavenderblush": [ 255, 240, 245 ],
    "lawngreen": [ 124, 252, 0 ],
    "lemonchiffon": [ 255, 250, 205 ],
    "lightblue": [ 173, 216, 230 ],
    "lightcoral": [ 240, 128, 128 ],
    "lightcyan": [ 224, 255, 255 ],
    "lightgoldenrodyellow": [ 250, 250, 210 ],
    "lightgray": [ 211, 211, 211 ],
    "lightgreen": [ 144, 238, 144 ],
    "lightgrey": [ 211, 211, 211 ],
    "lightpink": [ 255, 182, 193 ],
    "lightsalmon": [ 255, 160, 122 ],
    "lightseagreen": [ 32, 178, 170 ],
    "lightskyblue": [ 135, 206, 250 ],
    "lightslategray": [ 119, 136, 153 ],
    "lightslategrey": [ 119, 136, 153 ],
    "lightsteelblue": [ 176, 196, 222 ],
    "lightyellow": [ 255, 255, 224 ],
    "lime": [ 0, 255, 0 ],
    "limegreen": [ 50, 205, 50 ],
    "linen": [ 250, 240, 230 ],
    "magenta": [ 255, 0, 255 ],
    "maroon": [ 128, 0, 0 ],
    "mediumaquamarine": [ 102, 205, 170 ],
    "mediumblue": [ 0, 0, 205 ],
    "mediumorchid": [ 186, 85, 211 ],
    "mediumpurple": [ 147, 112, 219 ],
    "mediumseagreen": [ 60, 179, 113 ],
    "mediumslateblue": [ 123, 104, 238 ],
    "mediumspringgreen": [ 0, 250, 154 ],
    "mediumturquoise": [ 72, 209, 204 ],
    "mediumvioletred": [ 199, 21, 133 ],
    "midnightblue": [ 25, 25, 112 ],
    "mintcream": [ 245, 255, 250 ],
    "mistyrose": [ 255, 228, 225 ],
    "moccasin": [ 255, 228, 181 ],
    "navajowhite": [ 255, 222, 173 ],
    "navy": [ 0, 0, 128 ],
    "oldlace": [ 253, 245, 230 ],
    "olive": [ 128, 128, 0 ],
    "olivedrab": [ 107, 142, 35 ],
    "orange": [ 255, 165, 0 ],
    "orangered": [ 255, 69, 0 ],
    "orchid": [ 218, 112, 214 ],
    "palegoldenrod": [ 238, 232, 170 ],
    "palegreen": [ 152, 251, 152 ],
    "paleturquoise": [ 175, 238, 238 ],
    "palevioletred": [ 219, 112, 147 ],
    "papayawhip": [ 255, 239, 213 ],
    "peachpuff": [ 255, 218, 185 ],
    "peru": [ 205, 133, 63 ],
    "pink": [ 255, 192, 203 ],
    "plum": [ 221, 160, 221 ],
    "powderblue": [ 176, 224, 230 ],
    "purple": [ 128, 0, 128 ],
    "rebeccapurple": [ 102, 51, 153 ],
    "red": [ 255, 0, 0 ],
    "rosybrown": [ 188, 143, 143 ],
    "royalblue": [ 65, 105, 225 ],
    "saddlebrown": [ 139, 69, 19 ],
    "salmon": [ 250, 128, 114 ],
    "sandybrown": [ 244, 164, 96 ],
    "seagreen": [ 46, 139, 87 ],
    "seashell": [ 255, 245, 238 ],
    "sienna": [ 160, 82, 45 ],
    "silver": [ 192, 192, 192 ],
    "skyblue": [ 135, 206, 235 ],
    "slateblue": [ 106, 90, 205 ],
    "slategray": [ 112, 128, 144 ],
    "slategrey": [ 112, 128, 144 ],
    "snow": [ 255, 250, 250 ],
    "springgreen": [ 0, 255, 127 ],
    "steelblue": [ 70, 130, 180 ],
    "tan": [ 210, 180, 140 ],
    "teal": [ 0, 128, 128 ],
    "thistle": [ 216, 191, 216 ],
    "tomato": [ 255, 99, 71 ],
    "turquoise": [ 64, 224, 208 ],
    "violet": [ 238, 130, 238 ],
    "wheat": [ 245, 222, 179 ],
    "white": [ 255, 255, 255 ],
    "whitesmoke": [ 245, 245, 245 ],
    "yellow": [ 255, 255, 0 ],
    "yellowgreen": [ 154, 205, 50 ]
}, A = k, O = Object.hasOwnProperty, I = Object.create(null);

for (var L in T) O.call(T, L) && (I[T[L]] = L);

var E = y.exports = {
    to: {},
    get: {}
};

function R(t, e, i) {
    return Math.min(Math.max(e, t), i);
}

function F(t) {
    var e = Math.round(t).toString(16).toUpperCase();
    return e.length < 2 ? "0" + e : e;
}

E.get = function(t) {
    var e, i;
    switch (t.substring(0, 3).toLowerCase()) {
      case "hsl":
        e = E.get.hsl(t), i = "hsl";
        break;

      case "hwb":
        e = E.get.hwb(t), i = "hwb";
        break;

      default:
        e = E.get.rgb(t), i = "rgb";
    }
    return e ? {
        model: i,
        value: e
    } : null;
}, E.get.rgb = function(t) {
    if (!t) return null;
    var e, i, s, n = [ 0, 0, 0, 1 ];
    if (e = t.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)) {
        for (s = e[2], e = e[1], i = 0; i < 3; i++) {
            var r = 2 * i;
            n[i] = parseInt(e.slice(r, r + 2), 16);
        }
        s && (n[3] = parseInt(s, 16) / 255);
    } else if (e = t.match(/^#([a-f0-9]{3,4})$/i)) {
        for (s = (e = e[1])[3], i = 0; i < 3; i++) n[i] = parseInt(e[i] + e[i], 16);
        s && (n[3] = parseInt(s + s, 16) / 255);
    } else if (e = t.match(/^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/)) {
        for (i = 0; i < 3; i++) n[i] = parseInt(e[i + 1], 0);
        e[4] && (e[5] ? n[3] = .01 * parseFloat(e[4]) : n[3] = parseFloat(e[4]));
    } else {
        if (!(e = t.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/))) return (e = t.match(/^(\w+)$/)) ? "transparent" === e[1] ? [ 0, 0, 0, 0 ] : O.call(T, e[1]) ? ((n = T[e[1]])[3] = 1, 
        n) : null : null;
        for (i = 0; i < 3; i++) n[i] = Math.round(2.55 * parseFloat(e[i + 1]));
        e[4] && (e[5] ? n[3] = .01 * parseFloat(e[4]) : n[3] = parseFloat(e[4]));
    }
    for (i = 0; i < 3; i++) n[i] = R(n[i], 0, 255);
    return n[3] = R(n[3], 0, 1), n;
}, E.get.hsl = function(t) {
    if (!t) return null;
    var e = t.match(/^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
    if (e) {
        var i = parseFloat(e[4]);
        return [ (parseFloat(e[1]) % 360 + 360) % 360, R(parseFloat(e[2]), 0, 100), R(parseFloat(e[3]), 0, 100), R(isNaN(i) ? 1 : i, 0, 1) ];
    }
    return null;
}, E.get.hwb = function(t) {
    if (!t) return null;
    var e = t.match(/^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
    if (e) {
        var i = parseFloat(e[4]);
        return [ (parseFloat(e[1]) % 360 + 360) % 360, R(parseFloat(e[2]), 0, 100), R(parseFloat(e[3]), 0, 100), R(isNaN(i) ? 1 : i, 0, 1) ];
    }
    return null;
}, E.to.hex = function() {
    var t = A(arguments);
    return "#" + F(t[0]) + F(t[1]) + F(t[2]) + (t[3] < 1 ? F(Math.round(255 * t[3])) : "");
}, E.to.rgb = function() {
    var t = A(arguments);
    return t.length < 4 || 1 === t[3] ? "rgb(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ")" : "rgba(" + Math.round(t[0]) + ", " + Math.round(t[1]) + ", " + Math.round(t[2]) + ", " + t[3] + ")";
}, E.to.rgb.percent = function() {
    var t = A(arguments), e = Math.round(t[0] / 255 * 100), i = Math.round(t[1] / 255 * 100), s = Math.round(t[2] / 255 * 100);
    return t.length < 4 || 1 === t[3] ? "rgb(" + e + "%, " + i + "%, " + s + "%)" : "rgba(" + e + "%, " + i + "%, " + s + "%, " + t[3] + ")";
}, E.to.hsl = function() {
    var t = A(arguments);
    return t.length < 4 || 1 === t[3] ? "hsl(" + t[0] + ", " + t[1] + "%, " + t[2] + "%)" : "hsla(" + t[0] + ", " + t[1] + "%, " + t[2] + "%, " + t[3] + ")";
}, E.to.hwb = function() {
    var t = A(arguments), e = "";
    return t.length >= 4 && 1 !== t[3] && (e = ", " + t[3]), "hwb(" + t[0] + ", " + t[1] + "%, " + t[2] + "%" + e + ")";
}, E.to.keyword = function(t) {
    return I[t.slice(0, 3)];
};

var P = y.exports, H = {
    exports: {}
}, D = {
    "aliceblue": [ 240, 248, 255 ],
    "antiquewhite": [ 250, 235, 215 ],
    "aqua": [ 0, 255, 255 ],
    "aquamarine": [ 127, 255, 212 ],
    "azure": [ 240, 255, 255 ],
    "beige": [ 245, 245, 220 ],
    "bisque": [ 255, 228, 196 ],
    "black": [ 0, 0, 0 ],
    "blanchedalmond": [ 255, 235, 205 ],
    "blue": [ 0, 0, 255 ],
    "blueviolet": [ 138, 43, 226 ],
    "brown": [ 165, 42, 42 ],
    "burlywood": [ 222, 184, 135 ],
    "cadetblue": [ 95, 158, 160 ],
    "chartreuse": [ 127, 255, 0 ],
    "chocolate": [ 210, 105, 30 ],
    "coral": [ 255, 127, 80 ],
    "cornflowerblue": [ 100, 149, 237 ],
    "cornsilk": [ 255, 248, 220 ],
    "crimson": [ 220, 20, 60 ],
    "cyan": [ 0, 255, 255 ],
    "darkblue": [ 0, 0, 139 ],
    "darkcyan": [ 0, 139, 139 ],
    "darkgoldenrod": [ 184, 134, 11 ],
    "darkgray": [ 169, 169, 169 ],
    "darkgreen": [ 0, 100, 0 ],
    "darkgrey": [ 169, 169, 169 ],
    "darkkhaki": [ 189, 183, 107 ],
    "darkmagenta": [ 139, 0, 139 ],
    "darkolivegreen": [ 85, 107, 47 ],
    "darkorange": [ 255, 140, 0 ],
    "darkorchid": [ 153, 50, 204 ],
    "darkred": [ 139, 0, 0 ],
    "darksalmon": [ 233, 150, 122 ],
    "darkseagreen": [ 143, 188, 143 ],
    "darkslateblue": [ 72, 61, 139 ],
    "darkslategray": [ 47, 79, 79 ],
    "darkslategrey": [ 47, 79, 79 ],
    "darkturquoise": [ 0, 206, 209 ],
    "darkviolet": [ 148, 0, 211 ],
    "deeppink": [ 255, 20, 147 ],
    "deepskyblue": [ 0, 191, 255 ],
    "dimgray": [ 105, 105, 105 ],
    "dimgrey": [ 105, 105, 105 ],
    "dodgerblue": [ 30, 144, 255 ],
    "firebrick": [ 178, 34, 34 ],
    "floralwhite": [ 255, 250, 240 ],
    "forestgreen": [ 34, 139, 34 ],
    "fuchsia": [ 255, 0, 255 ],
    "gainsboro": [ 220, 220, 220 ],
    "ghostwhite": [ 248, 248, 255 ],
    "gold": [ 255, 215, 0 ],
    "goldenrod": [ 218, 165, 32 ],
    "gray": [ 128, 128, 128 ],
    "green": [ 0, 128, 0 ],
    "greenyellow": [ 173, 255, 47 ],
    "grey": [ 128, 128, 128 ],
    "honeydew": [ 240, 255, 240 ],
    "hotpink": [ 255, 105, 180 ],
    "indianred": [ 205, 92, 92 ],
    "indigo": [ 75, 0, 130 ],
    "ivory": [ 255, 255, 240 ],
    "khaki": [ 240, 230, 140 ],
    "lavender": [ 230, 230, 250 ],
    "lavenderblush": [ 255, 240, 245 ],
    "lawngreen": [ 124, 252, 0 ],
    "lemonchiffon": [ 255, 250, 205 ],
    "lightblue": [ 173, 216, 230 ],
    "lightcoral": [ 240, 128, 128 ],
    "lightcyan": [ 224, 255, 255 ],
    "lightgoldenrodyellow": [ 250, 250, 210 ],
    "lightgray": [ 211, 211, 211 ],
    "lightgreen": [ 144, 238, 144 ],
    "lightgrey": [ 211, 211, 211 ],
    "lightpink": [ 255, 182, 193 ],
    "lightsalmon": [ 255, 160, 122 ],
    "lightseagreen": [ 32, 178, 170 ],
    "lightskyblue": [ 135, 206, 250 ],
    "lightslategray": [ 119, 136, 153 ],
    "lightslategrey": [ 119, 136, 153 ],
    "lightsteelblue": [ 176, 196, 222 ],
    "lightyellow": [ 255, 255, 224 ],
    "lime": [ 0, 255, 0 ],
    "limegreen": [ 50, 205, 50 ],
    "linen": [ 250, 240, 230 ],
    "magenta": [ 255, 0, 255 ],
    "maroon": [ 128, 0, 0 ],
    "mediumaquamarine": [ 102, 205, 170 ],
    "mediumblue": [ 0, 0, 205 ],
    "mediumorchid": [ 186, 85, 211 ],
    "mediumpurple": [ 147, 112, 219 ],
    "mediumseagreen": [ 60, 179, 113 ],
    "mediumslateblue": [ 123, 104, 238 ],
    "mediumspringgreen": [ 0, 250, 154 ],
    "mediumturquoise": [ 72, 209, 204 ],
    "mediumvioletred": [ 199, 21, 133 ],
    "midnightblue": [ 25, 25, 112 ],
    "mintcream": [ 245, 255, 250 ],
    "mistyrose": [ 255, 228, 225 ],
    "moccasin": [ 255, 228, 181 ],
    "navajowhite": [ 255, 222, 173 ],
    "navy": [ 0, 0, 128 ],
    "oldlace": [ 253, 245, 230 ],
    "olive": [ 128, 128, 0 ],
    "olivedrab": [ 107, 142, 35 ],
    "orange": [ 255, 165, 0 ],
    "orangered": [ 255, 69, 0 ],
    "orchid": [ 218, 112, 214 ],
    "palegoldenrod": [ 238, 232, 170 ],
    "palegreen": [ 152, 251, 152 ],
    "paleturquoise": [ 175, 238, 238 ],
    "palevioletred": [ 219, 112, 147 ],
    "papayawhip": [ 255, 239, 213 ],
    "peachpuff": [ 255, 218, 185 ],
    "peru": [ 205, 133, 63 ],
    "pink": [ 255, 192, 203 ],
    "plum": [ 221, 160, 221 ],
    "powderblue": [ 176, 224, 230 ],
    "purple": [ 128, 0, 128 ],
    "rebeccapurple": [ 102, 51, 153 ],
    "red": [ 255, 0, 0 ],
    "rosybrown": [ 188, 143, 143 ],
    "royalblue": [ 65, 105, 225 ],
    "saddlebrown": [ 139, 69, 19 ],
    "salmon": [ 250, 128, 114 ],
    "sandybrown": [ 244, 164, 96 ],
    "seagreen": [ 46, 139, 87 ],
    "seashell": [ 255, 245, 238 ],
    "sienna": [ 160, 82, 45 ],
    "silver": [ 192, 192, 192 ],
    "skyblue": [ 135, 206, 235 ],
    "slateblue": [ 106, 90, 205 ],
    "slategray": [ 112, 128, 144 ],
    "slategrey": [ 112, 128, 144 ],
    "snow": [ 255, 250, 250 ],
    "springgreen": [ 0, 255, 127 ],
    "steelblue": [ 70, 130, 180 ],
    "tan": [ 210, 180, 140 ],
    "teal": [ 0, 128, 128 ],
    "thistle": [ 216, 191, 216 ],
    "tomato": [ 255, 99, 71 ],
    "turquoise": [ 64, 224, 208 ],
    "violet": [ 238, 130, 238 ],
    "wheat": [ 245, 222, 179 ],
    "white": [ 255, 255, 255 ],
    "whitesmoke": [ 245, 245, 245 ],
    "yellow": [ 255, 255, 0 ],
    "yellowgreen": [ 154, 205, 50 ]
}, G = {};

for (var N in D) D.hasOwnProperty(N) && (G[D[N]] = N);

var j = H.exports = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [ "hex" ]
    },
    keyword: {
        channels: 1,
        labels: [ "keyword" ]
    },
    ansi16: {
        channels: 1,
        labels: [ "ansi16" ]
    },
    ansi256: {
        channels: 1,
        labels: [ "ansi256" ]
    },
    hcg: {
        channels: 3,
        labels: [ "h", "c", "g" ]
    },
    apple: {
        channels: 3,
        labels: [ "r16", "g16", "b16" ]
    },
    gray: {
        channels: 1,
        labels: [ "gray" ]
    }
};

for (var z in j) if (j.hasOwnProperty(z)) {
    if (!("channels" in j[z])) throw new Error("missing channels property: " + z);
    if (!("labels" in j[z])) throw new Error("missing channel labels property: " + z);
    if (j[z].labels.length !== j[z].channels) throw new Error("channel and label counts mismatch: " + z);
    var B = j[z].channels, U = j[z].labels;
    delete j[z].channels, delete j[z].labels, Object.defineProperty(j[z], "channels", {
        value: B
    }), Object.defineProperty(j[z], "labels", {
        value: U
    });
}

j.rgb.hsl = function(t) {
    var e, i, s = t[0] / 255, n = t[1] / 255, r = t[2] / 255, h = Math.min(s, n, r), o = Math.max(s, n, r), a = o - h;
    return o === h ? e = 0 : s === o ? e = (n - r) / a : n === o ? e = 2 + (r - s) / a : r === o && (e = 4 + (s - n) / a), 
    (e = Math.min(60 * e, 360)) < 0 && (e += 360), i = (h + o) / 2, [ e, 100 * (o === h ? 0 : i <= .5 ? a / (o + h) : a / (2 - o - h)), 100 * i ];
}, j.rgb.hsv = function(t) {
    var e, i, s, n, r, h = t[0] / 255, o = t[1] / 255, a = t[2] / 255, l = Math.max(h, o, a), c = l - Math.min(h, o, a), u = function(t) {
        return (l - t) / 6 / c + .5;
    };
    return 0 === c ? n = r = 0 : (r = c / l, e = u(h), i = u(o), s = u(a), h === l ? n = s - i : o === l ? n = 1 / 3 + e - s : a === l && (n = 2 / 3 + i - e), 
    n < 0 ? n += 1 : n > 1 && (n -= 1)), [ 360 * n, 100 * r, 100 * l ];
}, j.rgb.hwb = function(t) {
    var e = t[0], i = t[1], s = t[2];
    return [ j.rgb.hsl(t)[0], 100 * (1 / 255 * Math.min(e, Math.min(i, s))), 100 * (s = 1 - 1 / 255 * Math.max(e, Math.max(i, s))) ];
}, j.rgb.cmyk = function(t) {
    var e, i = t[0] / 255, s = t[1] / 255, n = t[2] / 255;
    return [ 100 * ((1 - i - (e = Math.min(1 - i, 1 - s, 1 - n))) / (1 - e) || 0), 100 * ((1 - s - e) / (1 - e) || 0), 100 * ((1 - n - e) / (1 - e) || 0), 100 * e ];
}, j.rgb.keyword = function(t) {
    var e = G[t];
    if (e) return e;
    var i, s, n, r = 1 / 0;
    for (var h in D) if (D.hasOwnProperty(h)) {
        var o = D[h], a = (s = t, n = o, Math.pow(s[0] - n[0], 2) + Math.pow(s[1] - n[1], 2) + Math.pow(s[2] - n[2], 2));
        a < r && (r = a, i = h);
    }
    return i;
}, j.keyword.rgb = function(t) {
    return D[t];
}, j.rgb.xyz = function(t) {
    var e = t[0] / 255, i = t[1] / 255, s = t[2] / 255;
    return [ 100 * (.4124 * (e = e > .04045 ? Math.pow((e + .055) / 1.055, 2.4) : e / 12.92) + .3576 * (i = i > .04045 ? Math.pow((i + .055) / 1.055, 2.4) : i / 12.92) + .1805 * (s = s > .04045 ? Math.pow((s + .055) / 1.055, 2.4) : s / 12.92)), 100 * (.2126 * e + .7152 * i + .0722 * s), 100 * (.0193 * e + .1192 * i + .9505 * s) ];
}, j.rgb.lab = function(t) {
    var e = j.rgb.xyz(t), i = e[0], s = e[1], n = e[2];
    return s /= 100, n /= 108.883, i = (i /= 95.047) > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116, 
    [ 116 * (s = s > .008856 ? Math.pow(s, 1 / 3) : 7.787 * s + 16 / 116) - 16, 500 * (i - s), 200 * (s - (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116)) ];
}, j.hsl.rgb = function(t) {
    var e, i, s, n, r, h = t[0] / 360, o = t[1] / 100, a = t[2] / 100;
    if (0 === o) return [ r = 255 * a, r, r ];
    e = 2 * a - (i = a < .5 ? a * (1 + o) : a + o - a * o), n = [ 0, 0, 0 ];
    for (var l = 0; l < 3; l++) (s = h + 1 / 3 * -(l - 1)) < 0 && s++, s > 1 && s--, 
    r = 6 * s < 1 ? e + 6 * (i - e) * s : 2 * s < 1 ? i : 3 * s < 2 ? e + (i - e) * (2 / 3 - s) * 6 : e, 
    n[l] = 255 * r;
    return n;
}, j.hsl.hsv = function(t) {
    var e = t[0], i = t[1] / 100, s = t[2] / 100, n = i, r = Math.max(s, .01);
    return i *= (s *= 2) <= 1 ? s : 2 - s, n *= r <= 1 ? r : 2 - r, [ e, 100 * (0 === s ? 2 * n / (r + n) : 2 * i / (s + i)), 100 * ((s + i) / 2) ];
}, j.hsv.rgb = function(t) {
    var e = t[0] / 60, i = t[1] / 100, s = t[2] / 100, n = Math.floor(e) % 6, r = e - Math.floor(e), h = 255 * s * (1 - i), o = 255 * s * (1 - i * r), a = 255 * s * (1 - i * (1 - r));
    switch (s *= 255, n) {
      case 0:
        return [ s, a, h ];

      case 1:
        return [ o, s, h ];

      case 2:
        return [ h, s, a ];

      case 3:
        return [ h, o, s ];

      case 4:
        return [ a, h, s ];

      case 5:
        return [ s, h, o ];
    }
}, j.hsv.hsl = function(t) {
    var e, i, s, n = t[0], r = t[1] / 100, h = t[2] / 100, o = Math.max(h, .01);
    return s = (2 - r) * h, i = r * o, [ n, 100 * (i = (i /= (e = (2 - r) * o) <= 1 ? e : 2 - e) || 0), 100 * (s /= 2) ];
}, j.hwb.rgb = function(t) {
    var e, i, s, n, r, h, o, a = t[0] / 360, l = t[1] / 100, c = t[2] / 100, u = l + c;
    switch (u > 1 && (l /= u, c /= u), s = 6 * a - (e = Math.floor(6 * a)), 1 & e && (s = 1 - s), 
    n = l + s * ((i = 1 - c) - l), e) {
      default:
      case 6:
      case 0:
        r = i, h = n, o = l;
        break;

      case 1:
        r = n, h = i, o = l;
        break;

      case 2:
        r = l, h = i, o = n;
        break;

      case 3:
        r = l, h = n, o = i;
        break;

      case 4:
        r = n, h = l, o = i;
        break;

      case 5:
        r = i, h = l, o = n;
    }
    return [ 255 * r, 255 * h, 255 * o ];
}, j.cmyk.rgb = function(t) {
    var e = t[0] / 100, i = t[1] / 100, s = t[2] / 100, n = t[3] / 100;
    return [ 255 * (1 - Math.min(1, e * (1 - n) + n)), 255 * (1 - Math.min(1, i * (1 - n) + n)), 255 * (1 - Math.min(1, s * (1 - n) + n)) ];
}, j.xyz.rgb = function(t) {
    var e, i, s, n = t[0] / 100, r = t[1] / 100, h = t[2] / 100;
    return i = -.9689 * n + 1.8758 * r + .0415 * h, s = .0557 * n + -.204 * r + 1.057 * h, 
    e = (e = 3.2406 * n + -1.5372 * r + -.4986 * h) > .0031308 ? 1.055 * Math.pow(e, 1 / 2.4) - .055 : 12.92 * e, 
    i = i > .0031308 ? 1.055 * Math.pow(i, 1 / 2.4) - .055 : 12.92 * i, s = s > .0031308 ? 1.055 * Math.pow(s, 1 / 2.4) - .055 : 12.92 * s, 
    [ 255 * (e = Math.min(Math.max(0, e), 1)), 255 * (i = Math.min(Math.max(0, i), 1)), 255 * (s = Math.min(Math.max(0, s), 1)) ];
}, j.xyz.lab = function(t) {
    var e = t[0], i = t[1], s = t[2];
    return i /= 100, s /= 108.883, e = (e /= 95.047) > .008856 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116, 
    [ 116 * (i = i > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116) - 16, 500 * (e - i), 200 * (i - (s = s > .008856 ? Math.pow(s, 1 / 3) : 7.787 * s + 16 / 116)) ];
}, j.lab.xyz = function(t) {
    var e, i, s, n = t[0];
    e = t[1] / 500 + (i = (n + 16) / 116), s = i - t[2] / 200;
    var r = Math.pow(i, 3), h = Math.pow(e, 3), o = Math.pow(s, 3);
    return i = r > .008856 ? r : (i - 16 / 116) / 7.787, e = h > .008856 ? h : (e - 16 / 116) / 7.787, 
    s = o > .008856 ? o : (s - 16 / 116) / 7.787, [ e *= 95.047, i *= 100, s *= 108.883 ];
}, j.lab.lch = function(t) {
    var e, i = t[0], s = t[1], n = t[2];
    return (e = 360 * Math.atan2(n, s) / 2 / Math.PI) < 0 && (e += 360), [ i, Math.sqrt(s * s + n * n), e ];
}, j.lch.lab = function(t) {
    var e, i = t[0], s = t[1];
    return e = t[2] / 360 * 2 * Math.PI, [ i, s * Math.cos(e), s * Math.sin(e) ];
}, j.rgb.ansi16 = function(t) {
    var e = t[0], i = t[1], s = t[2], n = 1 in arguments ? arguments[1] : j.rgb.hsv(t)[2];
    if (0 === (n = Math.round(n / 50))) return 30;
    var r = 30 + (Math.round(s / 255) << 2 | Math.round(i / 255) << 1 | Math.round(e / 255));
    return 2 === n && (r += 60), r;
}, j.hsv.ansi16 = function(t) {
    return j.rgb.ansi16(j.hsv.rgb(t), t[2]);
}, j.rgb.ansi256 = function(t) {
    var e = t[0], i = t[1], s = t[2];
    return e === i && i === s ? e < 8 ? 16 : e > 248 ? 231 : Math.round((e - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(e / 255 * 5) + 6 * Math.round(i / 255 * 5) + Math.round(s / 255 * 5);
}, j.ansi16.rgb = function(t) {
    var e = t % 10;
    if (0 === e || 7 === e) return t > 50 && (e += 3.5), [ e = e / 10.5 * 255, e, e ];
    var i = .5 * (1 + ~~(t > 50));
    return [ (1 & e) * i * 255, (e >> 1 & 1) * i * 255, (e >> 2 & 1) * i * 255 ];
}, j.ansi256.rgb = function(t) {
    if (t >= 232) {
        var e = 10 * (t - 232) + 8;
        return [ e, e, e ];
    }
    var i;
    return t -= 16, [ Math.floor(t / 36) / 5 * 255, Math.floor((i = t % 36) / 6) / 5 * 255, i % 6 / 5 * 255 ];
}, j.rgb.hex = function(t) {
    var e = (((255 & Math.round(t[0])) << 16) + ((255 & Math.round(t[1])) << 8) + (255 & Math.round(t[2]))).toString(16).toUpperCase();
    return "000000".substring(e.length) + e;
}, j.hex.rgb = function(t) {
    var e = t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!e) return [ 0, 0, 0 ];
    var i = e[0];
    3 === e[0].length && (i = i.split("").map((function(t) {
        return t + t;
    })).join(""));
    var s = parseInt(i, 16);
    return [ s >> 16 & 255, s >> 8 & 255, 255 & s ];
}, j.rgb.hcg = function(t) {
    var e, i = t[0] / 255, s = t[1] / 255, n = t[2] / 255, r = Math.max(Math.max(i, s), n), h = Math.min(Math.min(i, s), n), o = r - h;
    return e = o <= 0 ? 0 : r === i ? (s - n) / o % 6 : r === s ? 2 + (n - i) / o : 4 + (i - s) / o + 4, 
    e /= 6, [ 360 * (e %= 1), 100 * o, 100 * (o < 1 ? h / (1 - o) : 0) ];
}, j.hsl.hcg = function(t) {
    var e = t[1] / 100, i = t[2] / 100, s = 1, n = 0;
    return (s = i < .5 ? 2 * e * i : 2 * e * (1 - i)) < 1 && (n = (i - .5 * s) / (1 - s)), 
    [ t[0], 100 * s, 100 * n ];
}, j.hsv.hcg = function(t) {
    var e = t[1] / 100, i = t[2] / 100, s = e * i, n = 0;
    return s < 1 && (n = (i - s) / (1 - s)), [ t[0], 100 * s, 100 * n ];
}, j.hcg.rgb = function(t) {
    var e = t[0] / 360, i = t[1] / 100, s = t[2] / 100;
    if (0 === i) return [ 255 * s, 255 * s, 255 * s ];
    var n, r = [ 0, 0, 0 ], h = e % 1 * 6, o = h % 1, a = 1 - o;
    switch (Math.floor(h)) {
      case 0:
        r[0] = 1, r[1] = o, r[2] = 0;
        break;

      case 1:
        r[0] = a, r[1] = 1, r[2] = 0;
        break;

      case 2:
        r[0] = 0, r[1] = 1, r[2] = o;
        break;

      case 3:
        r[0] = 0, r[1] = a, r[2] = 1;
        break;

      case 4:
        r[0] = o, r[1] = 0, r[2] = 1;
        break;

      default:
        r[0] = 1, r[1] = 0, r[2] = a;
    }
    return n = (1 - i) * s, [ 255 * (i * r[0] + n), 255 * (i * r[1] + n), 255 * (i * r[2] + n) ];
}, j.hcg.hsv = function(t) {
    var e = t[1] / 100, i = e + t[2] / 100 * (1 - e), s = 0;
    return i > 0 && (s = e / i), [ t[0], 100 * s, 100 * i ];
}, j.hcg.hsl = function(t) {
    var e = t[1] / 100, i = t[2] / 100 * (1 - e) + .5 * e, s = 0;
    return i > 0 && i < .5 ? s = e / (2 * i) : i >= .5 && i < 1 && (s = e / (2 * (1 - i))), 
    [ t[0], 100 * s, 100 * i ];
}, j.hcg.hwb = function(t) {
    var e = t[1] / 100, i = e + t[2] / 100 * (1 - e);
    return [ t[0], 100 * (i - e), 100 * (1 - i) ];
}, j.hwb.hcg = function(t) {
    var e = t[1] / 100, i = 1 - t[2] / 100, s = i - e, n = 0;
    return s < 1 && (n = (i - s) / (1 - s)), [ t[0], 100 * s, 100 * n ];
}, j.apple.rgb = function(t) {
    return [ t[0] / 65535 * 255, t[1] / 65535 * 255, t[2] / 65535 * 255 ];
}, j.rgb.apple = function(t) {
    return [ t[0] / 255 * 65535, t[1] / 255 * 65535, t[2] / 255 * 65535 ];
}, j.gray.rgb = function(t) {
    return [ t[0] / 100 * 255, t[0] / 100 * 255, t[0] / 100 * 255 ];
}, j.gray.hsl = j.gray.hsv = function(t) {
    return [ 0, 0, t[0] ];
}, j.gray.hwb = function(t) {
    return [ 0, 100, t[0] ];
}, j.gray.cmyk = function(t) {
    return [ 0, 0, 0, t[0] ];
}, j.gray.lab = function(t) {
    return [ t[0], 0, 0 ];
}, j.gray.hex = function(t) {
    var e = 255 & Math.round(t[0] / 100 * 255), i = ((e << 16) + (e << 8) + e).toString(16).toUpperCase();
    return "000000".substring(i.length) + i;
}, j.rgb.gray = function(t) {
    return [ (t[0] + t[1] + t[2]) / 3 / 255 * 100 ];
};

var V = H.exports, W = V;

function q(t) {
    var e = function() {
        for (var t = {}, e = Object.keys(W), i = e.length, s = 0; s < i; s++) t[e[s]] = {
            distance: -1,
            parent: null
        };
        return t;
    }(), i = [ t ];
    for (e[t].distance = 0; i.length; ) for (var s = i.pop(), n = Object.keys(W[s]), r = n.length, h = 0; h < r; h++) {
        var o = n[h], a = e[o];
        -1 === a.distance && (a.distance = e[s].distance + 1, a.parent = s, i.unshift(o));
    }
    return e;
}

function $(t, e) {
    return function(i) {
        return e(t(i));
    };
}

function Y(t, e) {
    for (var i = [ e[t].parent, t ], s = W[e[t].parent][t], n = e[t].parent; e[n].parent; ) i.unshift(e[n].parent), 
    s = $(W[e[n].parent][n], s), n = e[n].parent;
    return s.conversion = i, s;
}

var X = V, J = function(t) {
    for (var e = q(t), i = {}, s = Object.keys(e), n = s.length, r = 0; r < n; r++) {
        var h = s[r];
        null !== e[h].parent && (i[h] = Y(h, e));
    }
    return i;
}, Z = {};

Object.keys(X).forEach((function(t) {
    Z[t] = {}, Object.defineProperty(Z[t], "channels", {
        value: X[t].channels
    }), Object.defineProperty(Z[t], "labels", {
        value: X[t].labels
    });
    var e = J(t);
    Object.keys(e).forEach((function(i) {
        var s = e[i];
        Z[t][i] = function(t) {
            var e = function(e) {
                if (null == e) return e;
                arguments.length > 1 && (e = Array.prototype.slice.call(arguments));
                var i = t(e);
                if ("object" == typeof i) for (var s = i.length, n = 0; n < s; n++) i[n] = Math.round(i[n]);
                return i;
            };
            return "conversion" in t && (e.conversion = t.conversion), e;
        }(s), Z[t][i].raw = function(t) {
            var e = function(e) {
                return null == e ? e : (arguments.length > 1 && (e = Array.prototype.slice.call(arguments)), 
                t(e));
            };
            return "conversion" in t && (e.conversion = t.conversion), e;
        }(s);
    }));
}));

var K = P, Q = Z, tt = [].slice, et = [ "keyword", "gray", "hex" ], it = {};

Object.keys(Q).forEach((function(t) {
    it[tt.call(Q[t].labels).sort().join("")] = t;
}));

var st = {};

function nt(t, e) {
    if (!(this instanceof nt)) return new nt(t, e);
    if (e && e in et && (e = null), e && !(e in Q)) throw new Error("Unknown model: " + e);
    var i, s;
    if (null == t) this.model = "rgb", this.color = [ 0, 0, 0 ], this.valpha = 1; else if (t instanceof nt) this.model = t.model, 
    this.color = t.color.slice(), this.valpha = t.valpha; else if ("string" == typeof t) {
        var n = K.get(t);
        if (null === n) throw new Error("Unable to parse color from string: " + t);
        this.model = n.model, s = Q[this.model].channels, this.color = n.value.slice(0, s), 
        this.valpha = "number" == typeof n.value[s] ? n.value[s] : 1;
    } else if (t.length) {
        this.model = e || "rgb", s = Q[this.model].channels;
        var r = tt.call(t, 0, s);
        this.color = ot(r, s), this.valpha = "number" == typeof t[s] ? t[s] : 1;
    } else if ("number" == typeof t) t &= 16777215, this.model = "rgb", this.color = [ t >> 16 & 255, t >> 8 & 255, 255 & t ], 
    this.valpha = 1; else {
        this.valpha = 1;
        var h = Object.keys(t);
        "alpha" in t && (h.splice(h.indexOf("alpha"), 1), this.valpha = "number" == typeof t.alpha ? t.alpha : 0);
        var o = h.sort().join("");
        if (!(o in it)) throw new Error("Unable to parse color from object: " + JSON.stringify(t));
        this.model = it[o];
        var a = Q[this.model].labels, l = [];
        for (i = 0; i < a.length; i++) l.push(t[a[i]]);
        this.color = ot(l);
    }
    if (st[this.model]) for (s = Q[this.model].channels, i = 0; i < s; i++) {
        var c = st[this.model][i];
        c && (this.color[i] = c(this.color[i]));
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}

function rt(t, e, i) {
    return (t = Array.isArray(t) ? t : [ t ]).forEach((function(t) {
        (st[t] || (st[t] = []))[e] = i;
    })), t = t[0], function(s) {
        var n;
        return arguments.length ? (i && (s = i(s)), (n = this[t]()).color[e] = s, n) : (n = this[t]().color[e], 
        i && (n = i(n)), n);
    };
}

function ht(t) {
    return function(e) {
        return Math.max(0, Math.min(t, e));
    };
}

function ot(t, e) {
    for (var i = 0; i < e; i++) "number" != typeof t[i] && (t[i] = 0);
    return t;
}

nt.prototype = {
    toString: function() {
        return this.string();
    },
    toJSON: function() {
        return this[this.model]();
    },
    string: function(t) {
        var e = this.model in K.to ? this : this.rgb(), i = 1 === (e = e.round("number" == typeof t ? t : 1)).valpha ? e.color : e.color.concat(this.valpha);
        return K.to[e.model](i);
    },
    percentString: function(t) {
        var e = this.rgb().round("number" == typeof t ? t : 1), i = 1 === e.valpha ? e.color : e.color.concat(this.valpha);
        return K.to.rgb.percent(i);
    },
    array: function() {
        return 1 === this.valpha ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function() {
        for (var t = {}, e = Q[this.model].channels, i = Q[this.model].labels, s = 0; s < e; s++) t[i[s]] = this.color[s];
        return 1 !== this.valpha && (t.alpha = this.valpha), t;
    },
    unitArray: function() {
        var t = this.rgb().color;
        return t[0] /= 255, t[1] /= 255, t[2] /= 255, 1 !== this.valpha && t.push(this.valpha), 
        t;
    },
    unitObject: function() {
        var t = this.rgb().object();
        return t.r /= 255, t.g /= 255, t.b /= 255, 1 !== this.valpha && (t.alpha = this.valpha), 
        t;
    },
    round: function(t) {
        return t = Math.max(t || 0, 0), new nt(this.color.map(function(t) {
            return function(e) {
                return function(t, e) {
                    return Number(t.toFixed(e));
                }(e, t);
            };
        }(t)).concat(this.valpha), this.model);
    },
    alpha: function(t) {
        return arguments.length ? new nt(this.color.concat(Math.max(0, Math.min(1, t))), this.model) : this.valpha;
    },
    red: rt("rgb", 0, ht(255)),
    green: rt("rgb", 1, ht(255)),
    blue: rt("rgb", 2, ht(255)),
    hue: rt([ "hsl", "hsv", "hsl", "hwb", "hcg" ], 0, (function(t) {
        return (t % 360 + 360) % 360;
    })),
    saturationl: rt("hsl", 1, ht(100)),
    lightness: rt("hsl", 2, ht(100)),
    saturationv: rt("hsv", 1, ht(100)),
    value: rt("hsv", 2, ht(100)),
    chroma: rt("hcg", 1, ht(100)),
    gray: rt("hcg", 2, ht(100)),
    white: rt("hwb", 1, ht(100)),
    wblack: rt("hwb", 2, ht(100)),
    cyan: rt("cmyk", 0, ht(100)),
    magenta: rt("cmyk", 1, ht(100)),
    yellow: rt("cmyk", 2, ht(100)),
    black: rt("cmyk", 3, ht(100)),
    x: rt("xyz", 0, ht(100)),
    y: rt("xyz", 1, ht(100)),
    z: rt("xyz", 2, ht(100)),
    l: rt("lab", 0, ht(100)),
    a: rt("lab", 1),
    b: rt("lab", 2),
    keyword: function(t) {
        return arguments.length ? new nt(t) : Q[this.model].keyword(this.color);
    },
    hex: function(t) {
        return arguments.length ? new nt(t) : K.to.hex(this.rgb().round().color);
    },
    rgbNumber: function() {
        var t = this.rgb().color;
        return (255 & t[0]) << 16 | (255 & t[1]) << 8 | 255 & t[2];
    },
    luminosity: function() {
        for (var t = this.rgb().color, e = [], i = 0; i < t.length; i++) {
            var s = t[i] / 255;
            e[i] = s <= .03928 ? s / 12.92 : Math.pow((s + .055) / 1.055, 2.4);
        }
        return .2126 * e[0] + .7152 * e[1] + .0722 * e[2];
    },
    contrast: function(t) {
        var e = this.luminosity(), i = t.luminosity();
        return e > i ? (e + .05) / (i + .05) : (i + .05) / (e + .05);
    },
    level: function(t) {
        var e = this.contrast(t);
        return e >= 7.1 ? "AAA" : e >= 4.5 ? "AA" : "";
    },
    isDark: function() {
        var t = this.rgb().color;
        return (299 * t[0] + 587 * t[1] + 114 * t[2]) / 1e3 < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    negate: function() {
        for (var t = this.rgb(), e = 0; e < 3; e++) t.color[e] = 255 - t.color[e];
        return t;
    },
    lighten: function(t) {
        var e = this.hsl();
        return e.color[2] += e.color[2] * t, e;
    },
    darken: function(t) {
        var e = this.hsl();
        return e.color[2] -= e.color[2] * t, e;
    },
    saturate: function(t) {
        var e = this.hsl();
        return e.color[1] += e.color[1] * t, e;
    },
    desaturate: function(t) {
        var e = this.hsl();
        return e.color[1] -= e.color[1] * t, e;
    },
    whiten: function(t) {
        var e = this.hwb();
        return e.color[1] += e.color[1] * t, e;
    },
    blacken: function(t) {
        var e = this.hwb();
        return e.color[2] += e.color[2] * t, e;
    },
    grayscale: function() {
        var t = this.rgb().color, e = .3 * t[0] + .59 * t[1] + .11 * t[2];
        return nt.rgb(e, e, e);
    },
    fade: function(t) {
        return this.alpha(this.valpha - this.valpha * t);
    },
    opaquer: function(t) {
        return this.alpha(this.valpha + this.valpha * t);
    },
    rotate: function(t) {
        var e = this.hsl(), i = e.color[0];
        return i = (i = (i + t) % 360) < 0 ? 360 + i : i, e.color[0] = i, e;
    },
    mix: function(t, e) {
        if (!t || !t.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof t);
        var i = t.rgb(), s = this.rgb(), n = void 0 === e ? .5 : e, r = 2 * n - 1, h = i.alpha() - s.alpha(), o = ((r * h == -1 ? r : (r + h) / (1 + r * h)) + 1) / 2, a = 1 - o;
        return nt.rgb(o * i.red() + a * s.red(), o * i.green() + a * s.green(), o * i.blue() + a * s.blue(), i.alpha() * n + s.alpha() * (1 - n));
    }
}, Object.keys(Q).forEach((function(t) {
    if (-1 === et.indexOf(t)) {
        var e = Q[t].channels;
        nt.prototype[t] = function() {
            if (this.model === t) return new nt(this);
            if (arguments.length) return new nt(arguments, t);
            var i, s = "number" == typeof arguments[e] ? e : this.valpha;
            return new nt((i = Q[this.model][t].raw(this.color), Array.isArray(i) ? i : [ i ]).concat(s), t);
        }, nt[t] = function(i) {
            return "number" == typeof i && (i = ot(tt.call(arguments), e)), new nt(i, t);
        };
    }
}));

var at = _(nt);

const lt = "function" == typeof Object.assign, ct = [];

function ut(t) {
    if (lt) Object.assign.apply(Object, arguments); else for (let e = 1; e < arguments.length; e++) {
        const i = arguments[e];
        for (const e in i) t[e] = i[e];
    }
    return t;
}

function ft(t) {
    return null == t;
}

function dt(t) {
    return "number" == typeof t && !isNaN(t);
}

const mt = [];

function gt(t, e) {
    const i = e._get2DExtentAtRes(e.getGLRes()), s = i.getWidth(), n = i.getHeight(), r = t;
    l.identity(r);
    const h = c.copy(ct, e.cameraLookAt);
    return h[2] = 0, l.translate(r, r, h), l.scale(r, r, c.set(mt, s, n, 1)), r;
}

function pt(t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
}

function wt(t) {
    for (let e = 1; e < arguments.length; e++) {
        const i = arguments[e];
        if (i) for (let e = 0, s = i.length; e < s; e++) t.push(i[e]);
    }
    return t.length;
}

const vt = {};

function _t(t, e) {
    if (!Array.isArray(e)) {
        const t = e;
        e = vt[t] = vt[t] || at(e).array();
    }
    for (let i = 0; i < e.length; i++) t[i] = e[i];
    return 3 === e.length && (t[3] = 1), t;
}

function yt(t, e) {
    if (Array.isArray(e)) for (let i = 0; i < e.length; i++) t[i] = 255 * e[i]; else {
        const i = e;
        e = vt[i] = vt[i] || at(e).array();
        for (let i = 0; i < e.length; i++) t[i] = e[i];
    }
    return 3 === t.length && t.push(255), t;
}

function bt(t, i, s = 0) {
    if (!(t && i instanceof e)) return null;
    const n = t.coordinateToPointAtRes(i, t.getGLRes());
    return [ n.x, n.y, s ];
}

const xt = [ 0, 0 ], Mt = [ 0, 0, 0 ];

let St;

class Ct {
    static getUniformDeclares() {
        const t = [], e = [];
        return e.push({
            name: "shadow_lightProjViewModelMatrix",
            type: "function",
            fn: function(e, i) {
                const s = i.shadow_lightProjViewMatrix, n = i.modelMatrix;
                return l.multiply(t, s, n);
            }
        }), e;
    }
    constructor(t, e) {
        this.renderer = new a.Renderer(t), this.i = .3, this.h = e, this.o();
    }
    resize() {
        const t = this.canvas;
        t.width = this.h.getRenderer().canvas.width, t.height = this.h.getRenderer().canvas.height;
    }
    o() {
        const t = (this.h.u() || {}).shadow || {}, e = this.m(), i = this.getDefines();
        this.p = new a.ShadowPass(this.renderer, {
            width: e,
            height: e,
            blurOffset: t.blurOffset,
            defines: i
        }), this.v = new a.ShadowDisplayShader(i), this._();
    }
    m() {
        let t = 2048;
        const e = ((this.h.u() || {}).shadow || {}).quality;
        return "medium" === e ? t = 1024 : "low" === e && (t = 512), t;
    }
    getDefines() {
        return {
            "HAS_SHADOWING": 1,
            "PACK_FLOAT": 1,
            "USE_ESM": 1
        };
    }
    render(t, e, i, s, n, r, h, o, a, u) {
        this.M();
        const f = this.h.getMap(), d = this.m();
        let m, g;
        if (u || d !== this.p.width || this.S(f, h, !!t)) {
            d !== this.p.width && this.p.resize(d, d), this.C = this.C || [], this.k = this.k || [];
            const s = l.multiply(this.C, e, i), n = c.normalize(this.k, r);
            St || (St = f.getContainerExtent());
            let o = f.height;
            f.getPitch() > 62 && (o = f._getVisualHeight(62));
            const a = St.set(0, f.height - o, f.width, f.height).convertTo((t => f._containerPointToPointAtRes(t, f.getGLRes()))).toArray();
            t && h.addMesh(this.T);
            const u = a.map((t => [ t.x, t.y, 0, 1 ])), {lightProjViewMatrix: p, shadowMap: w, blurFBO: v} = this.p.render(h, {
                cameraProjViewMatrix: s,
                lightDir: n,
                farPlane: u,
                cameraLookAt: f.cameraLookAt
            });
            m = this.A = p, g = this.O = w, this.I = v, this.L = h.getMeshes().reduce(((t, e) => (e.castShadow && e.geometry && (t[e.uuid] = {
                v0: e.version,
                v1: e.geometry.version
            }), t)), {}), this.R = {
                count: h.getMeshes().length - +!!t,
                displayShadow: !!t
            }, this.F = !0;
        } else m = this.A, g = this.O, this.F = !1;
        this.P = e, this.H = i, ft(n) && (n = 1), t && h.getMeshes().length && this.displayShadow(s, n, o, a);
        return {
            "shadow_lightProjViewMatrix": m,
            "shadow_shadowMap": g,
            "shadow_opacity": n,
            "shadow_color": s || Mt,
            "esm_shadow_threshold": this.i
        };
    }
    displayShadow(t, e, i, s) {
        const n = this.A, r = this.T, h = this.D || [], o = this.h.getRenderer().canvas, a = this.G = this.G || [];
        a[0] = o.width, a[1] = o.height, this.renderer.render(this.v, {
            "halton": i || xt,
            "globalTexSize": a,
            "projMatrix": this.P,
            "viewMatrix": this.H,
            "shadow_lightProjViewModelMatrix": l.multiply(h, n, r.localTransform),
            "shadow_shadowMap": this.O,
            "esm_shadow_threshold": this.i,
            "shadow_opacity": e,
            "color": t || Mt
        }, this.N, s);
    }
    dispose() {
        this.p.dispose(), this.v.dispose(), this.T && (this.T.geometry.dispose(), this.T.dispose()), 
        delete this.renderer;
    }
    isUpdated() {
        return !1 !== this.F;
    }
    S(t, e, i) {
        if (!this.L) return !0;
        const s = this.R;
        if (e.getMeshes().length !== s.count || i !== s.displayShadow) return !0;
        const n = e.getMeshes();
        for (let t = 0; t < n.length; t++) {
            const e = this.L[n[t].uuid];
            if (n[t].castShadow && (n[t].hasSkinAnimation() || !e || e.v0 !== n[t].version || e.v1 !== n[t].geometry.version)) return !0;
        }
        return !1;
    }
    _() {
        const t = new a.Plane;
        t.generateBuffers(this.renderer.regl), this.T = new a.Mesh(t), this.N = new a.Scene([ this.T ]);
    }
    M() {
        const t = this.h.getMap(), e = gt(this.T.localTransform, t);
        this.T.setLocalTransform(e);
    }
}

const kt = [ 0, 0 ], Tt = new t.Coordinate(0, 0), At = new t.Coordinate(0, 0), Ot = [], It = [], Lt = [];

function Et(t, e, i, s) {
    const n = t.getGLRes(), r = t.distanceToPointAtRes(e, e, n, i ? Tt : null, At);
    return s ? r.y : r.x;
}

const {getIBLResOnCanvas: Rt, logoutIBLResOnCanvas: Ft, getPBRUniforms: Pt, loginIBLResOnCanvas: Ht} = a.pbr.PBRUtils, Dt = [ 0, 0 ], Gt = [ 1, 1 ], Nt = [], jt = [], zt = [], Bt = [], Ut = [];

class Vt {
    static getGroundTransform(t, e) {
        return gt(t, e);
    }
    constructor(t, e) {
        this.j = t, this.renderer = new a.Renderer(t), this.h = e, this.B = new a.ResourceLoader, 
        this.U = (...t) => this.V.call(this, ...t), this.o();
        const i = this.getMap().getRenderer().canvas;
        Ht(i, t, this.getMap());
    }
    needToRedraw() {
        const t = this.W();
        return t && (t[0] || t[1]);
    }
    getMap() {
        return this.h && this.h.getMap();
    }
    getSymbol() {
        const t = this.h.getGroundConfig();
        return t && t.symbol;
    }
    isEnable() {
        const t = this.h.getGroundConfig();
        return t && t.enable;
    }
    paint(t) {
        if (!this.isEnable()) return !1;
        const e = this.q();
        if (this.$(t) && e === this.Y) return !1;
        const i = this.X(t);
        i && this.T.setDefines(i), this.T.material !== this.material && this.T.setMaterial(this.material);
        const s = this.h.getGroundConfig();
        (s && s.symbol).ssr ? this.T.ssr = 1 : this.T.ssr = 0, this.M();
        const n = this.J(t);
        n.offsetFactor = t.offsetFactor, n.offsetUnits = t.offsetUnits;
        const r = t && t.renderTarget && t.renderTarget.fbo;
        return e === this.Y ? (this.renderer.render(e, n, this.N, r), this.h.getRenderer().setCanvasUpdated(), 
        !0) : (e.filter = t.sceneFilter, this.renderer.render(e, n, this.N, r), this.h.getRenderer().setCanvasUpdated(), 
        !0);
    }
    $(t) {
        return !(!this.h.getRenderer().isEnableSSR || !this.h.getRenderer().isEnableSSR()) && !(!t || !t.ssr);
    }
    update() {
        const t = this.h.getGroundConfig();
        if (!t) return;
        const e = t && t.symbol, i = t.urlModifier;
        if (e) {
            this.Z = this.K(e.polygonFill || [ 1, 1, 1, 1 ]), this.tt = void 0 === e.polygonOpacity ? 1 : e.polygonOpacity;
            const t = e.polygonPatternFile;
            if (t) {
                if (!this.et || this.et._pattern_src !== t) {
                    const e = new Image;
                    e.onload = () => {
                        this.et && this.et.destroy(), this.et = this.it(e), this.et._pattern_src = t, this.setToRedraw();
                    }, e.src = i && i(t) || t;
                }
            } else this.et && (this.et.destroy(), delete this.et);
        } else this.Z = [ 1, 1, 1, 1 ], this.tt = 1, this.et && (this.et.destroy(), delete this.et);
        this.st();
    }
    setToRedraw() {
        const t = this.h.getRenderer();
        t && t.setToRedraw();
    }
    dispose() {
        this.material && (this.material.dispose(), delete this.material), this.T && (this.T.geometry.dispose(), 
        this.T.material && this.T.material.dispose(), this.T.dispose(), delete this.T), 
        this.et && (this.et.destroy(), delete this.et), this.Y && (this.Y.dispose(), delete this.Y), 
        this.nt && (this.nt.dispose(), delete this.nt), this.rt();
    }
    q() {
        const t = this.h.getGroundConfig();
        if (!t || !t.renderPlugin) return this.Y;
        const e = t.renderPlugin.type;
        if ("lit" === e) return this.nt;
        if ("fill" === e) return this.Y;
        throw new Error("unsupported render plugin of " + e + " for layer ground");
    }
    J(t) {
        const e = this.ht(t);
        e.polygonFill = this.Z, e.polygonOpacity = this.tt;
        return this.q() === this.Y && this.et && (e.polygonPatternFile = this.et), e;
    }
    ht(t) {
        let e;
        if ("lit" === this.h.getGroundConfig().renderPlugin.type) {
            const i = this.getMap().getRenderer().canvas, {iblTexes: s, dfgLUT: n} = Rt(i);
            e = Pt(this.getMap(), s, n, t && t.ssr, t && t.jitter);
        } else {
            e = {
                projViewMatrix: this.getMap().projViewMatrix
            };
        }
        return this.ot(e, t), e;
    }
    ot(t, e) {
        const i = e && e.includes;
        if (i) for (const s in i) i[s] && e[s].renderUniforms && ut(t, e[s].renderUniforms);
    }
    rt() {
        const t = this.getMap().getRenderer().canvas;
        Ft(t, this.getMap());
    }
    o() {
        const t = this.lt(), e = Ct.getUniformDeclares(), i = [];
        e.push({
            name: "projViewModelMatrix",
            type: "function",
            fn: function(t, e) {
                return l.multiply(i, e.projViewMatrix, e.modelMatrix);
            }
        }), this.Y = new a.MeshShader({
            vert: "attribute vec3 aPosition;\nuniform mat4 projViewModelMatrix;\nuniform mat4 modelMatrix;\n#ifdef HAS_PATTERN\n    attribute vec2 aTexCoord;\n    uniform vec2 uvScale;\n    uniform vec2 uvOffset;\n    varying vec2 vTexCoord;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n    #include <vsm_shadow_vert>\n#endif\nvoid main () {\n    #ifdef HAS_PATTERN\n        vTexCoord = aTexCoord * uvScale + uvOffset;\n    #endif\n    vec3 position = vec3(aPosition);\n    gl_Position = projViewModelMatrix * vec4(position, 1.0);\n    #if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n        shadow_computeShadowPars(vec4(position, 1.0));\n    #endif\n}",
            frag: "precision mediump float;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n    #include <vsm_shadow_frag>\n#endif\n#ifdef HAS_PATTERN\n    uniform sampler2D polygonPatternFile;\n    varying vec2 vTexCoord;\n#endif\nuniform vec4 polygonFill;\nuniform float polygonOpacity;\nvoid main() {\n    #ifdef HAS_PATTERN\n        vec4 color = texture2D(polygonPatternFile, vTexCoord);\n    #else\n        vec4 color = polygonFill;\n    #endif\n    gl_FragColor = color * polygonOpacity;\n    #if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n        float shadowCoeff = shadow_computeShadow();\n        gl_FragColor.rgb = shadow_blend(gl_FragColor.rgb, shadowCoeff);\n    #endif\n}",
            uniforms: e,
            extraCommandProps: t
        });
        const s = Ct.getUniformDeclares();
        s.push(...a.SsrPass.getUniformDeclares()), this.nt = new a.pbr.StandardShader({
            uniforms: s,
            extraCommandProps: t
        }), this._(), this.update();
    }
    lt() {
        const t = [ 0, 1 ], e = this.h.getRenderer().canvas;
        return {
            viewport: {
                x: 0,
                y: 0,
                width: () => e.width,
                height: () => e.height
            },
            cull: {
                enable: !0
            },
            depth: {
                enable: !0,
                mask: () => {
                    const t = this.h.getGroundConfig();
                    return t.depth || void 0 === t.depth;
                },
                range: () => {
                    const e = this.h.getGroundConfig(), i = e && e.renderPlugin.sceneConfig;
                    return i && i.depthRange || t;
                },
                func: "<="
            },
            blend: {
                enable: !0,
                func: {
                    src: "src alpha",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: {
                    factor: (t, e) => e.offsetFactor,
                    units: (t, e) => e.offsetUnits
                }
            }
        };
    }
    ct() {
        const t = this.getMap().getLightManager();
        return !!(t && t.getAmbientResource());
    }
    _() {
        const t = new a.Plane;
        t.data.aTexCoord = new Uint8Array([ 0, 0, 1, 0, 0, 1, 1, 1 ]), t.createTangent(), 
        t.generateBuffers(this.renderer.regl), this.T = new a.Mesh(t, null, {
            castShadow: !1
        });
        const e = this.nt.getGeometryDefines(t);
        this.T.setDefines(e), this.N = new a.Scene([ this.T ]);
    }
    M() {
        const t = this.getMap(), e = Vt.getGroundTransform(this.T.localTransform, t);
        this.T.setLocalTransform(e);
        const i = t.getGLRes(), s = t._get2DExtentAtRes(i), n = s.getWidth(), r = s.getHeight(), h = t.cameraLookAt, o = h[0] - n, a = h[1] - r, l = this.et ? this.et.width / this.et.height : 1, c = this.getSymbol(), f = this.material ? this.material.get("textureOrigin") : c.polygonPatternFileOrigin, d = !!(this.material ? this.material.get("uvOffsetInMeter") : c.uvOffsetInMeter), m = (this.material ? this.material.get("uvOffset") : c.uvOffset) || Dt, g = this.material && this.material.get("uvScale") || Gt, p = this.material ? this.material.get("textureWidth") : c.polygonPatternFileWidth, w = this.material ? p * (g[1] / g[0]) : c.polygonPatternFileHeight, v = this.W(), [_, y, b, x, M] = function(t, e, i, s, n, r, h, o, a, l, c) {
            const f = t.getGLRes();
            s && (Tt.set(s[0], s[1]), t.coordToPointAtRes(Tt, f, At), e -= At.x, i -= At.y);
            const d = s ? Tt : null;
            l = u.copy(It, l);
            const m = !a && l || kt;
            let g = a && l || kt;
            g = u.copy(Ot, g), g[0] && (g[0] = Et(t, g[0], d)), g[1] && (g[1] = Et(t, g[1], d, 1));
            let p = .5;
            n && (p = Et(t, n, d));
            let w = p / h;
            if (r && (w = Et(t, r, d, 1)), c && (c[0] || c[1])) {
                const e = performance.now() / 1e3;
                let i = c[0], s = c[1];
                a && (i = -Et(t, c[0], d), s = -Et(t, c[1], d, 1)), c[0] && (a ? g[0] = e * i : m[0] = e * i), 
                c[1] && (a ? g[1] = e * s : m[1] = e * s);
            }
            const v = (e + g[0]) / (p / o[0]), _ = (i - g[1]) / (w / o[1]);
            return Lt[0] = p / o[0], Lt[1] = w / o[1], Lt[2] = v, Lt[3] = _, Lt[4] = m, Lt;
        }(t, o, a, f, p, w, l, g, d, m, v), S = 2 * s.getWidth() / _, C = 2 * s.getHeight() / y;
        if (!this.material) return this.T.setUniform("uvScale", u.set(Nt, S, C)), void this.T.setUniform("uvOffset", u.set(jt, b % 1 + M[0], x % 1 + M[1]));
        this.T.setUniform("uvScale", u.set(Ut, S, C)), this.T.setUniform("uvOffset", u.set(zt, b % 1 + M[0], x % 1 + M[1])), 
        this.T.setUniform("uvOrigin", u.set(Bt, b - b % 1, x - x % 1)), this.T.setUniform("uvRotation", 0);
    }
    X(t) {
        let e = !1;
        const i = this.T.defines, s = this.h.u && this.h.u(), n = this.h.getGroundConfig();
        function r(t, s) {
            t ? i[s] || (i[s] = 1, e = !0) : i[s] && (delete i[s], e = !0);
        }
        r(this.ct(), "HAS_IBL_LIGHTING");
        r(t && t.ssr && n && n.symbol && n.symbol.ssr, "HAS_SSR");
        const h = t && s && s.shadow && s.shadow.enable;
        r(h, "HAS_SHADOWING"), r(h, "USE_ESM");
        return r(!!this.et, "HAS_PATTERN"), e ? i : null;
    }
    st() {
        const t = this.getSymbol() && this.getSymbol().material;
        if (!t) return;
        const e = {};
        let i = !1;
        const s = this.h.getGroundConfig();
        this.B.setURLModifier(s.urlModifier);
        for (const s in t) if (pt(t, s)) if (s.indexOf("Texture") > 0) {
            let n = t[s];
            if (!n) continue;
            n = "string" == typeof n ? {
                url: n,
                wrap: "repeat"
            } : n, n.flipY = !0, n.min = "linear mipmap linear", n.mag = "linear", n.flipY = !0, 
            e[s] = new a.Texture2D(n, this.B), i = !0;
        } else e[s] = t[s];
        this.material ? (this.ut = new a.pbr.StandardMaterial(e), this.ut.isReady() ? this.V() : this.ut.once("complete", this.U)) : (this.material = new a.pbr.StandardMaterial(e), 
        this.material.once("complete", this.U, this)), i || this.V();
    }
    V() {
        this.ut && (this.material.dispose(), this.material = this.ut, delete this.ut), this.setToRedraw(!0);
    }
    it(t) {
        t = a.Util.resizeToPowerOfTwo(t);
        const e = this.j, i = {
            width: t.width,
            height: t.height,
            data: t,
            mag: "linear",
            min: "linear mipmap linear",
            flipY: !0,
            wrap: "repeat"
        };
        return e.texture(i);
    }
    K(t) {
        return _t([], t);
    }
    W() {
        return this.material && this.material.get("uvOffsetAnim");
    }
    getRenderMeshes() {
        return this.N.getMeshes();
    }
}

const {createIBLTextures: Wt, disposeIBLTextures: qt} = a.pbr.PBRUtils, $t = [ 0, 0, 0 ], Yt = [], Xt = [];

class Jt {
    constructor(t, e) {
        this.ft = 4, this.j = t, this.renderer = new a.Renderer(t), this.h = e, this.o(), 
        this.dt();
    }
    paint(t) {
        if (!this.isEnable() || !this.gt) return;
        const e = this.J(t), i = t && t.renderTarget && t.renderTarget.fbo;
        this.renderer.render(this.wt, e, null, i);
    }
    update() {
        const t = this.getMap();
        if (!t || !this.isEnable()) return;
        const e = t.getLightManager(), i = e && e.getAmbientResource();
        i !== this.gt && this.vt && (qt(this.vt), delete this.vt), this.gt = i, this.dt();
    }
    dispose() {
        this.wt.dispose(), qt(this.vt), delete this.wt, delete this.vt, delete this.gt;
    }
    getMap() {
        return this.h.getMap();
    }
    dt() {
        if (!this.gt) return;
        const t = this.h.u().environment || {};
        this.wt.setMode(t.toneMapping, t.mode ? 1 : 0);
    }
    isEnable() {
        const t = this.h.u();
        return this.ct() && t && t.environment && t.environment.enable;
    }
    ct() {
        const t = this.getMap().getLightManager();
        return !!(t && t.getAmbientResource());
    }
    J() {
        const t = this.getMap(), e = this.getMap().getLightManager(), i = e && e.getAmbientLight();
        let s = this.vt;
        s || (s = this.vt = Wt(this.j, t));
        const n = this.h.getRenderer().canvas, r = this.h.u().environment || {}, h = r.level || 0, o = s.prefilterMap.width, a = this._t = this._t || [], l = i && i.hsv || $t, u = r.brightness || 0, d = r.intensity || 1;
        return c.copy(Yt, l), u && (Yt[2] += u), Xt[0] = n.width, Xt[1] = n.height, {
            "cubeMap": s.prefilterMap,
            "bias": h,
            "size": o / Math.pow(2, Math.max(0, h - 1)),
            "environmentExposure": dt(i && i.exposure) ? i.exposure : 1,
            "backgroundIntensity": d,
            "diffuseSPH": s.sh,
            "viewMatrix": t.viewMatrix,
            "projMatrix": t.projMatrix,
            "resolution": Xt,
            "hsv": Yt,
            "transformMatrix": f.fromRotation(a, i && Math.PI / 180 * -i.orientation || 0)
        };
    }
    o() {
        const t = this.getMap();
        if (t.on("updatelights", this.update, this), this.wt = new a.SkyboxShader, t.options.lights) {
            const t = this.getMap().getLightManager().getAmbientResource();
            this.gt = t;
        }
    }
}

const Zt = [], Kt = [ .03, .03, .03 ], Qt = [], te = [], ee = [], ie = [ 1, 1, 1 ], se = [ -1200, -1200, 0 ], ne = [ 1200, 1200, 1e3 ], re = {
    min: [],
    max: []
}, he = l.fromRotationTranslation([], d.fromEuler([], 90, 0, 0), [ 0, 0, 0 ]);

class oe {
    constructor(t, e) {
        this.j = t, this.renderer = new a.Renderer(t), this.h = e, this.yt = new ae, this.o();
    }
    getMap() {
        return this.h && this.h.getMap();
    }
    o() {
        const t = this.h.getRenderer().canvas, e = {
            x: 0,
            y: 0,
            width: () => t.width,
            height: () => t.height
        };
        this.wt = new a.MeshShader({
            vert: "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform vec3 cameraPosition;\nuniform float top;\nuniform float bottom;\nuniform float time;\nvarying vec2 vTexCoord;\n#include <get_output>\nfloat angle(float x, float y){\n    return atan(y, x);\n}\nvec2 getFoot(vec2 camera, vec2 normal, vec2 pos) {\n    vec2 position = vec2(0.0, 0.0);\n    float distanceLen = distance(pos, normal);\n    float a = angle(camera.x - normal.x, camera.y - normal.y);\n    pos.x > normal.x ? a -= 0.785 : a += 0.785;\n    position.x = cos(a) * distanceLen;\n    position.y = sin(a) * distanceLen;\n    return position + normal;\n    return position;\n}\nvoid main()\n{\n    vec4 localPosition = getPosition(aPosition);\n    mat4 localPositionMatrix = getPositionMatrix();\n    vec2 foot = getFoot(vec2(cameraPosition.x, cameraPosition.z), vec2(aNormal.x, aNormal.z), vec2(localPosition.x, localPosition.z));\n    float height = top - bottom;\n    float y = aNormal.y - bottom - height * time;\n    y = y + (y < 0.0 ? height : 0.0);\n    float ratio = (1.0 - y / height) * (1.0 - y / height);\n    y = height * (1.0 - ratio);\n    y += bottom;\n    y += aPosition.y - aNormal.y;\n    localPosition = vec4( foot.x, y, foot.y , 1.0);\n    gl_Position = projMatrix * modelViewMatrix * localPositionMatrix * localPosition;\n    vTexCoord = aTexCoord;\n}",
            frag: "precision mediump float;\nvarying vec2 vTexCoord;\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D rainMap;\nvoid main() {\n    vec4 rainColor = texture2D(rainMap, vTexCoord);\n    vec4 diffuseColor = vec4(diffuse, opacity);\n    diffuseColor *= rainColor;\n    gl_FragColor = diffuseColor;\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, e) {
                    return l.multiply(Zt, e.viewMatrix, e.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: e,
                depth: {
                    enable: !0,
                    mask: !1,
                    func: "less",
                    range: [ 0, 1 ]
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "src alpha",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        }), this.bt();
    }
    bt() {
        const t = this.j.texture({
            width: 2,
            height: 2
        });
        if (this.xt = this.Mt(), !this.xt) return;
        this.St = new a.Scene(this.xt);
        const e = this.Ct();
        e.rainTexture ? this.kt(e.rainTexture).then((t => {
            this.xt.material.set("rainMap", t);
        })) : (this.xt.material.set("rainMap", t), console.warn("should set rain texture."));
    }
    Mt() {
        const t = this.getMap(), e = this.Ct();
        if (!e) return null;
        this.Tt = t.getZoom();
        const i = this.At(), s = this.Ot = e.density, n = this.It = e.rainWidth || 1, r = this.Lt = e.rainHeight || 1, h = [], o = [], l = [], c = [];
        for (let t = 0; t < s; t++) {
            const e = {};
            e.x = Math.random() * (i.max[0] - i.min[0]) + i.min[0], e.y = Math.random() * (i.max[2] - i.min[2]) + i.min[2], 
            e.z = Math.random() * (i.max[1] - i.min[1]) + i.min[1];
            const s = (i.max[2] - i.min[2]) / 37.5 * r, a = s / 3 * n;
            h.push(e.x + a, e.y + s, e.z, e.x - a, e.y + s, e.z, e.x - a, e.y, e.z, e.x + a, e.y, e.z), 
            o.push(e.x, e.y - s / 2, e.z, e.x, e.y - s / 2, e.z, e.x, e.y - s / 2, e.z, e.x, e.y - s / 2, e.z), 
            l.push(1, 1, 0, 1, 0, 0, 1, 0), c.push(4 * t + 0, 4 * t + 1, 4 * t + 2, 4 * t + 0, 4 * t + 2, 4 * t + 3);
        }
        const u = {};
        u.POSITION = h, u.NORMAL = o, u.TEXCOORD_0 = l;
        const f = new a.Geometry(u, c, 0, {
            primitive: "triangles",
            positionAttribute: "POSITION",
            normalAttribute: "NORMAL",
            uv0Attribute: "TEXCOORD_0"
        });
        f.generateBuffers(this.renderer.regl);
        const d = new a.Material({
            rainMap: this.j.texture({
                width: 2,
                height: 2
            }),
            diffuse: e.color || [ 1, 1, 1 ],
            opacity: e.opacity || 1
        }), m = new a.Mesh(f, d);
        return m.setUniform("top", i.max[2]), m.setUniform("bottom", i.min[2]), this.Et(m), 
        m.transparent = !0, m;
    }
    kt(t) {
        const e = new Image;
        return e.src = this.Rt = t, new Promise(((t, i) => {
            e.onload = () => {
                const i = this.j.texture({
                    mag: "linear",
                    min: "linear mipmap nearest",
                    wrapS: "clamp",
                    wrapT: "clamp",
                    data: e
                });
                t(i);
            }, e.onerror = t => {
                i(t);
            };
        }));
    }
    paint(t) {
        if (!this.St) return;
        const e = this.Ct(), i = {}, s = this.getMap();
        i.projMatrix = s.projMatrix, i.viewMatrix = s.viewMatrix, i.cameraPosition = s.cameraPosition;
        const n = e.speed || 1, r = this.yt.getElapsedTime() / (2 / n) % 1;
        i.time = r, this.xt.material.set("diffuse", e.color || ie), this.xt.material.set("opacity", e.opacity || 1), 
        this.Et(this.xt);
        const h = t && t.renderTarget && t.renderTarget.fbo;
        this.renderer.render(this.wt, i, this.St, h), this.h.getRenderer().setCanvasUpdated();
    }
    Et(t) {
        const e = this.getMap(), i = e.coordinateToPointAtRes(e.getCenter(), e.getGLRes()), s = e.getGLScale() / e.getGLScale(this.Tt), n = c.set(te, s, s, s), r = c.multiply(n, Kt, n), h = l.identity(ee), o = this.Ct(), a = e.getBearing();
        l.fromRotationTranslationScale(h, d.fromEuler(Qt, o.windDirectionX || 0, o.windDirectionY || 0, 90 - a), [ i.x, i.y, 0 ], r), 
        l.multiply(h, h, he), t.setLocalTransform(h);
    }
    setToRedraw() {
        const t = this.h.getRenderer();
        t && t.setToRedraw();
    }
    update() {
        const t = this.Ct();
        if (t) {
            if (this.xt || this.bt(), t.density !== this.Ot || t.rainWidth !== this.It || t.rainHeight !== this.Lt) {
                const t = this.xt.material.get("rainMap");
                this.xt.geometry.dispose(), this.xt.dispose(), this.St.clear(), this.xt = this.Mt(), 
                this.xt.material.set("rainMap", t), this.St.setMeshes(this.xt);
            }
            t.rainTexture !== this.Rt && this.kt(t.rainTexture).then((t => {
                this.xt.material.set("rainMap", t);
            }));
        }
    }
    dispose() {
        this.xt && (this.xt.geometry.dispose(), this.xt.material && this.xt.material.dispose(), 
        this.xt.dispose(), delete this.xt), this.wt && (this.wt.dispose(), delete this.wt);
    }
    isEnable() {
        const t = this.Ct();
        return t && t.enable;
    }
    Ct() {
        const t = this.h.getWeatherConfig();
        return t && t.rain;
    }
    At() {
        const t = 16.685648411389433 - this.getMap().getZoom();
        return c.scale(re.min, se, Math.pow(2, t)), c.scale(re.max, ne, Math.pow(2, t)), 
        re;
    }
}

class ae {
    constructor(t) {
        this.autoStart = void 0 === t || t, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, 
        this.running = !1;
    }
    start() {
        this.startTime = ("undefined" == typeof performance ? Date : performance).now(), 
        this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
    }
    stop() {
        this.getElapsedTime(), this.running = !1, this.autoStart = !1;
    }
    getElapsedTime() {
        return this.getDelta(), this.elapsedTime;
    }
    getDelta() {
        let t = 0;
        if (this.autoStart && !this.running) return this.start(), 0;
        if (this.running) {
            const e = ("undefined" == typeof performance ? Date : performance).now();
            t = (e - this.oldTime) / 1e3, this.oldTime = e, this.elapsedTime += t;
        }
        return 0;
    }
}

const le = [], ce = [ .03, .03, .03 ], ue = [], fe = [], de = [], me = l.fromRotationTranslation([], d.fromEuler([], 90, 0, 0), [ 0, 0, 0 ]);

class ge {
    constructor(t, e) {
        this.j = t, this.h = e, this.o();
    }
    o() {
        const t = this.h.getRenderer().canvas, e = {
            x: 0,
            y: 0,
            width: () => t.width,
            height: () => t.height
        };
        this.wt = new a.MeshShader({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\n#include <get_output>\nvoid main()\n{\n    mat4 localPositionMatrix = getPositionMatrix();\n    vec4 localPosition = getPosition(aPosition);\n    gl_Position = projMatrix * modelViewMatrix * localPositionMatrix * localPosition;\n    vTexCoord = aTexCoord;\n}",
            frag: "#if __VERSION__ == 100\n  #ifdef GL_OES_standard_derivatives\n    #extension GL_OES_standard_derivatives : enable\n  #endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nprecision mediump float;\nuniform sampler2D perlinTexture;\nvarying vec2 vTexCoord;\nfloat lerp(float a, float b, float w) {\n    return a + w * (b - a);\n}\nvoid main() {\n    float snowIntense = texture2D(perlinTexture, vTexCoord).r;\n    vec3 fixedC = vec3(1.0, 1.0, 1.0);\n    float r = lerp(0.5, fixedC.x, snowIntense);\n    float g = lerp(0.5, fixedC.y, snowIntense);\n    float b = lerp(0.5, fixedC.z, snowIntense);\n    glFragColor = vec4(r, g, b, 1.0);\n    #if __VERSION__ == 100\n        gl_FragColor = glFragColor;\n    #endif\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, e) {
                    return l.multiply(le, e.viewMatrix, e.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: e
            }
        }), this.wt.version = 300, this.St = new a.Scene, this.Ft = this.Pt(), this.St.setMeshes(this.Ft), 
        this.renderer = new a.Renderer(this.j);
        const i = this.Ht();
        i && (i.snowGroundTexture ? this.Dt(i.snowGroundTexture) : (this.Gt = this.j.texture({
            width: 2,
            height: 2
        }), console.warn("should set snow ground texture.")));
    }
    render(t) {
        this.Gt && this.Ft.material.set("perlinTexture", this.Gt);
        const e = this.h.getMap();
        this.Nt(e);
        const i = {
            projMatrix: e.projMatrix,
            viewMatrix: e.viewMatrix,
            cameraPosition: e.cameraPosition
        }, s = t && t.renderTarget && t.renderTarget.fbo;
        this.renderer.render(this.wt, i, this.St, s), this.h.getRenderer().setCanvasUpdated();
    }
    Nt(t) {
        const e = t.coordinateToPointAtRes(t.getCenter(), t.getGLRes()), i = t.getGLScale() / t.getGLScale(this.Tt), s = c.set(fe, i, i, i), n = c.multiply(s, ce, s), r = l.identity(de);
        l.fromRotationTranslationScale(r, d.fromEuler(ue, 0, 0, 0), [ e.x, e.y, .005 ], n), 
        l.multiply(r, r, me), this.Ft.setLocalTransform(r);
    }
    Dt(t) {
        const e = new Image;
        e.onload = () => {
            this.Gt = this.j.texture({
                mag: "linear",
                min: "linear mipmap nearest",
                wrapS: "repeat",
                wrapT: "repeat",
                data: e
            });
        }, e.onerror = t => {
            console.log(t);
        }, e.src = this.jt = t;
    }
    Pt() {
        const t = this.h.getMap();
        this.Tt = t.getZoom();
        const e = 16e3 * Math.pow(2, 16.685648411389433 - this.Tt), i = [ -e, 0, -e, e, 0, -e, -e, 0, e, e, 0, e ], s = {};
        s.POSITION = i, s.NORMAL = [ 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0 ], s.TEXCOORD_0 = [ 0, 0, 1, 0, 0, 1, 1, 1 ];
        const n = new a.Geometry(s, [ 3, 1, 0, 0, 2, 3 ], 0, {
            positionAttribute: "POSITION",
            normalAttribute: "NORMAL",
            uv0Attribute: "TEXCOORD_0"
        });
        n.generateBuffers(this.j);
        const r = new a.Material({
            perlinTexture: this.j.texture({
                with: 2,
                height: 2
            })
        });
        return new a.Mesh(n, r);
    }
    getMeshes() {
        return this.Ft;
    }
    dispose() {
        this.Ft && (this.Ft.geometry.dispose(), this.Ft.material && this.Ft.material.dispose(), 
        this.Ft.dispose(), delete this.Ft), this.wt && (this.wt.dispose(), delete this.wt);
    }
    update() {
        const t = this.Ht();
        t && t.snowGroundTexture === !this.jt && this.Dt(t.snowGroundTexture);
    }
    isEnable() {
        const t = this.Ht();
        return t && t.enable;
    }
    Ht() {
        const t = this.h.getWeatherConfig();
        return t && t.snow;
    }
}

const pe = [];

class we {
    constructor(t, e, i) {
        this.j = t, this.h = e, this.zt = i, this.o();
    }
    o() {
        this.renderer = new a.Renderer(this.j);
        const t = this.h.getRenderer(), e = this.Bt = {
            x: 0,
            y: 0,
            width: () => t.canvas ? t.canvas.width : 1,
            height: () => t.canvas ? t.canvas.height : 1
        };
        this.Ut = e.width, this.Vt = e.height, this.Wt = this.j.framebuffer({
            color: this.j.texture({
                width: t.canvas ? t.canvas.width : 1,
                height: t.canvas ? t.canvas.height : 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this.EMPTY_TEXTURE = this.j.texture({
            with: 2,
            height: 2
        }), this.qt = new oe(this.j, this.h), this.$t = new a.RainRipplesPass(this.j, e), 
        this.Yt = new ge(this.j, this.h), this.Xt = new a.FogPass(this.j, e, this.h), this.Jt = new a.FogShader, 
        this.Jt.version = 300;
    }
    getMap() {
        return this.h && this.h.getMap();
    }
    renderScene(t) {
        this.renderSnowMask(t), this.renderRain(t);
    }
    renderRain(t) {
        this.isEnableRain() && this.qt.paint(t);
    }
    renderSnowMask(t) {
        if (!this.isEnableSnow() || !this.Zt()) return;
        const e = this.getMap();
        this.Yt.render(t, e);
    }
    paint(t, e) {
        if (!e || !e.length) return t;
        this.Kt();
        const i = this.h.getWeatherConfig(), s = {};
        if (this.isEnableRain() ? (s.ripplesMap = this.Qt(), this.Jt.shaderDefines.HAS_RAIN = 1) : delete this.Jt.shaderDefines.HAS_RAIN, 
        this.isEnableSnow() ? (this.Jt.shaderDefines.HAS_SNOW = 1, s.snowIntensity = a.Util.isNumber(i.snow.snowIntensity) ? i.snow.snowIntensity : .5, 
        e.forEach((t => {
            t.defines.HAS_SNOW = 1;
        }))) : (delete this.Jt.shaderDefines.HAS_SNOW, e.forEach((t => {
            delete t.defines.HAS_SNOW;
        }))), this.isEnableFog()) {
            const t = i.fog;
            s.fogColor = t.color || [ .9, .9, .9 ], this.Jt.shaderDefines.HAS_FOG = 1;
        } else delete this.Jt.shaderDefines.HAS_FOG;
        return this.Jt.setDefines(this.Jt.shaderDefines), s.mixFactorMap = this.te(e) || this.EMPTY_TEXTURE, 
        s.sceneMap = t, s.time = this.ee() / 1e3, s.resolution = u.set(pe, this.Wt.width, this.Wt.height), 
        this.renderer.render(this.Jt, s, null, this.Wt), this.ie = e, this.Wt;
    }
    te(t) {
        const e = {}, i = this.getMap(), s = i.getZoom(), n = Math.pow(2, 16.685648411389433 - s), r = this.h.getWeatherConfig(), h = r.fog;
        if (!h || !h.enable) return null;
        const o = h.start || .1, a = h.end || 100;
        e.projMatrix = i.projMatrix, e.viewMatrix = i.viewMatrix, e.cameraPosition = i.cameraPosition, 
        e.fogDist = [ o * n, a * n ], e.rainDepth = i.altitudeToPoint(r.rain && r.rain.rainDepth || .1, i.getGLRes());
        const l = this.Xt.render(t, e);
        return this.h.getRenderer().se(l);
    }
    Qt() {
        const t = this.getMap(), e = this.h.getWeatherConfig(), i = e.rain.rippleRadius || 24, s = {};
        s.projMatrix = t.projMatrix, s.viewMatrix = t.viewMatrix, s.time = this.ee() / 1e3, 
        s.rippleRadius = i, s.density = e.rain.density || 2e3;
        return this.$t.render(t, s);
    }
    ee() {
        if (!this.h) return 0;
        if (void 0 === this.ne && (this.ne = 0), this.isPlaying()) {
            const t = this.h.getRenderer();
            this.ne = t.getFrameTime();
        }
        return this.ne;
    }
    isEnable() {
        const t = this.h.getWeatherConfig();
        return t && t.enable;
    }
    isEnableRain() {
        const t = this.h.getWeatherConfig();
        return t && t.enable && t.rain && t.rain.enable;
    }
    isEnableFog() {
        const t = this.h.getWeatherConfig();
        return t && t.enable && t.fog && t.fog.enable;
    }
    isEnableSnow() {
        const t = this.h.getWeatherConfig();
        return t && t.enable && t.snow && t.snow.enable;
    }
    Zt() {
        const t = this.h.getWeatherConfig();
        return this.isEnableSnow() && !1 === t.snow.showGround;
    }
    isPlaying() {
        const t = this.h.getWeatherConfig();
        return !!t && !1 !== t.playing;
    }
    re() {
        return this.isEnableRain() || this.isEnableFog() || this.isEnableSnow();
    }
    update() {
        !this.isEnable() && this.ie && this.ie.forEach((t => {
            delete t.defines.HAS_SNOW, delete t.defines.HAS_RAIN, delete t.defines.HAS_FOG;
        })), this.isEnableRain() && (this.qt = this.qt || new oe(this.j, this.h), this.qt.update()), 
        this.isEnableSnow() && (this.Yt = this.Yt || new ge(this.j, this.h), this.Yt.update());
    }
    getShadowMeshes() {
        return this.Yt.getMeshes();
    }
    Kt() {
        const t = this.Ut(), e = this.Vt();
        !this.Wt || this.Wt.width === t && this.Wt.height === e || this.Wt.resize(t, e);
    }
    dispose() {
        this.Wt && this.Wt.destroy(), this.Jt && (this.Jt.dispose(), delete this.Jt), this.qt && (this.qt.dispose(), 
        delete this.qt), this.Yt && (this.Yt.dispose(), delete this.Yt);
    }
}

const ve = [], _e = t => !!t.bloom, ye = t => !!t.ssr;

class be {
    constructor(t, e) {
        this.j = t, this.h = e, this.he = new a.Renderer(t), this.oe = new a.FxaaShader, 
        this.ae = new a.CopyShader, this.le = new a.SsrPass(this.j);
    }
    setContextIncludes() {}
    bloom(t, e, i, s, n, r, h) {
        this.ce || (this.ce = new a.BloomPass(this.j));
        const o = this.h.getRenderer().se(this.ue);
        return this.ce.render(t, o, s, n, r, e, i, h);
    }
    drawBloom(t) {
        const e = this.h.getRenderer(), i = this.j, s = this.ue;
        if (s) {
            const {width: e, height: n} = t;
            s.width === e && s.height === n || s.resize(e, n), i.clear({
                color: [ 0, 0, 0, 0 ],
                framebuffer: s
            });
        } else {
            const e = this.fe(t);
            this.ue = i.framebuffer(e);
        }
        const n = e.getFrameTime(), r = e.getFrameEvent(), h = e.getFrameContext(), o = h.renderMode, a = h.sceneFilter, l = h.renderTarget;
        h.isPostProcess = !0, h.renderMode = "default", h.sceneFilter = _e, h.renderTarget = {
            fbo: this.ue,
            getFramebuffer: xe,
            getDepthTexture: Me
        };
        const c = e.glCtx;
        return c.resetDrawCalls(), r ? e.forEachRenderer((t => {
            e.clearStencil(t, s), t.drawOnInteracting(r, n, h);
        })) : e.forEachRenderer((t => {
            e.clearStencil(t, s), t.draw(n, h);
        })), delete h.isPostProcess, h.renderMode = o, h.sceneFilter = a, h.renderTarget = l, 
        c.getDrawCalls();
    }
    genSsrMipmap(t, e) {
        const i = this.h.getMap().projViewMatrix;
        this.le.genMipMap(t, e, i);
    }
    getPrevSsrProjViewMatrix() {
        return this.le && this.le.getPrevProjViewMatrix();
    }
    drawSSR(t, e, i) {
        i && this.le.copyDepthTex(t);
        const s = this.h.getRenderer(), n = s.getFrameTime(), r = s.getFrameEvent(), h = s.getFrameContext();
        h.isPostProcess = !0, h.ssr = this.getSSRContext();
        const o = h.renderMode, a = h.sceneFilter;
        h.renderMode = "default", h.sceneFilter = ye, h.renderTarget.fbo = e;
        const l = s.glCtx;
        let c = !1;
        r ? s.forEachRenderer((t => {
            s.clearStencil(t, e), c || (l.resetDrawCalls(), c = !0), t.drawOnInteracting(r, n, h);
        })) : s.forEachRenderer((t => {
            s.clearStencil(t, e), c || (l.resetDrawCalls(), c = !0), t.draw(n, h);
        }));
        const u = s.drawGround();
        return delete h.ssr, delete h.isPostProcess, h.renderMode = o, h.sceneFilter = a, 
        this.de = l.getDrawCalls() > 0, u;
    }
    getSSRUniforms() {
        const t = this.h.u(), e = t && t.postProcess, i = this.h.getMap();
        return this.le.getSSRUniforms(i, e.ssr.factor, e.ssr.quality);
    }
    getSSRContext() {
        const t = this.h.u(), e = t && t.postProcess, i = this.h.getMap(), s = this.le.getSSRUniforms(i, e.ssr.factor, e.ssr.quality);
        if (!s) return null;
        return {
            renderUniforms: s,
            defines: {
                "HAS_SSR": 1
            }
        };
    }
    fxaa(t, e, i, s, n, r, h, o, a, l, c, f) {
        !t || t.width === e.fbo && t.height === e.height || t.resize(e.width, e.height);
        const d = {};
        o ? d.HAS_OUTLINE_TEX = 1 : delete d.HAS_OUTLINE_TEX, this.oe.setDefines(d), this.he.render(this.oe, {
            textureSource: e,
            resolution: u.set(ve, e.width, e.height),
            enableFXAA: i,
            enableToneMapping: s,
            enableSharpen: n,
            pixelRatio: r,
            sharpFactor: h,
            textureOutline: o,
            highlightFactor: a,
            outlineFactor: l,
            outlineWidth: c,
            outlineColor: f
        }, null, t);
    }
    renderFBOToScreen(t, e, i, s) {
        this.me || (this.me = []), this.me[0] = t.width, this.me[1] = t.height;
        const n = this.h.getRenderer();
        this.he.render(this.ae, {
            texture: t.color && n.se(t) || t,
            size: this.me,
            enableSharpen: +!!e,
            sharpFactor: i,
            pixelRatio: s
        });
    }
    postprocess(t, e, i) {
        this.ge || (this.ge = new a.PostProcessShader);
        const s = this.h && this.h.getRenderer(), n = i || s.se(t);
        return e.resolution = u.set(ve, n.width, n.height), e.textureSource = n, e.timeGrain = performance.now(), 
        this.he.render(this.ge, e), this.pe;
    }
    dispose() {
        this.ue && (this.ue.destroy(), delete this.ue), this.ce && (this.ce.dispose(), delete this.ce), 
        this.ge && (this.ge.dispose(), delete this.ge), this.oe && (this.oe.dispose(), delete this.oe), 
        this.ae && (this.ae.dispose(), delete this.ae);
    }
    fe(t, e) {
        const {width: i, height: s} = this.h.getRenderer().canvas, n = this.j;
        let r;
        r = this.h.getRenderer().we() ? n.renderbuffer({
            width: i,
            height: s,
            samples: this.h.options.multiSamples,
            format: "rgba8"
        }) : n.texture({
            min: "nearest",
            mag: "nearest",
            format: e || "rgba",
            width: i,
            height: s
        });
        const h = {
            width: i,
            height: s,
            colors: [ r ]
        };
        return t && (h.depthStencil = t), h;
    }
}

function xe(t) {
    return t._framebuffer.framebuffer;
}

function Me(t) {
    return t.depthStencil._texture.texture;
}

class Se extends a.QuadShader {
    constructor(t) {
        super({
            vert: "#if __VERSION__ == 300\n\t#define attribute in\n\t#define varying out\n#endif\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nvoid main()\n{\n  gl_Position = vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}",
            frag: "#if __VERSION__ == 100\n  #ifdef GL_OES_standard_derivatives\n    #extension GL_OES_standard_derivatives : enable\n  #endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\n#ifdef HAS_FLOODANALYSE\n    uniform vec3 flood_waterColor;\n    uniform float flood_waterOpacity;\n    uniform sampler2D floodMap;\n#endif\n#ifdef HAS_SKYLINE\n    uniform sampler2D skylineMap;\n#endif\n#ifdef HAS_VIEWSHED\n    uniform vec4 viewshed_visibleColor;\n    uniform vec4 viewshed_invisibleColor;\n    uniform sampler2D viewshedMap;\n#endif\n#ifdef HAS_INSIGHT\n    uniform vec4 insight_visibleColor;\n    uniform vec4 insight_invisibleColor;\n    uniform sampler2D insightMap;\n#endif\n#ifdef HAS_CUT\n    uniform sampler2D meshesMap;\n    uniform sampler2D invisibleMap;\n#endif\n#ifdef HAS_EXCAVATE\n    uniform sampler2D excavateMap;\n#endif\n#ifdef HAS_CROSSCUT\n    uniform sampler2D crosscutMap;\n    uniform vec4 cutLineColor;\n#endif\n#ifdef HAS_HEIGHTLIMIT\n    uniform vec3 limitColor;\n    uniform sampler2D heightLimitMap;\n#endif\nuniform sampler2D sceneMap;\nvoid main() {\n    vec4 sceneColor = texture2D(sceneMap, vTexCoord);\n    glFragColor = sceneColor;\n    #ifdef HAS_VIEWSHED\n        vec4 viewshedColor = texture2D(viewshedMap, vTexCoord);\n        if (viewshedColor.r > 0.99) {\n            glFragColor = vec4(mix(viewshed_invisibleColor.rgb, sceneColor.rgb, viewshed_invisibleColor.a), sceneColor.a);\n        } else if (viewshedColor.g > 0.99) {\n            glFragColor = vec4(mix(viewshed_visibleColor.rgb, sceneColor.rgb, viewshed_visibleColor.a), sceneColor.a);\n        } else if (viewshedColor.a < 0.01) {\n            glFragColor = vec4(viewshedColor.rgb, 1.0);\n        }\n    #endif\n    #ifdef HAS_FLOODANALYSE\n        vec4 floodColor = texture2D(floodMap, vTexCoord);\n        if (floodColor.r > 0.0) {\n            glFragColor = vec4(mix(glFragColor.rgb, flood_waterColor, flood_waterOpacity), glFragColor.a);\n        }\n    #endif\n    #ifdef HAS_SKYLINE\n        vec4 skylineColor = texture2D(skylineMap, vTexCoord);\n        if (skylineColor.r > 0.0 || skylineColor.g > 0.0 || skylineColor.b > 0.0) {\n            glFragColor = skylineColor;\n        }\n    #endif\n    #ifdef HAS_INSIGHT\n        vec4 insightColor = texture2D(insightMap, vTexCoord);\n        if (insightColor.g > 0.0) {\n            glFragColor = insight_visibleColor;\n        } else if (insightColor.r > 0.0) {\n            glFragColor = insight_invisibleColor;\n        }\n    #endif\n    #ifdef HAS_CUT\n        vec4 cutColor = texture2D(invisibleMap, vTexCoord);\n        vec4 meshesMapColor = texture2D(meshesMap, vTexCoord);\n        if (cutColor.r == 1.0 && cutColor.g == 0.0 && cutColor.b == 0.0) {\n            glFragColor = meshesMapColor;\n        } else if (cutColor.r == 0.0 && cutColor.g == 1.0 && cutColor.b == 0.0) {\n            glFragColor = meshesMapColor;\n        } else if (cutColor.r == 0.0 && cutColor.g == 0.0 && cutColor.b == 1.0) {\n          glFragColor = sceneColor;\n        }\n    #endif\n    #ifdef HAS_EXCAVATE\n        vec4 excavateColor = texture2D(excavateMap, vTexCoord);\n        if (excavateColor.r == 1.0 && excavateColor.g == 0.0 && excavateColor.b == 0.0) {\n          glFragColor = sceneColor;\n        }  else {\n          glFragColor = excavateColor;\n        }\n    #endif\n    #ifdef HAS_CROSSCUT\n        vec4 crosscutColor = texture2D(crosscutMap, vTexCoord);\n        if (crosscutColor.r > 0.0) {\n            glFragColor = vec4(mix(cutLineColor.rgb, glFragColor.rgb, 0.99), glFragColor.a);\n        }\n    #endif\n    #ifdef HAS_HEIGHTLIMIT\n        vec4 heightLimitColor = texture2D(heightLimitMap, vTexCoord);\n        if (heightLimitColor.r > 0.0) {\n            glFragColor = vec4(mix(limitColor, glFragColor.rgb, 0.6), glFragColor.a);\n        }\n    #endif\n    #if __VERSION__ == 100\n        gl_FragColor = glFragColor;\n    #endif\n}",
            extraCommandProps: {
                viewport: t,
                cull: {
                    enable: !0
                },
                blend: {
                    enable: !0,
                    func: {
                        srcRGB: "src alpha",
                        srcAlpha: 1,
                        dstRGB: "one minus src alpha",
                        dstAlpha: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        });
    }
}

class Ce {
    constructor(t, e, i) {
        this.j = t, this.h = e, this.zt = i, this.o();
    }
    o() {
        this.renderer = new a.Renderer(this.j);
        const t = this.h.getRenderer(), e = this.Bt = {
            x: 0,
            y: 0,
            width: () => t.canvas ? t.canvas.width : 1,
            height: () => t.canvas ? t.canvas.height : 1
        };
        this.Wt = this.j.framebuffer({
            color: this.j.texture({
                width: t.canvas ? t.canvas.width : 1,
                height: t.canvas ? t.canvas.height : 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this.wt = new Se(e);
    }
    getMap() {
        return this.h && this.h.getMap();
    }
    paint(t, e) {
        if (!e && e.length) return t;
        this.Kt();
        const i = {}, s = this.h.ve;
        if (!this._e()) return t;
        this.j.clear({
            color: [ 0, 0, 0, 0 ],
            depth: 1,
            stencil: 0,
            framebuffer: this.Wt
        }), delete this.wt.shaderDefines.HAS_FLOODANALYSE, delete this.wt.shaderDefines.HAS_VIEWSHED, 
        delete this.wt.shaderDefines.HAS_SKYLINE, delete this.wt.shaderDefines.HAS_INSIGHT, 
        delete this.wt.shaderDefines.HAS_CUT, delete this.wt.shaderDefines.HAS_CROSSCUT, 
        delete this.wt.shaderDefines.HAS_HEIGHTLIMIT;
        for (let t = 0; t < s.length; t++) {
            const n = s[t];
            if (!n.isEnable()) continue;
            const r = n.getDefines();
            ut(this.wt.shaderDefines, r);
            const h = this.getMap(), o = h.width, a = h.height, l = this.ye(e, n.getExcludeLayers()), c = n.renderAnalysis(l, o, a);
            c && ut(i, c);
        }
        return i.sceneMap = t, this.wt.setDefines(this.wt.shaderDefines), this.renderer.render(this.wt, i, null, this.Wt), 
        this.Wt;
    }
    ye(t, e) {
        let i = [];
        for (let s = 0; s < t.length; s++) {
            if (e.indexOf(t[s].getId()) > -1) continue;
            const n = t[s].getRenderer();
            if (n && n.getAnalysisMeshes) {
                const t = n.getAnalysisMeshes();
                t.forEach((t => {
                    t.setUniform("useAnalysis", 1);
                })), i = i.concat(t);
            }
        }
        return i;
    }
    Kt() {
        const t = i.isFunction(this.Bt.width.data) ? this.Bt.width.data() : this.Bt.width, e = i.isFunction(this.Bt.height.data) ? this.Bt.height.data() : this.Bt.height;
        !this.Wt || this.Wt.width === t && this.Wt.height === e || this.Wt.resize(t, e);
    }
    _e() {
        const t = this.h && this.h.ve;
        if (!t) return !1;
        for (let e = 0; e < t.length; e++) if (t[e].isEnable()) return !0;
        return !1;
    }
}

const ke = [ 0, 0, 0, 0 ], Te = [ 1, 1, -1 ], Ae = [ 0, 0 ], Oe = t => !t.bloom && !t.ssr, Ie = t => !t.bloom, Le = t => !t.ssr;

class Ee extends t.renderer.CanvasRenderer {
    setToRedraw() {
        this.setRetireFrames(), super.setToRedraw();
    }
    onAdd() {
        super.onAdd(), this.prepareCanvas();
    }
    updateSceneConfig() {
        this.be && this.be.update(), this.xe && this.xe.update(), this.Me && this.Me.update(), 
        this.setToRedraw();
    }
    render(...t) {
        this.getMap() && this.layer.isVisible() && (this.forEachRenderer((t => {
            t._replacedDrawFn || (t.draw = this.Se(t.draw), t.drawOnInteracting = this.Ce(t.drawOnInteracting), 
            t.setToRedraw = this.ke(t.setToRedraw), t._replacedDrawFn = !0);
        })), this.prepareRender(), this.prepareCanvas(), this.layer.Te(), this._toRedraw = !1, 
        this.Ae("render", t), this.Oe(), this.Ie());
    }
    prepareCanvas() {
        super.prepareCanvas(), this.forEachRenderer((t => {
            t.prepareCanvas();
        }));
    }
    drawOnInteracting(...t) {
        this.getMap() && this.layer.isVisible() && (this.layer.Te(), this._toRedraw = !1, 
        this.Ae("drawOnInteracting", t), this.Oe(), this.Ie());
    }
    Ae(t, e) {
        this.Le = "default";
        const i = this.hasRenderTarget(), s = this.Ee(e);
        if (i && (this.Re.renderTarget = this.Fe()), this.xe.paint(s), this.drawGround(!0), 
        !i) return void this.Pe("default", null, t, e, !0);
        const n = this.glCtx, r = this.layer.u(), h = r && r.postProcess, o = this.isSSROn();
        s.jitter = Ae;
        const a = this.layer.getGroundConfig();
        s.hasSSRGround = !!(o && a && a.enable && a.symbol && a.symbol.ssr), n.resetDrawCalls(), 
        this.Pe("default", this.He, t, e), o && this.De.drawSSR(this.Ge(), this.He);
        h.bloom && h.bloom.enable && (this.Ne = this.De.drawBloom(this.je)), 2 === o && this.De.drawSSR(this.Ge(), this.He, !0), 
        n.resetDrawCalls(), this.Me.renderScene(s), this.ze = n.getDrawCalls();
    }
    Pe(t, e, i, s, n) {
        this.Le = t;
        const r = this.Ee(s);
        r.renderMode = this.Le, r.renderTarget && (r.renderTarget.fbo = e), n && (r.isFinalRender = !0), 
        this.forEachRenderer(((t, n) => {
            n.isVisible() && (this.clearStencil(t, e), t[i].apply(t, s));
        }));
    }
    Ee(t) {
        let e = t[0];
        return Re(e) || (e = t[1]), e !== this.Be && (this.forEachRenderer(((t, e) => {
            e.isVisible() && t.needRetireFrames && t.needRetireFrames() && this.setRetireFrames();
        })), this.Re = this.Ue(e), this.Be = e, this.Ve = Re(t[0]) ? null : t[0]), this.Re;
    }
    Oe() {
        if (!this.isEnableOutline()) return;
        const t = this.We(), e = this.glCtx;
        e.resetDrawCalls(), this.forEachRenderer(((e, i) => {
            i.isVisible() && e.drawOutline && e.drawOutline(t);
        })), this.qe = e.getDrawCalls();
    }
    We() {
        const {width: t, height: e} = this.canvas;
        let i = this.$e;
        if (i) t === i.width && e === i.height || i.resize(t, e); else {
            const s = this.regl.texture({
                width: t,
                height: e,
                format: "rgba4"
            });
            i = this.$e = this.regl.framebuffer({
                width: t,
                height: e,
                colors: [ s ],
                depth: !1,
                stencil: !1
            });
        }
        return i;
    }
    se(t) {
        if (this.we()) {
            const e = this.Ye(t);
            return e.width !== t.width || e.height !== t.height ? e.resize(t.width, t.height) : this.regl.clear({
                color: [ 0, 0, 0, 0 ],
                fbo: e
            }), e.blit(t), e.color[0];
        }
        return t.color[0];
    }
    Ge() {
        if (this.je.subimage) return this.je;
        const {width: t, height: e} = this.je;
        if (!this.Xe) {
            const i = this.regl, s = {
                depthStencil: i.texture({
                    min: "nearest",
                    mag: "nearest",
                    mipmap: !1,
                    type: "depth stencil",
                    width: t,
                    height: e,
                    format: "depth stencil"
                }),
                colors: [ i.renderbuffer({
                    width: t,
                    height: e,
                    format: "rgba4"
                }) ],
                colorFormat: "rgba4",
                width: t,
                height: e
            };
            this.Xe = i.framebuffer(s);
        }
        return this.Xe.width === t && this.Xe.height === e || this.Xe.resize(t, e), this.regl.clear({
            color: [ 0, 0, 0, 0 ],
            depth: 1,
            fbo: this.Xe
        }), this.Xe.blit(this.He, 256, "nearest"), this.Xe.depthStencil;
    }
    Ye(t) {
        if (this.Je || (this.Je = []), !t.Ze) {
            const e = this.Ke(!0, t.width, t.height), i = this.regl.framebuffer(e);
            this.Je.push(i), t.Ze = i;
        }
        return t.Ze;
    }
    we() {
        return 0 === this.regl.limits.version.indexOf("WebGL 2.0") && this.layer.options.antialias;
    }
    hasRenderTarget() {
        const t = this.layer.u(), e = t && t.postProcess;
        return !(!e || !e.enable);
    }
    testIfNeedRedraw() {
        if (this.layer.options.forceRedrawPerFrame) return !0;
        if (this._toRedraw) return this._toRedraw = !1, !0;
        if (this.getMap().isInteracting() && (this.be && this.be.isEnable() || this.xe && this.xe.isEnable())) return !0;
        if (this.Me && this.Me.isEnable()) return !0;
        const t = this.layer.getTerrainLayer();
        if (t) {
            const e = t.getRenderer();
            if (e && e.testIfNeedRedraw()) return this.Qe = !0, !0;
        }
        const e = this.ti();
        for (const t of e) {
            if (!t || !t.isVisible()) continue;
            const e = t.getRenderer();
            if (e && e.testIfNeedRedraw()) return this.Qe = !0, !0;
        }
        return !1;
    }
    isRenderComplete() {
        const t = this.ti();
        for (const e of t) {
            const t = e.getRenderer();
            if (t && !t.isRenderComplete()) return !1;
        }
        return !0;
    }
    mustRenderOnInteracting() {
        const t = this.ti();
        for (const e of t) {
            const t = e.getRenderer();
            if (t && t.mustRenderOnInteracting()) return !0;
        }
        return !1;
    }
    isCanvasUpdated() {
        if (super.isCanvasUpdated()) return !0;
        const t = this.ti();
        for (const e of t) {
            const t = e.getRenderer();
            if (t && t.isCanvasUpdated()) return !0;
        }
        return !1;
    }
    isBlank() {
        if (this.be && this.be.isEnable()) return !1;
        if (this.xe && this.xe.isEnable()) return !1;
        const t = this.layer.getTerrainLayer();
        if (t) {
            const e = t.getRenderer();
            if (e && !e.isBlank()) return !1;
        }
        const e = this.ti();
        for (const t of e) {
            const e = t.getRenderer();
            if (e && !e.isBlank()) return !1;
        }
        return !0;
    }
    createContext() {
        const t = this.layer, e = t.options.glOptions || {
            alpha: !0,
            depth: !0,
            stencil: !0
        };
        e.preserveDrawingBuffer = !0, e.antialias = !!t.options.antialias, this.glOptions = e;
        const i = this.gl = function(t, e, i) {
            const s = i ? [ "webgl", "experimental-webgl" ] : [ "webgl2", "webgl", "experimental-webgl" ];
            let n = null;
            for (let i = 0; i < s.length; ++i) {
                try {
                    n = t.getContext(s[i], e);
                } catch (t) {}
                if (n) break;
            }
            return n || console.error("Browser doesn't support WebGL."), n;
        }(this.canvas, e, t.options.onlyWebGL1);
        this.ei(i), i.wrap = () => new p(this.gl), this.glCtx = i.wrap(), this.canvas.gl = this.gl, 
        this.reglGL = i.wrap(), this.regl = w({
            gl: this.reglGL,
            attributes: e,
            extensions: t.options.extensions,
            optionalExtensions: t.options.optionalExtensions
        }), this.gl.regl = this.regl, this.ii = [ 0, 0 ], this.be = new Vt(this.regl, this.layer), 
        this.xe = new Jt(this.regl, this.layer);
        const s = this.layer.getWeatherConfig();
        this.Me = new we(this.regl, t, s), this.si = new Ce(this.regl, t);
        const n = this.layer.u() || {}, r = n && n.postProcess, h = r && r.antialias && r.antialias.jitterRatio || .2;
        this.ni = new a.Jitter(h), this.De = new be(this.regl, this.layer, this.ni), this.ri = new Ct(this.regl, this.layer);
    }
    ei() {
        const t = this.layer, e = this.gl, i = t.options.extensions;
        i && i.forEach((t => {
            e.getExtension(t);
        }));
        const s = t.options.optionalExtensions;
        s && s.forEach((t => {
            e.getExtension(t);
        })), this.gl.clearColor(0, 0, 0, 0);
    }
    clearCanvas() {
        super.clearCanvas(), this.hi();
    }
    hi() {
        const t = this.regl;
        this.He && t.clear({
            color: ke,
            depth: 1,
            stencil: 255,
            framebuffer: this.He
        }), this.$e && t.clear({
            color: ke,
            framebuffer: this.$e
        }), t.clear({
            color: ke,
            depth: 1,
            stencil: 255
        });
    }
    resizeCanvas() {
        const t = this.canvas.width, e = this.canvas.height;
        !this.He || this.He.width === t && this.He.height === e || (super.resizeCanvas(), 
        this.He.resize(t, e), this.hi(), this.forEachRenderer((t => {
            t.canvas && t.resizeCanvas();
        })));
    }
    getCanvasImage() {
        return this.forEachRenderer((t => {
            t.getCanvasImage();
        })), super.getCanvasImage();
    }
    ti() {
        return this.layer.ti();
    }
    forEachRenderer(t) {
        const e = this.ti();
        for (const i of e) {
            if (!i.isVisible() || !i.options.beneathTerrain) continue;
            const e = i.getRenderer();
            e && t(e, i);
        }
        const i = this.layer.getTerrainLayer();
        if (i) {
            const e = i.getRenderer();
            e && t(e, i);
        }
        for (const i of e) {
            if (!i.isVisible() || i.options.beneathTerrain) continue;
            const e = i.getRenderer();
            e && t(e, i);
        }
    }
    clearStencil(t, e) {
        const i = {
            stencil: t.getStencilValue ? t.getStencilValue() : 255
        };
        e && (i.framebuffer = e), this.regl.clear(i);
    }
    onRemove() {
        this.canvas.pickingFBO && this.canvas.pickingFBO.destroy && this.canvas.pickingFBO.destroy(), 
        this.oi(), this.be && (this.be.dispose(), delete this.be), this.xe && (this.xe.dispose(), 
        delete this.xe), this.ri && (this.ri.dispose(), delete this.ri), this.De && (this.De.dispose(), 
        delete this.De), this.$e && (this.$e.destroy(), delete this.$e), this.Me && (this.Me.dispose(), 
        delete this.Me), super.onRemove();
    }
    oi() {
        if (this.He && (this.He.destroy(), delete this.He, this.ai && (this.ai.destroy(), 
        delete this.ai), this.Xe && (this.Xe.destroy(), delete this.Xe), this.Je)) {
            for (let t = 0; t < this.Je.length; t++) this.Je[t] && this.Je[t].destroy();
            delete this.Je;
        }
    }
    setRetireFrames() {
        this.li = !0;
    }
    getFrameTime() {
        return this.Be;
    }
    getFrameEvent() {
        return this.Ve;
    }
    getFrameContext() {
        return this.Re;
    }
    drawGround(t) {
        const e = this.layer.getGroundConfig();
        if (!e || !e.enable) return !1;
        if (!this.be) return !1;
        const i = this.getFrameContext(), s = i.jitter;
        i.jitter = Ae;
        const n = this.layer.getPolygonOffsetCount();
        let r;
        i.offsetFactor = n + 1, i.offsetUnits = n + 1, t && (r = i.sceneFilter, delete i.sceneFilter);
        const h = this.be.paint(i);
        return this.be.needToRedraw() && this.setToRedraw(), r && (i.sceneFilter = r), i.jitter = s, 
        h;
    }
    Se(t) {
        const e = this;
        return function(i, s) {
            return (s = s || e.Re) && s.renderTarget && (s.renderTarget.getFramebuffer = Fe, 
            s.renderTarget.getDepthTexture = Pe), t.call(this, i, s);
        };
    }
    Ce(t) {
        const e = this;
        return function(i, s, n) {
            return (n = n || e.Re) && n.renderTarget && (n.renderTarget.getFramebuffer = Fe, 
            n.renderTarget.getDepthTexture = Pe), t.call(this, i, s, n);
        };
    }
    ke(t) {
        return function(...e) {
            return t.apply(this, e);
        };
    }
    isEnableSSR() {
        const t = this.layer.u(), e = t && t.postProcess;
        return e && e.enable && e.ssr && e.ssr.enable;
    }
    isSSROn() {
        const t = this.isEnableSSR(), e = this.getMap();
        if (!t || e.getPitch() <= -.001) return 0;
        const i = e.projViewMatrix, s = this.De.getPrevSsrProjViewMatrix();
        return s && l.exactEquals(s, i) ? 1 : 2;
    }
    isEnableTAA() {
        return !1;
    }
    isEnableSSAO() {
        return !1;
    }
    isEnableOutline() {
        const t = this.layer.u(), e = t && t.postProcess;
        return e && e.enable && e.outline && e.outline.enable;
    }
    isEnableWeather() {
        const t = this.layer.u(), e = t && t.weather;
        return e && e.enable;
    }
    ci() {
        const t = this.layer.getMap();
        if (!this.R) {
            this.R = {
                center: t.getCenter(),
                bearing: t.getBearing(),
                pitch: t.getPitch(),
                res: t.getResolution()
            };
            let e = !1;
            if (t.options.lights) {
                const i = t.getLightManager().getDirectionalLight().direction || Te;
                this.R.lightDirection = c.copy([], i), e = !0;
            }
            return {
                viewChanged: !0,
                lightDirectionChanged: e
            };
        }
        const e = t.getResolution() / this.R.res, i = t.coordToContainerPoint(this.R.center), s = this.layer.options.viewMoveThreshold, n = i._sub(t.width / 2, t.height / 2).mag() > s || e < .95 || e > 1.05;
        let r = !1;
        if (t.options.lights) {
            const e = t.getLightManager().getDirectionalLight().direction || Te;
            r = !c.equals(this.R.lightDirection, e), r && (this.R.lightDirection = c.copy([], e));
        }
        return n && (this.R.center = t.getCenter(), this.R.bearing = t.getBearing(), this.R.pitch = t.getPitch(), 
        this.R.res = t.getResolution()), {
            viewChanged: n,
            lightDirectionChanged: r
        };
    }
    Ue(t) {
        const e = this.layer.u(), i = e && e.postProcess, s = e && e.weather, n = {
            timestamp: t,
            renderMode: this.Le || "default",
            includes: {},
            states: this.ci(),
            testSceneFilter: t => !n.sceneFilter || n.sceneFilter(t),
            isFinalRender: !1,
            weather: {
                fog: s && s.fog
            }
        }, r = i && i.antialias && i.antialias.jitterRatio || .2, h = this.ni;
        h && h.setRatio(r);
        const o = this.isSSROn();
        let a;
        if (i && i.enable) {
            if (this.isEnableTAA()) {
                (this.getMap().isInteracting() || this.li) && h.reset(), h.getJitter(this.ii), h.frame();
            } else u.set(this.ii, 0, 0);
            n.jitter = this.ii;
            const t = i.bloom && i.bloom.enable;
            t && o ? (n.bloom = 1, n.sceneFilter = Oe) : t ? (n.bloom = 1, n.sceneFilter = Ie) : o && (n.sceneFilter = Le), 
            a = this.Fe(), a && (n.renderTarget = a);
        } else this.oi();
        return "noAa" !== this.Le && (this.ui = this.fi(n), this.ui && (n.includes.shadow = 1), 
        this.di = this.mi(n)), this.ui && (n.shadow = this.ui, n.includes.shadow = 1), n.states.includesChanged = this.di, 
        i && i.enable && this.De && this.De.setContextIncludes(n), n;
    }
    gi(t) {
        const e = this.ti().filter((t => t.isVisible()));
        return this.layer.getTerrainLayer() && e.push(this.layer.getTerrainLayer()), this.si.paint(t, e);
    }
    mi(t) {
        let e = !1;
        const i = Object.keys(t.includes), s = this.pi;
        if (s) {
            const t = i.filter((t => -1 === s.indexOf(t))).concat(s.filter((t => -1 === i.indexOf(t))));
            t.length && (e = t.reduce(((t, e) => (t[e] = 1, t)), {}));
        }
        return this.pi = i, e;
    }
    fi(t) {
        const e = this.layer.u();
        if (!e || !e.shadow || !e.shadow.enable) return this.ri && (this.ri.dispose(), delete this.ri), 
        null;
        this.ri || (this.ri = new Ct(this.regl, this.layer));
        const i = {
            config: e.shadow,
            defines: this.ri.getDefines(),
            uniformDeclares: Ct.getUniformDeclares()
        };
        return i.renderUniforms = this.wi(t), i;
    }
    wi(t) {
        const e = t.renderTarget && t.renderTarget.fbo, i = this.layer.u(), s = [];
        let n = t.states.lightDirectionChanged || t.states.viewChanged;
        this.forEachRenderer(((t, e) => {
            if (!t.getShadowMeshes || !e.isVisible()) return;
            const i = t.getShadowMeshes();
            if (Array.isArray(i)) for (let t = 0; t < i.length; t++) i[t] && (i[t].needUpdateShadow && (n = !0, 
            i[t].needUpdateShadow = !1), i[t].hasFunctionUniform && (i[t].hasFunctionUniform("minAltitude") || i[t].setFunctionUniform("minAltitude", (() => e && e.options.altitude || 0)), 
            s.push(i[t])));
        })), this.vi || (this.vi = new a.Scene), this.vi.setMeshes(s);
        const r = this.getMap(), h = i.shadow, o = r.getLightManager(), l = o && o.getDirectionalLight().direction || Te, c = !i.ground || !i.ground.enable;
        return this.ri.render(c, r.projMatrix, r.viewMatrix, h.color, h.opacity, l, this.vi, this.ii, e, n);
    }
    _i(t) {
        let e = [];
        if (this.forEachRenderer(((t, i) => {
            if (!t.getAnalysisMeshes || !i.isVisible()) return;
            const s = t.getAnalysisMeshes();
            e = e.concat(s);
        })), this.be) {
            const t = this.be.getRenderMeshes();
            e = e.concat(t);
        }
        const i = this.layer.getWeatherConfig();
        return this.Me.paint(t, e, i);
    }
    getGroundMesh() {
        if (this.be) {
            return this.be.getRenderMeshes();
        }
        return [];
    }
    Fe() {
        const t = this.layer.u(), e = t && t.postProcess;
        if (!this.He) {
            const t = this.regl;
            let i = this.je;
            (!i || !i._texture || i._texture.refCount <= 0) && (i = null);
            const s = this.createFBOInfo(e, i);
            this.je = s.depth || s.depthStencil, this.He = t.framebuffer(s), this.hi();
        }
        return {
            fbo: this.He
        };
    }
    Ke(t, e, i) {
        e = e || this.canvas.width, i = i || this.canvas.height;
        const s = this.regl, n = this.we();
        let r;
        if (!t && n) r = s.renderbuffer({
            width: e,
            height: i,
            samples: this.layer.options.multiSamples,
            format: "rgba8"
        }); else {
            const t = "uint8";
            r = s.texture({
                min: "nearest",
                mag: "nearest",
                type: t,
                width: e,
                height: i
            });
        }
        return {
            width: e,
            height: i,
            colors: [ r ],
            colorFormat: n ? "rgba8" : "rgba"
        };
    }
    createFBOInfo(t, e) {
        let {width: i, height: s} = this.canvas;
        i = i || 1, s = s || 1;
        const n = this.regl, r = this.Ke(), h = this.we(), o = n.hasExtension("WEBGL_depth_texture");
        if (h) {
            const t = e || n.renderbuffer({
                width: i,
                height: s,
                format: "depth24 stencil8",
                samples: this.layer.options.multiSamples
            });
            r.depthStencil = t;
        } else if (o) {
            const t = e || n.texture({
                min: "nearest",
                mag: "nearest",
                mipmap: !1,
                type: "depth stencil",
                width: i,
                height: s,
                format: "depth stencil"
            });
            r.depthStencil = t;
        } else {
            const t = e || n.renderbuffer({
                width: i,
                height: s,
                format: "depth stencil"
            });
            r.depthStencil = t;
        }
        return r;
    }
    Ie() {
        if (!this.He) return void (this.li = !1);
        const t = this.layer.u(), e = t && t.postProcess;
        if (!e || !e.enable) {
            if (this.isEnableWeather()) throw new Error("you must enable the post process to turn on weather");
            return;
        }
        this.layer.fire("postprocessstart");
        const i = this.layer.getMap();
        let s = e.sharpen && e.sharpen.factor;
        s || 0 === s || (s = .2);
        let n = 0, r = .2, h = .3, o = 1, a = [ 1, 1, 0 ];
        e.outline && (n = +!!e.outline.enable, r = He(e.outline, "highlightFactor", r), 
        h = He(e.outline, "outlineFactor", h), o = He(e.outline, "outlineWidth", o), a = He(e.outline, "outlineColor", a));
        const l = e.ssr && e.ssr.enable, c = e.bloom && e.bloom.enable, u = this.si._e(), f = this.Me.re(), d = c || l || u || f;
        let m = this.ai;
        if (d) {
            if (!m) {
                const t = this.Ke();
                this.we() && (t.depthStencil = this.regl.renderbuffer({
                    width: this.canvas.width,
                    height: this.canvas.height,
                    samples: this.layer.options.multiSamples,
                    format: "depth24 stencil8"
                })), m = this.ai = this.regl.framebuffer(t);
            }
            const {width: t, height: e} = this.canvas;
            m.width === t && m.height === e || m.resize(t, e);
        } else m = null, this.ai && (this.ai.destroy(), delete this.ai);
        let g = this.se(this.He);
        if (this.De.fxaa(m, g, 0, +!(!e.toneMapping || !e.toneMapping.enable), +!(d || !e.sharpen || !e.sharpen.enable), i.getDevicePixelRatio(), s, n && this.qe > 0 && this.We(), r, h, o, a), 
        m && (g = this.se(m)), c && this.Ne) {
            const t = e.bloom, i = +t.threshold || 0, s = He(t, "factor", 1), n = He(t, "radius", 1);
            g = this.De.bloom(g, null, null, i, s, n, 0);
        }
        if (l && (this.De.genSsrMipmap(g, this.Ge()), this.Qe)) {
            const t = this.li;
            this.setToRedraw(), this.li = t, this.Qe = !1;
        }
        this.si && (g = this.gi(g)), this.isEnableWeather() && (g = this._i(g)), d && this.De.renderFBOToScreen(g, +!(!e.sharpen || !e.sharpen.enable), s, i.getDevicePixelRatio()), 
        this.layer.fire("postprocessend");
    }
}

function Re(t) {
    return "number" == typeof t && !isNaN(t);
}

function Fe(t) {
    return t._framebuffer.framebuffer;
}

function Pe(t) {
    return t.depthStencil._texture.texture;
}

function He(t, e, i) {
    return null == t[e] ? i : t[e];
}

class De extends t.worker.Actor {
    constructor(t) {
        super("@maptalks/terrain"), this.mapId = t;
    }
    checkUrl(e) {
        return e && t.Util.isString(e) ? t.Util.getAbsoluteURL(e) : e;
    }
    fetchTerrain(t, e, i) {
        t = this.checkUrl(t);
        const s = {
            actorId: this.actorId,
            mapId: this.mapId,
            command: "fetchTerrain",
            params: {
                url: t,
                origin: location.origin,
                terrainWidth: e.terrainWidth,
                type: e.type,
                accessToken: e.accessToken,
                cesiumIonTokenURL: e.cesiumIonTokenURL,
                error: e.error,
                colors: e.colors,
                tileSize: e.tileSize
            }
        };
        this.send(s, null, ((t, e) => {
            t ? i(t) : i(t, e);
        }));
    }
    abortTerrain(t, e) {
        const i = {
            actorId: this.actorId,
            mapId: this.mapId,
            command: "abortTerrain",
            params: {
                url: t
            }
        };
        this.broadcast(i, null, e);
    }
    addLayer(t, e, i) {
        const s = {
            actorId: this.actorId,
            mapId: this.mapId,
            layerId: t,
            command: "addLayer",
            params: {}
        };
        this.broadcast(s, null, i);
    }
    createTerrainMesh(t, e) {
        const i = {
            actorId: this.actorId,
            command: "createTerrainMesh",
            params: t
        };
        this.send(i, [ t.terrainHeights.data.buffer ], ((t, i) => {
            t ? e(t) : e(t, i);
        }));
    }
    removeLayer(t, e, i) {
        const s = {
            mapId: this.mapId,
            layerId: t,
            command: "removeLayer"
        };
        this.broadcast(s, null, i);
    }
}

class Ge {
    constructor(t = 257) {
        this.gridSize = t;
        const e = t - 1;
        if (e & e - 1) throw new Error(`Expected grid size to be 2^n+1, got ${t}.`);
        this.numTriangles = e * e * 2 - 2, this.numParentTriangles = this.numTriangles - e * e, 
        this.indices = new Uint32Array(this.gridSize * this.gridSize), this.coords = new Uint16Array(4 * this.numTriangles);
        for (let t = 0; t < this.numTriangles; t++) {
            let i = t + 2, s = 0, n = 0, r = 0, h = 0, o = 0, a = 0;
            for (1 & i ? r = h = o = e : s = n = a = e; (i >>= 1) > 1; ) {
                const t = s + r >> 1, e = n + h >> 1;
                1 & i ? (r = s, h = n, s = o, n = a) : (s = r, n = h, r = o, h = a), o = t, a = e;
            }
            const l = 4 * t;
            this.coords[l + 0] = s, this.coords[l + 1] = n, this.coords[l + 2] = r, this.coords[l + 3] = h;
        }
    }
    createTile(t) {
        return new Ne(t, this);
    }
}

class Ne {
    constructor(t, e) {
        const i = e.gridSize;
        if (t.length !== i * i) throw new Error(`Expected terrain data of length ${i * i} (${i} x ${i}), got ${t.length}.`);
        this.terrain = t, this.martini = e, this.errors = new Float32Array(t.length), this.update();
    }
    update() {
        const {numTriangles: t, numParentTriangles: e, coords: i, gridSize: s} = this.martini, {terrain: n, errors: r} = this;
        for (let h = t - 1; h >= 0; h--) {
            const t = 4 * h, o = i[t + 0], a = i[t + 1], l = i[t + 2], c = i[t + 3], u = o + l >> 1, f = a + c >> 1, d = u + f - a, m = f + o - u, g = (n[a * s + o] + n[c * s + l]) / 2, p = f * s + u, w = Math.abs(g - n[p]);
            if (r[p] = Math.max(r[p], w), h < e) {
                const t = (a + m >> 1) * s + (o + d >> 1), e = (c + m >> 1) * s + (l + d >> 1);
                r[p] = Math.max(r[p], r[t], r[e]);
            }
        }
    }
    getMesh(t = 0) {
        const {gridSize: e, indices: i} = this.martini, {errors: s} = this;
        let n = 0, r = 0;
        const h = e - 1;
        function o(h, a, l, c, u, f) {
            const d = h + l >> 1, m = a + c >> 1;
            Math.abs(h - u) + Math.abs(a - f) > 1 && s[m * e + d] > t ? (o(u, f, h, a, d, m), 
            o(l, c, u, f, d, m)) : (i[a * e + h] = i[a * e + h] || ++n, i[c * e + l] = i[c * e + l] || ++n, 
            i[f * e + u] = i[f * e + u] || ++n, r++);
        }
        i.fill(0), o(0, 0, h, h, h, 0), o(h, h, 0, 0, 0, h);
        const a = new Uint16Array(2 * n), l = new Uint32Array(3 * r);
        let c = 0;
        function u(n, r, h, o, f, d) {
            const m = n + h >> 1, g = r + o >> 1;
            if (Math.abs(n - f) + Math.abs(r - d) > 1 && s[g * e + m] > t) u(f, d, n, r, m, g), 
            u(h, o, f, d, m, g); else {
                const t = i[r * e + n] - 1, s = i[o * e + h] - 1, u = i[d * e + f] - 1;
                a[2 * t] = n, a[2 * t + 1] = r, a[2 * s] = h, a[2 * s + 1] = o, a[2 * u] = f, a[2 * u + 1] = d, 
                l[c++] = t, l[c++] = s, l[c++] = u;
            }
        }
        return u(0, 0, h, h, h, 0), u(h, h, 0, 0, 0, h), {
            vertices: a,
            triangles: l
        };
    }
    getMeshWithSkirts(t = 0, e) {
        const {gridSize: i, indices: s} = this.martini, {errors: n} = this;
        let r = 0, h = 0;
        const o = i - 1;
        let a, l, c = 0;
        const u = [], f = [], d = [], m = [];
        function g(e, p, w, v, _, y) {
            const b = e + w >> 1, x = p + v >> 1;
            Math.abs(e - _) + Math.abs(p - y) > 1 && n[x * i + b] > t ? (g(_, y, e, p, b, x), 
            g(w, v, _, y, b, x)) : (a = p * i + e, l = v * i + w, c = y * i + _, 0 === s[a] && (0 === e ? u.push(r) : e === o && f.push(r), 
            0 === p ? d.push(r) : p === o && m.push(r), s[a] = ++r), 0 === s[l] && (0 === w ? u.push(r) : w === o && f.push(r), 
            0 === v ? d.push(r) : v === o && m.push(r), s[l] = ++r), 0 === s[c] && (0 === _ ? u.push(r) : _ === o && f.push(r), 
            0 === y ? d.push(r) : y === o && m.push(r), s[c] = ++r), h++);
        }
        let p;
        s.fill(0), g(0, 0, o, o, o, 0), g(o, o, 0, 0, 0, o), p = e ? 2 * (r + 3 * u.length - 2 + 3 * f.length - 2 + 3 * d.length - 2 + 3 * m.length - 2) : 2 * (r + u.length + f.length + d.length + m.length);
        const w = 3 * (h + 2 * (u.length - 1) + 2 * (f.length - 1) + 2 * (d.length - 1) + 2 * (m.length - 1)), v = new Uint16Array(p), _ = new Uint32Array(w);
        let y = 0;
        function b(e, r, h, o, a, l) {
            const c = e + h >> 1, u = r + o >> 1;
            if (Math.abs(e - a) + Math.abs(r - l) > 1 && n[u * i + c] > t) b(a, l, e, r, c, u), 
            b(h, o, a, l, c, u); else {
                const t = s[r * i + e] - 1, n = s[o * i + h] - 1, c = s[l * i + a] - 1;
                v[2 * t] = e, v[2 * t + 1] = r, v[2 * n] = h, v[2 * n + 1] = o, v[2 * c] = a, v[2 * c + 1] = l, 
                _[y++] = t, _[y++] = n, _[y++] = c;
            }
        }
        b(0, 0, o, o, o, 0), b(o, o, 0, 0, 0, o), u.sort(((t, e) => v[2 * t + 1] - v[2 * e + 1])), 
        f.sort(((t, e) => v[2 * e + 1] - v[2 * t + 1])), d.sort(((t, e) => v[2 * e] - v[2 * t])), 
        m.sort(((t, e) => v[2 * t] - v[2 * e]));
        let x, M, S, C, k = 2 * r, T = 0;
        function A(t) {
            T = t.length;
            for (let i = 0; i < T - 1; i++) x = t[i], M = t[i + 1], S = k / 2, C = (k + (e ? 6 : 2)) / 2, 
            v[k++] = 2 * x, v[k++] = 2 * x + 1, e && (v[k++] = 2 * x, v[k++] = 2 * x + 1, v[k++] = 2 * M, 
            v[k++] = 2 * M + 1), e ? (_[y++] = S + 1, _[y++] = S, _[y++] = S + 2, _[y++] = S, 
            _[y++] = C, _[y++] = S + 2) : (_[y++] = x, _[y++] = S, _[y++] = M, _[y++] = S, _[y++] = C, 
            _[y++] = M);
            v[k++] = 2 * t[T - 1], v[k++] = 2 * t[T - 1] + 1;
        }
        A(u);
        const O = k;
        A(f);
        const I = k;
        A(d);
        const L = k;
        A(m);
        return {
            vertices: v,
            triangles: _,
            numVerticesWithoutSkirts: r,
            numTrianglesWithoutSkirts: h,
            leftSkirtIndex: O,
            rightSkirtIndex: I,
            bottomSkirtIndex: L,
            topSkirtIndex: k
        };
    }
}

const je = {};

function ze(t, e, i, s) {
    let n = je[i];
    n || (n = je[i] = new Ge(i));
    const r = n.createTile(e).getMeshWithSkirts(t, !0), {triangles: h, vertices: o, leftSkirtIndex: a, rightSkirtIndex: l, bottomSkirtIndex: c, topSkirtIndex: u} = r;
    let {numVerticesWithoutSkirts: f, numTrianglesWithoutSkirts: d} = r;
    f || (f = o.legnth / 3, d = h.length / 3);
    const m = o.length / 2, g = new Float32Array(3 * m), p = new Float32Array(2 * m);
    let w = 1 / 0, v = -1 / 0;
    const _ = i - 1;
    for (let t = 0; t < m; t++) {
        const s = o[2 * t], n = o[2 * t + 1];
        if (t >= f) {
            const e = s / 2 * 3;
            let i, n = .001;
            (t - (t < a / 2 ? f : t < l / 2 ? a / 2 : t < c / 2 ? l / 2 : c / 2)) % 3 == 0 ? (i = 0, 
            n = 0) : i = g[e + 2];
            g[3 * t] = g[e], g[3 * t + 1] = g[e + 1], g[3 * t + 2] = i, p[2 * t] = g[e] / _ + n, 
            p[2 * t + 1] = -g[e + 1] / _ + n;
        } else g[3 * t] = 1 * s, g[3 * t + 1] = 1 * -n, g[3 * t + 2] = e[n * i + s], p[2 * t] = s / _, 
        p[2 * t + 1] = n / _;
        const r = g[g.length - 1];
        r < w && (w = r), r > v && (v = r);
    }
    return {
        positions: g,
        texcoords: p,
        triangles: h,
        leftSkirtIndex: a,
        rightSkirtIndex: l,
        bottomSkirtIndex: c,
        topSkirtIndex: u,
        numTrianglesWithoutSkirts: d,
        numVerticesWithoutSkirts: f,
        minHeight: w,
        maxHeight: v,
        terrainWidth: i
    };
}

function Be(t, e, i, s, n, r, h, o, a) {
    const l = {};
    for (let c = 0; c < a; c++) l[c + ""] = Ve(t, e, i, s, n, r, h, o, c);
    return l;
}

const Ue = [];

function Ve(t, e, i, s, n, r, h, o, a) {
    if ((s -= a) <= 0) return Ue;
    const l = t.getTileSize().width, c = t._getTileOffset(s, n), u = r[0] - c[0], f = c[1] - r[1], d = t._getTileConfig(), m = t.getSpatialReference().getResolution(s), g = d.tileSystem.scale.y, p = 1e-7;
    let w = 0, v = 0, _ = o /= Math.pow(2, a), y = o;
    if (u < 0 ? _ += Math.ceil(-u / l - p) : u > 0 && (w -= Math.ceil(u / l - p)), f > 0 ? v -= Math.ceil(f / l - p) : f < 0 && (y += Math.ceil(-f / l - p)), 
    0 === w && 0 === v && _ <= 1 && y <= 1) {
        const n = Math.floor(e * o);
        let r = Math.floor(i * o);
        const a = r;
        return g !== h && (r = $e(d, r, m)), [ {
            x: n,
            y: r,
            skinY: a,
            z: s,
            offset: c,
            tileSize: l,
            id: t._getTileId(n, r, s)
        } ];
    }
    const b = [];
    for (let n = w; n < _; n++) for (let r = v; r < y; r++) {
        const a = e * o + n;
        let u = i * o + r;
        const f = u;
        g !== h && (u = $e(d, u, m)), b.push({
            x: a,
            y: u,
            skinY: f,
            z: s,
            offset: c,
            tileSize: l,
            id: t._getTileId(a, u, s)
        });
    }
    return b;
}

function We(t, e, i, s) {
    let n = t / i * s / e;
    return n < 1 ? (n = 1 / n, n = 1 / Math.round(n)) : n = Math.round(n), n;
}

function qe(t, e, i) {
    const s = t.getResolution(e), n = e - Math.log(i / s) * Math.LOG2E;
    return {
        zoom: n,
        res: t.getResolution(n)
    };
}

function $e(t, e, i) {
    const s = t.fullExtent, n = t.tileSize.width, r = Math.max(s.top, s.bottom), h = Math.min(s.top, s.bottom);
    return Math.ceil(r / n / i) - 1 - Math.floor(h / n / i) - e;
}

function Ye(t, e) {
    const i = e * e, s = 0 !== t ? new Float32Array(i) : new Uint8Array(i);
    return s.fill(t), {
        data: s,
        width: e,
        height: e,
        max: t,
        min: t
    };
}

new t.Point(0, 0);

const Xe = Ye(0, 5), Je = ze(1, Xe.data, Xe.width);

function Ze(t, e, i) {
    const s = i && i.includes;
    if (s) for (const n in s) s[n] && (i[n].uniformDeclares && e.push(...i[n].uniformDeclares), 
    i[n].defines && ut(t, i[n].defines));
}

function Ke(t, e) {
    const i = e && e.includes;
    if (i) for (const s in i) i[s] && e[s].renderUniforms && ut(t, e[s].renderUniforms);
}

Je.empty = !0;

var Qe = Object.freeze({
    __proto__: null,
    fillIncludes: Ze,
    setIncludeUniformValues: Ke
});

const ti = [], ei = [];

class ii {
    constructor(t) {
        this.layer = t, this.regl = t.getRenderer().regl, this.renderer = new a.Renderer(this.regl), 
        this.yi = new a.Scene;
        const e = new Uint8Array(16);
        e.fill(255), this.bi = this.regl.texture({
            width: 2,
            height: 2,
            data: e
        }), this.xi = new a.ResourceLoader(this.bi), this.Mi();
    }
    setToRedraw() {
        this.layer.getRenderer().setToRedraw();
    }
    getMap() {
        return this.layer.getMap();
    }
    startFrame(t) {
        t && t.states && t.states.includesChanged && (this.shader.dispose(), delete this.shader), 
        this.shader || this.initShader(t), this.yi.clear();
    }
    createTerrainMesh(t, e) {
        const {mesh: i, image: s} = e;
        let n = e.terrainMesh;
        const {positions: r, texcoords: h, triangles: o, empty: l} = i;
        if (n && n.geometry !== this.Si) n.geometry.updateData("aPosition", r), n.geometry.updateData("aTexCoord", h), 
        n.geometry.setElements(o); else {
            const t = l ? this.Si : new a.Geometry({
                aPosition: r,
                aTexCoord: h
            }, o, 0);
            n ? n.geometry = t : (n = new a.Mesh(t, null, {
                disableVAO: !0
            }), t.generateBuffers(this.regl));
        }
        if (!n.uniforms.skin) {
            const t = this.getEmptyTexture();
            n.setUniform("skin", t);
        }
        return n.setUniform("heightTexture", s), this.prepareMesh(n, t, e), n;
    }
    Ci(t) {
        const e = this.layer.getRenderer();
        e && e.updateMaskDefines(t);
    }
    ki(t) {
        const e = this.Ti(100) / 100, i = l.identity(t);
        return l.scale(i, i, [ 1, 1, e ]), i;
    }
    Ai(t, e, i) {
        const s = this.getMap(), n = this.layer.getTileSize().width, r = e.res / s.getGLRes(), h = n / (i - 1), {extent2d: o, offset: a} = e;
        c.set(ti, (o.xmin - a[0]) * r, (e.extent2d.ymax - a[1]) * r, 0);
        const u = l.identity(t);
        return l.translate(u, u, ti), c.set(ei, r * h, r * h, 1), l.scale(u, u, ei), u;
    }
    prepareMesh(t, e, i) {
        if (!t.isValid()) return;
        const {mesh: s} = i;
        this.Ci(t);
        const {triangles: n, numTrianglesWithoutSkirts: r, terrainWidth: h} = s;
        t.localTransform = this.Ai(t.localTransform || [], e, h), t.positionMatrix = this.ki(t.positionMatrix || []), 
        t.properties.skirtOffset = 3 * r, t.properties.skirtCount = n.length - 3 * r, t.properties.z = e.z, 
        t.properties.minHeight = s.minHeight, t.properties.maxHeight = s.maxHeight, t.properties.terrainWidth = h, 
        t.castShadow = !1, pt(t.uniforms, "minAltitude") || Object.defineProperty(t.uniforms, "minAltitude", {
            enumerable: !0,
            get: () => i.minAltitude || 0
        });
    }
    addTerrainImage(t, e) {
        const i = e.terrainMesh;
        i && i.geometry && e.skin && (i.setUniform("skin", e.skin.color[0]), i.setUniform("polygonOpacity", 1), 
        this.yi.addMesh(i));
    }
    endFrame(t) {
        this.updateIBLDefines(this.shader);
        let e = 0;
        const i = this.getUniformValues(), s = this.Oi(t);
        return this.shader.filter = t && t.sceneFilter, Ke(i, t), e += this.renderer.render(this.shader, i, this.yi, s), 
        e;
    }
    delete() {
        this.shader && (this.shader.dispose(), delete this.shader), this.bi && (this.bi.destroy(), 
        delete this.bi), this.Si && (this.Si.dispose(), delete this.Si);
    }
    deleteMesh(t) {
        if (!t) return;
        const e = t.geometry;
        t.dispose(), e !== this.Si && e.dispose();
    }
    initShader(t) {
        const e = [], i = [], s = {}, n = [];
        Ze(s, n, t), this.shader = new a.MeshShader({
            vert: "#define SHADER_NAME TERRAIN_MESH\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nuniform float minAltitude;\nuniform mat4 projViewModelMatrix;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform float heightScale;\nvarying vec2 vUv;\n#include <mask_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n    #include <vsm_shadow_vert>\n#endif\nvoid main() {\n    vec4 position = vec4(aPosition.xy, (aPosition.z + minAltitude) * heightScale, 1.0);\n    position = positionMatrix * position;\n    #ifdef HAS_MASK_EXTENT\n        gl_Position = projMatrix * getMaskPosition(position, modelMatrix);\n    #else\n        gl_Position = projViewModelMatrix * position;\n    #endif\n    vUv = aTexCoord;\n    #if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n        shadow_computeShadowPars(position);\n    #endif\n}",
            frag: "#define SHADER_NAME TERRAIN_MESH\nprecision mediump float;\nuniform sampler2D skin;\nuniform float polygonOpacity;\nvarying vec2 vUv;\n#include <mask_frag>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n    #include <vsm_shadow_frag>\n#endif\nvoid main() {\n    vec2 uv = vec2(vUv);\n    uv.y = 1.0 - uv.y;\n    vec4 color = texture2D(skin, uv);\n    #if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n        float shadowCoeff = shadow_computeShadow();\n        color.rgb = shadow_blend(color.rgb, shadowCoeff).rgb;\n    #endif\n    gl_FragColor = color * polygonOpacity;\n    #ifdef HAS_MASK_EXTENT\n      gl_FragColor = setMask(gl_FragColor);\n    #endif\n}",
            uniforms: n.concat([ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(t, e) {
                    return l.multiply(i, e.viewMatrix, e.modelMatrix);
                }
            }, {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(t, i) {
                    return l.multiply(e, i.projViewMatrix, i.modelMatrix);
                }
            } ]),
            defines: s,
            extraCommandProps: this.getExtraCommandProps()
        });
    }
    getExtraCommandProps() {
        const t = this.layer.getRenderer().canvas;
        return {
            viewport: {
                x: 0,
                y: 0,
                width: () => t ? t.width : 1,
                height: () => t ? t.height : 1
            },
            stencil: {
                enable: !1
            },
            cull: {
                enable: !0,
                face: "back"
            },
            depth: {
                enable: !0,
                mask: () => !!this.layer.options.depthMask,
                func: this.layer.options.depthFunc || "<="
            },
            blend: {
                enable: !0,
                func: {
                    src: this.layer.options.blendSrc,
                    dst: this.layer.options.blendDst
                },
                equation: "add"
            }
        };
    }
    Oi(t) {
        return t && t.renderTarget && t.renderTarget.fbo;
    }
    getUniformValues() {
        const t = this.getMap(), e = t.projViewMatrix, i = this.layer.getRenderer().getMaskUniforms(), s = {
            viewMatrix: t.viewMatrix,
            projMatrix: t.projMatrix,
            projViewMatrix: e,
            heightScale: 1
        };
        return ut(s, i), s;
    }
    Ti(t) {
        const e = this.layer.getMap();
        if (!e) return null;
        return e.altitudeToPoint(t, e.getGLRes());
    }
    getEmptyTexture() {
        return this.bi;
    }
    hasIBL() {
        const t = this.getMap().getLightManager();
        return !!(t && t.getAmbientResource());
    }
    updateIBLDefines(t) {
        const e = t.shaderDefines;
        let i = !1;
        this.hasIBL() ? e[[ "HAS_IBL_LIGHTING" ]] || (e.HAS_IBL_LIGHTING = 1, i = !0) : e[[ "HAS_IBL_LIGHTING" ]] && (delete e.HAS_IBL_LIGHTING, 
        i = !0), i && (t.shaderDefines = e);
    }
    Mi() {
        const t = Je, {positions: e, texcoords: i, triangles: s} = t;
        this.Si = new a.Geometry({
            aPosition: e,
            aTexCoord: i
        }, s, 0), this.Si.generateBuffers(this.regl);
    }
}

const {getIBLResOnCanvas: si, getPBRUniforms: ni, loginIBLResOnCanvas: ri, logoutIBLResOnCanvas: hi} = a.pbr.PBRUtils, oi = {
    baseColorFactor: [ 1, 1, 1, 1 ],
    emissiveFactor: [ 0, 0, 0 ],
    baseColorIntensity: 1,
    emitColorFactor: 1,
    roughnessFactor: 1,
    metallicFactor: 0,
    emitMultiplicative: 1,
    outputSRGB: 1,
    hsv: [ 0, 0, 0 ],
    contrast: 1,
    alphaTest: 0
};

class ai extends ii {
    constructor(...t) {
        super(...t), this.createIBLTextures(), this.Ii = 0;
    }
    updateMaterial(t, e) {
        this.Ii = e, this.Li = this.Li || {}, ut(this.Li, t), this.setToRedraw();
    }
    setMaterial(t, e) {
        this.Ii = e, this.Li = ut({}, oi, t), this.setToRedraw();
    }
    createIBLTextures() {
        const t = this.getMap().getRenderer().canvas;
        ri(t, this.regl, this.getMap()), this.layer.fire("iblupdated");
    }
    disposeIBLTextures() {
        const t = this.getMap().getRenderer().canvas;
        hi(t, this.getMap());
    }
    createTerrainMesh(t, e) {
        const {mesh: i, image: s} = e, {positions: n, texcoords: r, triangles: h, leftSkirtIndex: o, rightSkirtIndex: l, bottomSkirtIndex: c, numVerticesWithoutSkirts: u} = i, f = new Int8Array(n.length);
        for (let t = 2; t < f.length; t += 3) t < 3 * u ? f[t] = 1 : t < o / 2 * 3 ? f[t - 2] = -1 : t < l / 2 * 3 ? f[t - 2] = 1 : f[t - 1] = t < c / 2 * 3 ? -1 : 1;
        const d = new a.Geometry({
            aPosition: n,
            aTexCoord: r,
            aNormal: f
        }, h, 0);
        let m;
        d.createTangent(), delete d.data.aNormal, d.generateBuffers(this.regl), m = s ? this.regl.texture({
            width: s.width,
            height: s.height,
            data: s,
            min: "linear",
            mag: "linear"
        }) : this.getEmptyTexture();
        const g = this.getEmptyTexture(), p = ut({}, oi, this.layer.options.material || {});
        p.skinTexture = g, p.terrainHeightTexture = m;
        const w = new a.pbr.StandardMaterial(p), v = new a.Mesh(d, w);
        v.properties.matVer = this.Ii;
        const _ = v.defines;
        return _.HAS_UV_FLIP = 1, _.HAS_TERRAIN_NORMAL = 1, _.HAS_MAP = 1, v.defines = _, 
        v.setUniform("terrainTileResolution", t.res), this.prepareMesh(v, t, e), v;
    }
    addTerrainImage(t, e) {
        const i = e.terrainMesh;
        if (i) {
            if (this.Li && i.properties.matVer !== this.Ii) {
                for (const t in this.Li) i.material.set(t, this.Li[t]);
                i.properties.matVer = this.Ii;
            }
            e.skin && i.material.set("skinTexture", e.skin), i.setUniform("polygonOpacity", 1), 
            this.yi.addMesh(i);
        }
    }
    getUniformValues() {
        const t = this.getMap(), e = t.getRenderer().canvas, {iblTexes: i, dfgLUT: s} = si(e), n = ni(t, i, s), r = this.layer.getTileSize().width, h = this.layer.getRenderer().getMaskUniforms(), o = this.Ti(100) / 100;
        return ut(n, {
            viewMatrix: t.viewMatrix,
            projMatrix: t.projMatrix,
            projViewMatrix: t.projViewMatrix,
            outSize: [ e.width, e.height ],
            polygonFill: [ 1, 1, 1, 1 ],
            terrainHeightMapResolution: [ r, r ],
            terrainResolution: [ e.width, e.height ],
            terrainHeightScale: o,
            terrainUnpackFactors: [ 6553.6, 25.6, .1, 1e4 ]
        }), ut(n, h), n;
    }
    initShader(t) {
        const e = {}, i = [];
        Ze(e, i, t), this.shader = new a.pbr.StandardShader({
            uniforms: i,
            defines: e,
            extraCommandProps: this.getExtraCommandProps()
        });
    }
    delete() {
        return this.disposeIBLTextures(), super.delete();
    }
}

function li(t, e, i, s) {
    const n = ci.call(this, i, s);
    this._projViewMatrix = e;
    const {colorExtent: r, modeExtent: h} = this._extentPass.render(n, e);
    this._maskUniforms = this._maskUniforms || {}, this._maskUniforms.mask_colorExtent = r, 
    this._maskUniforms.mask_extent = t, this._maskUniforms.mask_modeExtent = h, this._maskUniforms.mask_hasFlatOut = fi.call(this, "flat-outside"), 
    this._maskUniforms.mask_hasClipOut = fi.call(this, "clip-outside"), this._maskUniforms.mask_hasVideo = fi.call(this, "video"), 
    this._maskUniforms.mask_heightRatio = i, this._maskUniforms.mask_heightOffset = s, 
    this.setToRedraw();
}

function ci(t, e) {
    const i = [], s = this.layer.getMasks();
    for (let n = 0; n < s.length; n++) {
        const r = s[n].getMesh(this.regl, t, e);
        r && i.push(r);
    }
    return i;
}

function ui() {
    if (!this._extentPass || !this._maskUniforms) return;
    const t = this._maskUniforms.mask_heightRatio, e = this._maskUniforms.mask_heightOffset, i = ci.call(this, t, e);
    this._extentPass.render(i, this._projViewMatrix);
    const s = this.layer.getMasks();
    for (let t = 0; t < s.length; t++) "video" === s[t].getMode() && s[t].Ei();
}

function fi(t) {
    const e = this.layer.getMasks();
    for (let i = 0; i < e.length; i++) if (e[i].getMode() === t) return 1;
    return 0;
}

function di() {
    const t = this.layer.getMasks();
    if (!t) return !1;
    for (let e = 0; e < t.length; e++) if ("video" === t[e].getMode() && t[e].Ri()) return !0;
    return !1;
}

function mi(t) {
    return class extends t {
        setMask(t, e, i, s) {
            this.viewport || (this.viewport = {
                x: 0,
                y: 0,
                width: () => this.canvas ? this.canvas.width : 1,
                height: () => this.canvas ? this.canvas.height : 1
            }), this._extentPass ? li.call(this, t, e, i, s) : this.regl ? (this._extentPass = new a.ExtentPass(this.regl, this.viewport), 
            li.call(this, t, e, i, s)) : this.layer.once("contextcreate", (() => {
                this._extentPass = new a.ExtentPass(this.regl, this.viewport), li.call(this, t, e, i, s);
            }), this);
        }
        needToRedraw() {
            return !!super.needToRedraw() || !!di.call(this);
        }
        getMaskUniforms() {
            return di.call(this) && ui.call(this), this.layer.updateMaskExtent(), this._maskUniforms;
        }
        getMaskDefines() {
            return this._maskDefines || (this._maskDefines = {}), this._maskUniforms && this._maskUniforms.mask_colorExtent ? this._maskDefines.HAS_MASK_EXTENT = 1 : delete this._maskDefines.HAS_MASK_EXTENT, 
            this._maskDefines;
        }
        updateMaskDefines(t) {
            const e = t.getDefines();
            delete e.HAS_MASK_EXTENT;
            ut(e, this.getMaskDefines()), t.setDefines(e);
        }
        _clearMask() {
            this._deleteMaskUniforms(), this._extentPass && (this._extentPass.dispose(), delete this._extentPass), 
            this.setToRedraw();
        }
        _deleteMaskUniforms() {
            delete this._maskUniforms;
        }
    };
}

class gi {
    constructor(t, e) {
        this.max = t, this.onRemove = e, this.reset();
    }
    reset() {
        if (this.data) {
            const t = this.data.values();
            for (const e of t) this.onRemove(e);
        }
        return this.data = new Map, this;
    }
    clear() {
        this.reset(), delete this.onRemove;
    }
    add(t, e) {
        return e ? (this.has(t) ? (this.data.delete(t), this.data.set(t, e)) : this.data.set(t, e), 
        this) : this;
    }
    keys() {
        const t = new Array(this.data.size);
        let e = 0;
        const i = this.data.keys();
        for (const s of i) t[e++] = s;
        return t;
    }
    has(t) {
        return this.data.has(t);
    }
    getAndRemove(t) {
        if (!this.has(t)) return null;
        const e = this.data.get(t);
        return this.data.delete(t), e;
    }
    get(t) {
        if (!this.has(t)) return null;
        return this.data.get(t);
    }
    pop() {
        if (this.data.size < this.max) return null;
        const t = this.data.keys().next();
        return this.data.get(t.value).current ? (this.max += Math.ceil(this.max / 2), null) : this.getAndRemove(t.value);
    }
    remove(t) {
        if (!this.has(t)) return this;
        const e = this.data.get(t);
        return this.data.delete(t), this.onRemove(e), this;
    }
    resetCurrent(t) {
        this.data && this.data.forEach((e => {
            e.current = t;
        }));
    }
}

const pi = new t.Point(0, 0), wi = new t.Point(0, 0), vi = new t.PointExtent(0, 0, 0, 0), _i = new t.Point(0, 0), yi = new t.Point(20, 20), bi = {
    color: [ 0, 0, 0, 0 ],
    depth: 1,
    stencil: 0
};

class xi extends(mi(t.renderer.TileLayerCanvasRenderer)){
    isDrawable() {
        return !0;
    }
    getTempTileOnLoading(t, e) {
        if (e.image && !e.image.reset) return e;
        const i = this.Fi(t);
        return i.temp = !0, e.image || (e.image = i), delete e.image.reset, e.current = !0, 
        e.info = t, ut(e.image, i), this.Pi(e.image, t), e;
    }
    Hi(t, e, i) {
        e.reset = !0, delete e.data, delete e.loadTime, delete e.rendered, delete e.minAltitude;
        const s = t.id + "-temp", n = e.skinImages;
        if (n) for (let t = 0; t < n.length; t++) {
            const e = n[t];
            if (e) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && (n.refs.delete(s), n.refs.size || i.push(n));
                }
                delete e.currentSkins, delete e.tileIds;
            }
        }
        delete e.sourceZoom, delete e.skinImages, delete e.skinStatus, delete e.skinTileIds, 
        e.debugTexture && (e.debugTexture.destroy(), delete e.debugTexture);
    }
    Fi(t, e) {
        for (e = e || this.findParentTile(t); e && e.image && (-1 === e.image.sourceZoom || e.image.originalError); ) e = this.findParentTile(e.info);
        const i = (e && e.info || t).res, s = this.getMap().pointAtResToDistance(1, 1, i), n = e && e.image && e.image.data && this.Di(e, t), r = n && -1 !== e.image.sourceZoom ? e.info.z : -1;
        if (!n || n.width <= 1) {
            const i = this.Gi(t, e);
            return {
                data: Ye(i || 0, 5),
                minAltitude: i,
                mesh: Je,
                sourceZoom: r
            };
        }
        const h = n.width;
        return {
            data: n,
            mesh: ze(s, n.data, h),
            sourceZoom: r
        };
    }
    Gi(t, e) {
        if (e && e.minAltitude) return e.minAltitude;
        const {idx: i, idy: s, z: n} = t;
        for (let t = -1; t <= 1; t++) for (let e = -1; e <= 1; e++) {
            if (0 === t && 0 === e) continue;
            const r = this.layer.getTileId(i + t, s + e, n), h = this.layer.tileInfoCache.get(r);
            if (h && h.minAltitude) return h.minAltitude;
        }
        return 0;
    }
    consumeTile(t, e) {
        if (t.empty && !t.mesh) {
            const i = this.findParentTile(e);
            if (!i || i.image && i.image.empty) {
                t.mesh = Je;
                const i = this.Gi(e);
                t.data = Ye(i || 0, 5), t.minAltitude = i, t.sourceZoom = -1;
            } else t = this.Fi(e, i);
        }
        this.Pi(t, e), super.consumeTile(t, e), this.Ni(e);
    }
    Pi(t, e) {
        if (t && t.mesh) {
            t.terrainMesh = this.ji.createTerrainMesh(e, t), e.minAltitude = t.data.min, e.maxAltitude = t.data.max, 
            delete t.mesh;
            const i = this.layer.tileInfoCache;
            if (i && e.parent && !t.empty && !t.temp) {
                const t = i.get(e.parent);
                if (t) {
                    const {minAltitude: i, maxAltitude: s} = e;
                    (void 0 === t.minAltitude || t.minAltitude > i) && (t.minAltitude = i), (void 0 === t.maxAltitude || t.maxAltitude < s) && (t.maxAltitude = s);
                }
            }
        }
    }
    Ni(t) {
        const e = this.getMap();
        if (e.updateCenterAltitude && void 0 === e.centerAltitude && t.z === this.getCurrentTileZoom()) {
            const i = e._getPrjCenter(), s = e._prjToPointAtRes(i, t.res, _i);
            t.extent2d.contains(s) && e.updateCenterAltitude();
        }
    }
    draw(t, e) {
        this.zi(), this.ji.startFrame(e), super.draw(t, e), this.Bi(e);
    }
    drawTile(t, e) {
        const i = this.getMap();
        if (!t || !i || !e) return;
        if (!this.drawingCurrentTiles && !this.drawingChildTiles) return;
        let s = this.drawingCurrentTiles ? this.getTileOpacity(e) : 1;
        s *= this.layer.options.opacity || 1, this.ji.addTerrainImage(t, e, s);
    }
    _drawTiles(t, e, i, s, n, r) {
        const h = [];
        wt(t, this.Ui(r, h)), this.Vi = 0;
        const o = this.layer.getSkinCount(), a = new Set;
        for (let e = 0; e < o; e++) this.Wi(e, t, a, h);
        for (let e = 0; e < t.length; e++) this.qi(t[e].info, t[e].image);
        for (let t = 0; t < h.length; t++) h[t] && h[t].texture && !h[t].refs.size && (this.$i.delete(h[t].tile.id), 
        this.Yi(h[t]));
        return this.Xi(), super._drawTiles(...arguments);
    }
    Ui(t, e) {
        const i = [];
        let s = this.Ji;
        s || (s = this.Ji = new gi(this.layer.options.tempTileCacheSize, (t => {
            const {info: e, image: i} = t;
            this.Zi(e, i);
        }))), s.resetCurrent(!1);
        for (let n = 0; n < t.length; n++) {
            const r = t[n];
            let h;
            s.has(r.id) ? h = s.getAndRemove(r.id) : (h = s.pop(), h ? h.image && (this.Hi(h.info, h.image, e), 
            h.image.temp = !0) : h = {
                info: r
            }), h.current = !0, s.add(r.id, h), i.push(h);
        }
        for (let e = 0; e < t.length; e++) this.getTempTileOnLoading(t[e], i[e]);
        return i;
    }
    Xi() {
        if (!this.$i) return;
        const t = this.getCurrentTimestamp();
        if (this.Ki && t - this.Ki < 1e3) return;
        const e = new Set;
        for (const t of this.tileCache.data.values()) this.Qi(t, e);
        for (const t in this.tilesInView) {
            const i = this.tilesInView[t];
            this.Qi(i, e);
        }
        if (this.Ji) for (const t of this.Ji.data.values()) this.Qi(t, e);
        e.size && (this.$i.forEach(((t, i) => {
            e.has(i) || (console.log("deleted:", i), this.Yi(this.$i.get(i)), this.$i.delete(i));
        })), this.Ki = t);
    }
    Qi(t, e) {
        const i = t.image && t.image.skinImages;
        if (i && i.length) for (let t = 0; t < i.length; t++) {
            const s = i[t] && i.currentSkins;
            if (s) for (const t of s) e.add(t);
        }
    }
    Wi(t, e, i, s) {
        const n = this.layer.getSkinLayer(t).getRenderer();
        if (!n) return;
        const r = [];
        for (let n = 0; n < e.length; n++) {
            const {info: h, image: o} = e[n];
            if (this.ts(t, h, o, s)) {
                const s = e[n].image.skinImages[t];
                for (let t = 0; t < s.length; t++) {
                    const e = s[t].tile.info.id;
                    i.has(e) || (r.push(s[t]), i.add(e));
                }
            }
        }
        n.renderTerrainSkin(this.regl, this.layer, r);
    }
    ts(t, e, i, s) {
        const n = this.getMap();
        if (delete i.path, !e || !n || !i) return !1;
        if (!i.terrainMesh) return !1;
        const r = this.layer.getSkinLayer(t), h = r.getRenderer();
        if (!h) return !1;
        i.skinImages || (i.skinImages = []), i.skinStatus || (i.skinStatus = []), i.skinTileIds || (i.skinTileIds = []);
        const o = h.isAnimating && h.isAnimating(), a = i.skinStatus[t], l = h.needToRefreshTerrainTileOnZooming && h.needToRefreshTerrainTileOnZooming(), c = o || l && i.renderedZoom !== n.getZoom();
        if (a && !c) return !1;
        const u = r.getSpatialReference(), {x: f, y: d, z: m, res: g, offset: p} = e;
        let w = e.nw;
        w || (w = e.nw = this.getMap().pointAtResToCoord(e.extent2d.getMin(pi), e.res));
        const v = this.layer.getTileSize().width, {res: _, zoom: y} = qe(u, m, g), b = We(_, r.getTileSize().width, g, v);
        let x = i.skinTileIds[t];
        if (!x) {
            const e = this.layer._getTileConfig().tileSystem.scale.y;
            x = i.skinTileIds[t] = Be(r, f, d, y, w, p, e, b, Mi);
        }
        const M = x[0];
        let S = !0;
        const C = [];
        for (let t = 0; t < M.length; t++) {
            const e = h.getCachedTile(M[t], !1);
            if (e) C.push(e); else {
                S = !1;
                const e = h.findParentTile(M[t]);
                e && C.push(e);
            }
        }
        const k = i.skinImages[t] || [];
        k.currentSkins = k.currentSkins || new Set;
        const T = new Set;
        let A = !1;
        for (let t = 0; t < k.length; t++) {
            if (!k[t].tile) {
                A = !0;
                continue;
            }
            const e = k[t].tile.info.id;
            T.add(e);
        }
        if (!C.length) return k.currentSkins.clear(), i.skinImages[t] = [], !1;
        const O = C.length ? C.map((t => t.info.id)).join() : C[0].info.id;
        if (!c && !A && k.tileIds === O) return !1;
        k.tileIds = O;
        let I = !1;
        k.currentSkins.clear(), k.length = 0;
        const L = k.currentSkins;
        let E = e.id;
        i.temp && (E += "-temp");
        for (let t = 0; t < C.length; t++) {
            const e = C[t].info.id;
            L.add(e);
            let i = this.es(e);
            i && ((R = i) && R.texture) || (i = {
                tile: ut({}, C[t]),
                layer: r,
                refs: new Set,
                texture: h.createTerrainTexture(this.regl)
            }, this.ss(e, i)), i.refs.add(E), k.push(i), I = !0;
        }
        var R;
        return this.ns(e, i, T, L, s), I && this.Vi++, i.skinImages[t] = k, r.fire("renderterrainskin", {
            tile: e,
            skinTiles: C
        }), S && (i.skinStatus[t] = 1), !0;
    }
    ns(t, e, i, s, n) {
        if (!i.size) return;
        let r = t.id;
        e.temp && (r += "-temp");
        for (const t of i) if (!s || !s.has(t)) {
            const e = this.es(t);
            this.rs(e, r, n);
        }
    }
    es(t) {
        return this.$i || (this.$i = new Map), this.$i.get(t);
    }
    ss(t, e) {
        this.$i.set(t, e);
    }
    qi(t, e) {
        const i = this.getMap();
        if (!t || !i || !e) return;
        const s = e.skinImages, n = this.hs(e.renderedZoom);
        if (e.rendered && !n) return;
        e.skin ? (bi.framebuffer = e.skin, this.regl.clear(bi)) : e.skin = this.os(t, e), 
        this.ls();
        const r = this.layer.options.debug, h = [], o = r && [], l = this.layer.getTileSize().width;
        if (s) for (let e = 0; e < s.length; e++) {
            const i = s[e];
            for (let e = 0; e < i.length; e++) {
                const {tile: s, texture: n, layer: r} = i[e];
                if ((s.info.offset[0] || s.info.offset[1]) && t.skinTileIds) {
                    const e = t.skinTileIds[r.getId()];
                    for (let t = 0; t < e.length; t++) if (s.info.x === e[t].x && s.info.y === e[t].y) {
                        s.info.offset = e[t].offset;
                        break;
                    }
                }
                const o = Ci(t, s, l), c = i[e].skinMesh || new a.Mesh(this.cs);
                c.setUniform("skinTexture", n);
                const u = r.getOpacity();
                c.setUniform("opacity", ft(u) ? 1 : u), c.setUniform("skinDim", o), c.setUniform("tileSize", l), 
                c.setUniform("x", t.x), c.setUniform("y", t.y), i[e].skinMesh = c, h.push(c);
            }
        }
        if (r) {
            const i = e.skinDebugMesh || new a.Mesh(this.cs);
            i.setUniform("tileSize", l);
            const s = e.debugTexture || this.us(t, l, e.temp);
            e.debugTexture = s, e.skinDebugMesh = i, i.setUniform("opacity", 1), i.setUniform("skinTexture", s), 
            i.setUniform("skinDim", [ 0, 0, 1 ]), i.setUniform("tileSize", l), o.push(i);
        }
        if (h.length) {
            this.fs.setMeshes(h);
            try {
                this.renderer.render(this.ds, null, this.fs, e.skin);
            } catch (t) {
                throw console.error(e), t;
            }
        }
        o && o.length && this.layer.options.debug && (this.fs.setMeshes(o), this.renderer.render(this.ds, null, this.fs, e.skin)), 
        e.rendered = this.gs(e), e.renderedZoom = i.getZoom();
    }
    us(t, e, i) {
        e *= 2;
        const {x: s, y: n, z: r} = t, h = `terrain:${s}/${n}/${r}` + (i ? "-temp" : ""), o = document.createElement("canvas");
        o.width = e, o.height = e;
        const a = o.getContext("2d");
        a.font = "20px monospace";
        const l = this.layer.options.debugOutline;
        return a.fillStyle = l, a.strokeStyle = l, a.fillText(h, 20, e - 40), a.beginPath(), 
        a.lineWidth = 4, a.moveTo(0, 0), a.lineTo(e, 0), a.lineTo(e, e), a.lineTo(0, e), 
        a.lineTo(0, 0), a.stroke(), this.regl.texture({
            data: o,
            flipY: !0,
            mag: "linear",
            min: "linear"
        });
    }
    os(t) {
        const e = this.layer.getTileSize().width, i = 2 * e, s = 2 * e, n = this.regl, r = t.colorsTexture;
        let h;
        h = r && r instanceof Uint8Array ? n.texture({
            data: r,
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: i,
            height: s,
            flipY: !0
        }) : n.texture({
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: i,
            height: s,
            flipY: !0
        });
        const o = {
            width: i,
            height: s,
            colors: [ h ],
            colorFormat: "rgba",
            ignoreStatusCheck: !0,
            depthStencil: !1,
            depth: !1,
            stencil: !1
        }, a = n.framebuffer(o);
        return a.colorTex = h, a;
    }
    Bi(t) {
        this.ji.endFrame(t) && !Object.keys(this.tilesLoading).length && this.layer.fire("terrainreadyandrender");
    }
    Di(t, e) {
        const {image: i, info: s} = t, n = i.data, r = n.width, {extent2d: h, res: o} = s, {extent2d: a, res: l} = e, c = h.getWidth(), u = h.getHeight();
        let f = (a.xmin * l / o - h.xmin) / c * (r - 1), d = (h.ymax - a.ymax * l / o) / u * (r - 1);
        const m = (a.xmax * l / o - h.xmin) / c * (r - 1);
        let g = Math.round(m - f);
        const p = Math.log2(g);
        g = Math.pow(2, Math.round(p)) + 1, f = Math.floor(f), d = Math.floor(d);
        const w = new Float32Array(g * g);
        let v = 1 / 0, _ = -1 / 0;
        for (let t = 0; t < g; t++) for (let e = 0; e < g; e++) {
            let i = t + f, s = e + d;
            i > r - 1 ? i = r - 1 : i < 0 && (i = 0), s > r - 1 ? s = r - 1 : s < 0 && (s = 0);
            const h = n.data[i + s * r];
            w[t + e * g] = h, h < v && (v = h), h > _ && (_ = h);
        }
        return {
            width: g,
            height: g,
            data: w,
            min: v,
            max: _
        };
    }
    getTileOpacity(t) {
        return this.gs(t) ? super.getTileOpacity(t) : (this.resetTileLoadTime(t), 0);
    }
    gs(t) {
        const e = this.layer.getSkinCount();
        if (!e) return !0;
        if (!t.skinStatus) return !1;
        for (let i = 0; i < e; i++) if (!t.skinStatus[i]) return !1;
        return !0;
    }
    hs(t) {
        const e = this.getMap().getZoom(), i = this.layer.getSkinLayers();
        for (let s = 0; s < i.length; s++) {
            const n = i[s] && i[s].getRenderer();
            if (n) {
                if (n.isAnimating && n.isAnimating()) return !0;
                if (n.needToRefreshTerrainTileOnZooming && n.needToRefreshTerrainTileOnZooming() && t !== e) return !0;
            }
        }
        return !1;
    }
    isValidCachedTile(t) {
        const e = !t.image.skinStatus;
        return t.image && !t.image.temp && (e || this.gs(t.image));
    }
    isTileComplete(t) {
        return t.image && !t.image.temp && this.gs(t.image);
    }
    ps() {
        const t = this.layer.options, e = this.layer.getTileSize().width;
        return ft(t.terrainWidth) ? e / 4 + 1 : t.terrainWidth;
    }
    ws(t, e) {
        const i = this.layer.options.maxAvailableZoom - this.layer.options.zoomOffset, s = t.z - i, n = Math.pow(2, s), r = Math.floor(t.x / n), h = Math.floor(t.y / n), o = Math.floor(t.idx / n), a = Math.floor(t.idy / n), l = ki(r, h);
        this.vs || (this.vs = {});
        const c = !this.vs[l];
        return c && e && (this.vs[l] = new Set, this.vs[l].url = this.layer.getTileUrl(r, h, i + this.layer.options.zoomOffset)), 
        {
            x: r,
            y: h,
            idx: o,
            idy: a,
            requests: this.vs[l],
            isFirst: c,
            key: l
        };
    }
    loadTile(e) {
        const i = this.layer, s = this.ps(), n = i.getSpatialReference().getResolution(e.z);
        let r = this.getMap().pointAtResToDistance(1, 1, n);
        const h = i.options.zoomOffset || 0, o = i.options.maxAvailableZoom && i.options.maxAvailableZoom - h;
        if (o && e.z > o) {
            const t = this.Fi(e);
            if (-1 !== t.sourceZoom) return this.onTileLoad(t, e), t;
            {
                const {requests: s, isFirst: n, x: h, y: a, idx: l, idy: c} = this.ws(e, !0);
                if (s.add(e), !n) return t;
                const u = e.z - o;
                r *= Math.pow(2, u);
                const f = [ h, a, o, l, c, e.res * Math.pow(2, u), e.error * Math.pow(2, u) ];
                e = i.createTileNode ? i.createTileNode(...f) : i._s(...f);
            }
        }
        const a = e.url, l = {}, c = i.options, u = i.getTileSize(), f = {
            terrainWidth: s,
            type: c.type,
            accessToken: c.accessToken,
            cesiumIonTokenURL: c.cesiumIonTokenURL,
            error: r,
            colors: c.colors,
            tileSize: u ? [ u.width, u.height ] : [ 256, 256 ]
        };
        return this.workerConn.fetchTerrain(a, f, ((i, s) => {
            if (this.vs) {
                const t = ki(e.x, e.y), i = this.vs[t];
                if (i && i.size) {
                    this.tileCache.add(e.id, {
                        info: e,
                        image: l
                    });
                    for (const t of i) this.removeTileLoading(t);
                }
                delete this.vs[t];
            }
            if (i) {
                if (i.canceled) return;
                return console.warn(i), void this.onTileError(l, e);
            }
            t.Util.extend(l, s), function(t, e = 1) {
                if (ft(e) || !t || !t.mesh || 1 === e) return;
                const i = t.mesh.positions;
                if (i) for (let t = 0, s = i.length; t < s; t += 3) i[t + 2] *= e;
            }(l, this.layer.options.exaggeration), e.colorsTexture = l.colorsTexture, this.onTileLoad(l, e);
        })), l;
    }
    deleteTile(t) {
        if (!t || !t.image) return;
        super.deleteTile(t);
        const {info: e, image: i} = t;
        i.temp || (delete e.skinTileIds, this.Zi(t.info, i));
    }
    Zi(t, e) {
        const i = e.skin;
        i && (i.destroy(), i.colorTex.destroy(), delete i.colorTex), e.debugTexture && (e.debugTexture.destroy(), 
        delete e.debugTexture, e.skinDebugMesh.dispose(), delete e.skinDebugMesh);
        const s = e.skinImages;
        if (s && s.length) {
            let i = t.id;
            e.temp && (i += "-temp");
            for (let t = 0; t < s.length; t++) {
                const e = s[t];
                if (e) {
                    for (let t = 0; t < e.length; t++) {
                        if (!e[t] || !e[t].tile) continue;
                        const s = e[t].tile.info.id, n = this.$i && this.$i.get(s);
                        n && this.rs(n, i);
                    }
                    e.length = 0;
                }
            }
        }
        e.terrainMesh && this.ji.deleteMesh(e.terrainMesh), e.image && e.image.close && e.image.close(), 
        delete e.skinImages, delete e.skin, delete e.skinStatus, delete e.skinTileIds, delete e.terrainMesh, 
        delete e.image, delete e.data, delete e.mesh, delete e.rendered;
    }
    rs(t, e, i) {
        t && (t.refs.delete(e), t.refs.size || (i ? i.push(t) : this.Yi(t)));
    }
    Yi(t) {
        if (!t || !t.tile) return;
        const e = t.tile.info.id, i = t.layer.getRenderer();
        delete t.canvas, delete t.layer, t.refs.clear(), t.texture && (i ? i.deleteTerrainTexture(t.texture) : t.texture.destroy && t.texture.destroy(), 
        delete t.texture), t.skinMesh && (t.skinMesh.dispose(), delete t.skinMesh), i && (i.removeTileCache && i.removeTileCache(e), 
        i.deleteTile && i.constructor.prototype.deleteTile.call(i, t.tile)), delete t.tile, 
        this.$i.delete(e);
    }
    ys() {
        if (!this.$i) return;
        const t = this.$i.keys();
        for (const e of t) {
            const t = this.es(e);
            this.Yi(t);
        }
        this.$i.clear();
    }
    abortTileLoading(t, e) {
        const i = this.layer, s = i.options.maxAvailableZoom && i.options.maxAvailableZoom - i.options.zoomOffset;
        if (e) if (s && e.z > s) {
            const {requests: t, key: i} = this.ws(e);
            t && t.size && (t.delete(e), t.size || (delete this.vs[i], this.workerConn && this.workerConn.abortTerrain(t.url)));
        } else e && e.url && this.workerConn && this.workerConn.abortTerrain(e.url);
        super.abortTileLoading(t, e);
    }
    onTileError(t, e) {
        super.onTileError(t, e);
    }
    bs(t) {
        const e = this.getCurrentTileZoom(), i = this.layer.getSpatialReference().getResolution(e), s = this.layer._getTileConfig().getTileIndex(t, i, this.layer.options.repeatWorld);
        return s.z = e, s;
    }
    xs(t, e, i, s, n) {
        const r = this.layer.getMinZoom(), h = this.Ms(e, i.x, i.y, i.z, r);
        if (h && h.image && h.image.data) {
            const e = h.info.extent2d, r = h.info.res / n, o = s.x - e.xmin * r, a = e.ymax * r - s.y, l = this.Ss(h.image.data, o / (e.getWidth() * r), a / (e.getHeight() * r));
            t[0] = l, t[1] = null === l ? 0 : +(h.info.z === i.z);
        } else t[0] = null, t[1] = 0;
        return t;
    }
    Ms(t, e, i, s, n) {
        t || (t = this.layer._getTileId(e, i, s));
        const r = this.tilesInView[t] || this.tileCache.get(t);
        return !r && s - 1 >= n ? this.Ms(null, Math.floor(e / 2), Math.floor(i / 2), s - 1, n) : r;
    }
    Ss(t, e, i) {
        const {width: s, height: n, data: r} = t, h = Math.floor((s - 1) * e), o = Math.floor((n - 1) * i) * s + h;
        return void 0 === r[o] ? null : r[o];
    }
    Cs(t, e, i) {
        t || (t = {
            tiles: {},
            dirty: !0,
            complete: !1
        });
        const s = this.layer, n = this.getCurrentTileZoom(), r = s.getSpatialReference().getResolution(n), {xmin: h, ymin: o, xmax: a, ymax: l} = e, c = s._getTileConfig();
        pi.set(h, o).ks(i);
        const u = c._getTileNum(pi, i, !0);
        wi.set(a, l).ks(i);
        const f = c._getTileNum(wi, i, !0), d = Math.min(u.x, f.x), m = Math.max(u.x, f.x), g = Math.min(u.y, f.y), p = Math.max(u.y, f.y), w = i / r;
        pi.set(h, o).ks(w), wi.set(a, l).ks(w);
        const v = vi.set(pi.x, pi.y, wi.x, wi.y), _ = s.getTileSize().width + 1;
        v.Ts(v.getWidth() / _), t.array = t.array || new Float32Array(_ * _);
        const y = t.tiles;
        t.complete = !0, t.array.fill(0);
        for (let e = d; e <= m; e++) for (let i = g; i <= p; i++) {
            const s = this.layer._getTileId(e, i, n);
            if (y[s]) continue;
            const r = this.tileCache.get(s);
            r ? (this.As(t.array, r, v, _), t.dirty = !0, y[s] = 1) : (t.dirty = t.dirty || void 0 !== t.tiles[s], 
            t.tiles[s] && delete t.tiles[s], t.complete = !1);
        }
        return t;
    }
    As(t, e, i, s) {
        const n = e.info.extent2d, r = n.intersection(i), {xmin: h, ymin: o, xmax: a, ymax: l} = r, {data: c} = e.image, u = c.width, f = i.getWidth() / s, d = Math.floor((h - i.xmin) / f), m = Math.floor((o - i.ymin) / f), g = Math.floor((a - i.xmin) / f) - d, p = Math.floor((l - i.ymin) / f) - m, w = n.getWidth() / u, v = Math.floor((h - n.xmin) / w), _ = Math.floor((o - n.ymin) / w), y = Math.floor(f / w);
        for (let e = 0; e <= g; e++) for (let i = 0; i <= p; i++) {
            const n = e + d + (m + i) * s;
            let r = 0;
            for (let t = 0; t < y; t++) for (let s = 0; s < y; s++) {
                const n = (v + Math.floor(e * y)) * u + t + _ + Math.floor(i * y) + s;
                r += c.data[n];
            }
            t[n] = r / Math.max(y, 1);
        }
        return t;
    }
    clear() {
        return this.clearTempResources(), super.clear();
    }
    clearTempResources() {
        this.Ji && (this.Ji.reset(), delete this.Ji), this.$i && this.ys();
    }
    onAdd() {
        super.onAdd(), this.prepareWorker();
    }
    onRemove() {
        this.workerConn && (this.workerConn.removeLayer(this.layer.getId(), (t => {
            if (t) throw t;
        })), this.workerConn.remove(), delete this.workerConn), this.clearTempResources(), 
        this.ds && (this.ds.dispose(), delete this.ds), this.cs && (this.cs.dispose(), delete this.cs), 
        delete this.vs, super.onRemove(), this.ji && (this.ji.delete(), delete this.ji);
    }
    prepareWorker() {
        const t = this.layer.getMap();
        this.workerConn || (this.workerConn = new De(t.id));
        const e = this.workerConn;
        if (!e.isActive()) return;
        const i = this.layer.options || {}, s = this.layer.getId();
        e.addLayer(s, i, (t => {
            if (t) throw t;
            this.layer && (this.ready = !0, this.setToRedraw(), this.layer.fire("workerready"));
        }));
    }
    createContext() {
        this.canvas.gl && this.canvas.gl.wrap ? (this.gl = this.canvas.gl.wrap(), this.regl = this.canvas.gl.regl) : this.Os(), 
        this.renderer = new a.Renderer(this.regl), this.layer.fire("contextcreate", {
            regl: this.regl
        });
    }
    zi() {
        const t = this.ji;
        "lit" === this.layer.options.shader || "pbr" === this.layer.options.shader ? (t && t.constructor === ii || !t) && (t && (t.delete(), 
        this.clear(), this.setToRedraw()), this.ji = new ai(this.layer), this.layer.fire("paintercreated")) : (t && t.constructor === ai || !t) && (t && (t.delete(), 
        this.clear(), this.setToRedraw()), this.ji = new ii(this.layer), this.layer.fire("paintercreated"));
    }
    Os() {
        const t = this.layer, e = t.options.glOptions || {
            alpha: !0,
            depth: !0,
            antialias: this.layer.options.antialias
        };
        e.preserveDrawingBuffer = !0, e.stencil = !0, this.glOptions = e, this.gl = this.gl || this.Is(this.canvas, e), 
        this.regl = v({
            gl: this.gl,
            attributes: e,
            extensions: [ "OES_element_index_uint" ],
            optionalExtensions: t.options.glExtensions
        });
    }
    Is(t, e) {
        const i = [ "webgl", "experimental-webgl" ];
        let s = null;
        for (let n = 0; n < i.length; ++n) {
            try {
                s = t.getContext(i[n], e);
            } catch (t) {}
            if (s) break;
        }
        return s;
    }
    resizeCanvas(t) {
        this.canvas && super.resizeCanvas(t);
    }
    clearCanvas() {
        this.canvas && super.clearCanvas();
    }
    ls() {
        if (this.ds) return;
        const t = this.layer.getTileSize().width;
        this.ds = new a.MeshShader({
            vert: "#define SHADER_NAME TERRAIN_SKIN\nattribute vec2 aPosition;\nvoid main() {\n    gl_Position = vec4(aPosition, 0.0, 1.0);\n}",
            frag: "#define SHADER_NAME TERRAIN_SKIN\nprecision mediump float;\nuniform float tileSize;\nuniform sampler2D skinTexture;\nuniform vec3 skinDim;\nuniform float opacity;\nvoid main() {\n    vec2 fragCoord = gl_FragCoord.xy / 2.0;\n    vec2 resolution = vec2(tileSize);\n    vec2 uv = (fragCoord - skinDim.xy) /  (resolution * skinDim.z);\n    if (uv.x >= 0.0 && uv.x <= 1.0 && uv.y >= 0.0 && uv.y <= 1.0) {\n        gl_FragColor = texture2D(skinTexture, uv) * opacity;\n    } else {\n        gl_FragColor = vec4(0.0);\n    }\n}",
            extraCommandProps: {
                cull: {
                    enable: !1
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: 2 * t,
                    height: 2 * t
                },
                depth: {
                    enable: !1
                },
                stencil: {
                    enable: !1
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "one",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        });
        const e = new Int8Array([ -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1 ]);
        this.cs = this.cs || new a.Geometry({
            aPosition: e
        }, 0, 6, {
            positionSize: 2
        }), this.cs.generateBuffers(this.regl), this.fs = this.fs || new a.Scene;
    }
    updateMaterial(t) {
        this.ji && t && this.ji.updateMaterial && (void 0 === this.Ii && (this.Ii = 1), 
        this.ji.updateMaterial(t, this.Ii++));
    }
    setMaterial(t) {
        this.ji && t && this.ji.setMaterial && (void 0 === this.Ii && (this.Ii = 1), this.ji.setMaterial(t, this.Ii++));
    }
    getAnalysisMeshes() {
        return this.ji && this.ji.yi ? this.ji.yi.getMeshes() : [];
    }
}

const Mi = 1;

function Si(t, e, i, s, n, r, h, o, a = 0) {
    t.font = "20px monospace", t.fillStyle = i, yi.y = o - 30, t.globalAlpha = 1, t.fillText(e, yi.x + n, yi.y + r + a), 
    t.globalAlpha = .6, t.strokeStyle = i, t.lineWidth = s, t.beginPath(), t.moveTo(n, r), 
    t.lineTo(n + h, r), t.lineTo(n + h, r + o), t.lineTo(n, r + o), t.lineTo(n, r), 
    t.stroke(), t.globalAlpha = 1;
}

function Ci(t, e, i) {
    const {res: s, extent2d: n, offset: r} = t, {info: h} = e, o = h.res / s, a = h.offset, l = h.extent2d.xmin * o, c = h.extent2d.ymin * o, u = r[0] - a[0], f = a[1] - r[1];
    return [ l - n.xmin + u, -(n.ymin - c + f), o * h.tileSize / i ];
}

function ki(t, e) {
    return t + "-" + e;
}

t.renderer.TileLayerCanvasRenderer.include({
    renderTerrainSkin(t, e, i) {
        const s = this.layer.getTileSize().width, n = e.options.debug;
        for (let t = 0; t < i.length; t++) {
            const {tile: e, texture: r} = i[t];
            if (!e.image) continue;
            const h = document.createElement("canvas");
            i[t].canvas = h, h.width = s, h.height = s;
            const o = h.getContext("2d");
            if (o.drawImage(e.image, 0, 0), n) {
                const {x: t, y: i, z: n} = e.info;
                Si(o, `${t}/${i}/${n}`, "yellow", 1, 0, 0, s, s, -18);
            }
            r({
                data: h,
                width: s,
                height: s,
                flipY: !0,
                min: "linear mipmap linear",
                mag: "linear"
            });
        }
    },
    createTerrainTexture(t) {
        const e = this.layer.getTileSize().width, i = {
            width: e,
            height: e,
            flipY: !0,
            min: "linear mipmap linear",
            mag: "linear",
            depthStencil: !1,
            depth: !1,
            stencil: !1
        };
        return t.texture(i);
    },
    deleteTerrainTexture(t) {
        t.destroy();
    }
});

const Ti = {
    "clip-inside": .1,
    "clip-outside": .2,
    "flat-inside": .3,
    "flat-outside": .4,
    "color": .5,
    "video": .6,
    "elevate": .7
}, Ai = [], Oi = [ 1, 1, 1 ], Ii = {
    polygonFill: [ 255, 0, 0 ],
    polygonOpacity: .8
}, Li = new e(0, 0), Ei = new e(0, 0), Ri = [], Fi = new e(0, 0), Pi = new s(0, 0), Hi = new s(0, 0), Di = new s(0, 0);

class Gi extends n {
    getMode() {
        return this.Ls;
    }
    remove() {
        const t = this.getLayer();
        return t ? (t.removeMask(this), this.Es(), super.remove(), this) : this;
    }
    getMesh(t, e, i) {
        return this.isVisible() ? (this.xt || (this.xt = this.Pi(t, e, i)), this.Rs(this.xt, e, i), 
        this.xt) : null;
    }
    Fs(t) {
        const e = this.getMap(), i = this.toGeoJSON(), s = m.flatten(i.geometry.coordinates), n = s.dimensions;
        for (let t = 0; t < s.vertices.length; t += n) {
            Fi.x = s.vertices[t], Fi.y = s.vertices[t + 1];
            const i = bt(e, Fi);
            s.vertices[t] = i[0], s.vertices[t + 1] = i[1];
        }
        const r = bt(e, this.getCenter()), h = [], o = "video" === this.getMode() ? 4 : s.vertices.length / n;
        for (let t = 0; t < o; t++) h.push(s.vertices[t * n] - r[0]), h.push(s.vertices[t * n + 1] - r[1]), 
        h.push(0);
        const l = m(h, s.holes, 3), c = new a.Geometry({
            POSITION: h,
            TEXCOORD: this.Ps(s.vertices, n)
        }, l, 0, {
            positionAttribute: "POSITION",
            uv0Attribute: "TEXCOORD"
        });
        return c.generateBuffers(t), c;
    }
    Ps(t, e) {
        const i = [ 0, 0, 1, 0, 1, 1, 0, 1 ];
        if (this.hasHoles()) {
            const s = t.length / e * 2;
            for (let t = i.length / 2 - 1; t < s; t += 2) i[t] = i[t + 1] = 0;
        }
        return i;
    }
    clearMesh() {
        this.Es(), delete this.xt, this.maskGeoJSON && (this.maskGeoJSON = null);
    }
    Hs() {
        return Ti[this.Ls];
    }
    Ds() {
        const t = this.getSymbol(), {polygonFill: e, polygonOpacity: i} = t || Ii, s = _t([], e);
        return s[0] /= 255, s[1] /= 255, s[2] /= 255, s[3] = dt(i) ? i : Ii.polygonOpacity, 
        s;
    }
    Gs(t = 0) {
        const e = this.getMap(), i = e.getGLRes();
        return e.altitudeToPoint(t, i);
    }
    Ns(t) {
        const e = bt(this.getMap(), this.getCenter()), i = l.fromRotationTranslationScale(t.localTransform, d.identity(Ai), e, Oi);
        t.localTransform = i;
    }
    Es() {
        this.xt && (this.xt.material && this.xt.material.dispose(), this.xt.geometry && this.xt.geometry.dispose(), 
        this.xt.dispose(), delete this.xt);
    }
    containsPoint(t) {
        const e = this.getExtent();
        if (Fi.set(t[0], t[1]), !e || !e.contains(Fi)) return !1;
        const i = this.getHoles();
        for (let e = 0; e < i.length; e++) if (this.js(i[e], t)) return !1;
        const s = this.getShell();
        return this.js(s, t);
    }
    js(t, e) {
        const i = this.zs(t);
        let s = 0;
        for (let i = 0; i < t.length; i++) {
            Li.x = t[i].x, Li.y = t[i].y;
            const n = i + 1 >= t.length ? 0 : i + 1;
            Ei.x = t[n].x, Ei.y = t[n].y, Fi.x = e[0], Fi.y = e[1], Ri[0] = Fi, Ri[1] = Li, 
            Ri[2] = Ei;
            s += this.zs(Ri);
        }
        return !(Math.abs(s - i) > 1e-8);
    }
    zs(t) {
        const e = this.getMap();
        let i = 0;
        const s = e.getGLRes(), n = e.coordToPointAtRes(t[0], s, Pi);
        for (let a = 1; a < t.length - 1; a++) {
            const l = e.coordToPointAtRes(t[a], s, Hi), c = e.coordToPointAtRes(t[a + 1], s, Di);
            i += (r = n, o = c, (((h = l).x - r.x) * (o.y - r.y) - (h.y - r.y) * (o.x - r.x)) / 2);
        }
        var r, h, o;
        return i;
    }
}

const Ni = [ "shapechange", "heightrangechange", "flatheightchange" ], ji = new e(0, 0), zi = [ 0, 0, 0 ], Bi = [ 0, 0, 0 ];

function Ui() {
    return this._maskList ? (this._maskList.forEach((t => {
        t.remove();
    })), this._maskList = [], this.updateMaskExtent("shapechange"), this) : this;
}

function Vi(t) {
    const e = this.getMap(), i = e.getView(), s = e.getFitZoom(t), n = t.getCenter();
    e.setView({
        center: n,
        zoom: s,
        pitch: 0,
        bearing: 0
    });
    const r = e.getExtent(), h = l.copy([ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ], e.projViewMatrix);
    return e.setView(i), {
        mapExtent: r,
        projViewMatrix: h
    };
}

function Wi() {
    for (let t = 0; t < this._maskList.length; t++) if (this._maskList[t].isVisible()) return !0;
    return !1;
}

function qi(t) {
    return class extends t {
        removeMask(t) {
            if (!this._maskList) return this;
            if (!t) return Ui.call(this), this;
            const e = Array.isArray(t) ? t : [ t ];
            for (let t = 0; t < e.length; t++) {
                const i = e[t], s = this._maskList.indexOf(i);
                s > -1 && this._maskList.splice(s, 1);
            }
            return this.updateMaskExtent("shapechange"), this.fire("removemask", {
                masks: t
            }), this;
        }
        setMask(t) {
            return this.removeMask(null), this._maskList || (this._maskList = []), Array.isArray(t) ? t.forEach((t => {
                this._maskList.push(t);
            })) : this._maskList.push(t), this._maskList.forEach((t => {
                t._bindLayer(this), t.Bs && t.Bs();
            })), this.updateMaskExtent("shapechange"), this.fire("setmask", {
                masks: t
            }), this;
        }
        onAdd() {
            super.onAdd(), this.updateMaskExtent("shapechange");
        }
        getMasks() {
            return this._maskList || [];
        }
        onGeometryEvent(t) {
            if (!t || !t.target) return;
            const e = t.type;
            "shapechange" === e && t.target instanceof Gi && t.target.clearMesh(), t.target instanceof Gi && Ni.indexOf(e) > -1 && this.updateMaskExtent(e), 
            super.onGeometryEvent && super.onGeometryEvent(t);
        }
        identifyMask(t, e) {
            if (!this.getMap()) return [];
            if (!this._maskList || !this._maskList.length) return [];
            const i = ut({}, e);
            i.excludeMasks = !0;
            const s = this.identifyAtPoint(t, i), n = s.length && s[0].coordinate;
            if (n) {
                const t = this._maskList;
                if (!t) return [];
                const e = [];
                for (let i = 0; i < t.length; i++) {
                    const s = t[i].getMode();
                    !t[i].containsPoint(n) || "color" !== s && "video" !== s || e.push(t[i]);
                }
                return e;
            }
            return [];
        }
        remove() {
            this._maskList && this._maskList.length && this._maskList.forEach((t => {
                t.remove();
            })), super.remove();
        }
        updateMask(t) {
            const e = this.getMap(), {projViewMatrix: i, mapExtent: s} = Vi.call(this, t);
            ji.x = s.xmin, ji.y = s.ymin;
            const n = $i(zi, ji, e);
            ji.x = s.xmax, ji.y = s.ymax;
            const r = $i(Bi, ji, e);
            return {
                projViewMatrix: i,
                extentInWorld: [ n[0], n[1], r[0], r[1] ]
            };
        }
        updateMaskExtent(t) {
            if (!this._maskList) return;
            if (!this.getMap()) return;
            const e = this.getRenderer();
            if (e && !this._maskList.length) return void e._clearMask();
            if (e && !Wi.call(this)) return e._deleteMaskUniforms(), void e.setToRedraw();
            const i = this.getMaskExtent();
            if (!i) return;
            const {extent: s, ratio: n, minHeight: r} = i;
            if (t || !this.Us || !this.Vs) {
                const {projViewMatrix: t, extentInWorld: e} = this.updateMask(s);
                this.Us = t, this.Vs = e;
            }
            e ? e.setMask(this.Vs, this.Us, n, r) : this.once("renderercreate", (t => {
                t.renderer.setMask(this.Vs, this.Us, n, r);
            }));
        }
        getMaskExtent() {
            let t = 1 / 0, e = 1 / 0, i = -1 / 0, s = -1 / 0, n = -1 / 0, h = 1 / 0, o = !1;
            const a = this.getMap().getExtent();
            for (let r = 0; r < this._maskList.length; r++) {
                const l = this._maskList[r];
                if (!l.isVisible()) continue;
                const c = l.getExtent();
                if (c && a.intersects(c) && (o = !0, c.xmin < t && (t = c.xmin), c.ymin < e && (e = c.ymin), 
                c.xmax > i && (i = c.xmax), c.ymax > s && (s = c.ymax), l.Ws)) {
                    const t = l.Ws();
                    t[0] < h && (h = t[0]), t[1] > n && (n = t[1]);
                }
            }
            if (!o) return null;
            const {ratio: l, minHeight: c} = function(t, e) {
                const i = t === 1 / 0 ? 0 : t, s = e === -1 / 0 ? 0 : e, n = Math.abs(s - i);
                return 0 === n ? {
                    ratio: 1,
                    minHeight: 0
                } : {
                    ratio: Math.pow(n, -1),
                    minHeight: i
                };
            }(h, n);
            return {
                extent: new r(t, e, i, s),
                ratio: l,
                minHeight: c
            };
        }
    };
}

function $i(t, i, s, n = 0) {
    if (!(s && i instanceof e)) return null;
    const r = s.coordinateToPointAtRes(i, s.getGLRes());
    return t[0] = r.x, t[1] = r.y, t[2] = n, t;
}

const Yi = new t.Coordinate(0, 0), Xi = new t.Coordinate(0, 0), Ji = new t.Point(0, 0), Zi = [], Ki = {
    tileGrids: [],
    count: 0
}, Qi = "01", ts = "1";

class es extends(qi(t.TileLayer)){
    constructor(t, e) {
        e && !e.tileSystem && ("cesium" === e.type || "cesium-ion" === e.type ? e.tileSystem = [ 1, 1, -180, -90 ] : "tianditu" === e.type && (e.tileSystem = [ 1, -1, -180, 90 ])), 
        e.tileSize || "mapbox" === e.type && (e.tileSize = 512), super(t, e);
    }
    onAdd() {
        const t = this.options, e = this.getMap().getProjection(), i = "EPSG:4326" === e.code || "EPSG:4490" === e.code, s = "EPSG:3857" === e.code;
        512 !== t.tileSize || t.spatialReference || ("mapbox" === t.type ? i ? t.spatialReference = "preset-4326-512" : s && (t.spatialReference = "preset-3857-512") : "cesium" === t.type || "cesium-ion" === t.type ? t.spatialReference = "preset-4326-512" : "tianditu" === t.type && (t.spatialReference = {
            "projection": "EPSG:4326",
            "fullExtent": {
                "top": 90,
                "left": -180,
                "bottom": -90,
                "right": 180
            },
            "resolutions": function() {
                const t = [];
                for (let e = 0; e <= 22; e++) t[e] = 90 / (128 * Math.pow(2, e));
                return t;
            }()
        })), t.terrainWidth || "tianditu" !== t.type || (t.terrainWidth = 65);
    }
    getTileUrl(t, e, i) {
        let s = super.getTileUrl(t, e, i);
        return "mapbox" === this.options.type && this.options.requireSkuToken && (this.qs || (this.qs = this.$s()), 
        s.indexOf("?") > -1 ? s += "&sku=" + this.qs : s += "?sku=" + this.qs), s;
    }
    getMaxAvailableZoom() {
        return this.getSpatialReference().getMaxZoom();
    }
    $s() {
        let t = "";
        for (let e = 0; e < 10; e++) t += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
        return [ ts, Qi, t ].join("");
    }
    setSkinLayers(t) {
        this.Ys = t;
        const e = this.getRenderer();
        e && (e.clear(), e.setToRedraw());
    }
    getSkinTiles(e) {
        const i = this.getRenderer();
        if (!i) return Ki;
        const s = i.getTileGridsInCurrentFrame().tileGrids[0];
        if (!s) return Ki;
        const n = e.getId(), r = this._getTileConfig().tileSystem.scale, h = e.getTileSize().width, o = s.tiles;
        if (!o.length) return Ki;
        const a = this.getMap(), l = s.parents || Zi, c = l.length, u = l.concat(o), f = e.getSpatialReference(), d = o[0].extent2d.getWidth(), m = r.x, g = r.y, p = [], w = [], v = new Set, _ = this._getTileConfig().tileSystem.scale.y;
        for (let i = 0; i < u.length; i++) {
            const s = u[i], {res: r} = s;
            let o = s.nw;
            o || (o = s.nw = a.pointAtResToCoord(s.extent2d.getMin(Ji), s.res));
            const {res: l, zoom: y} = qe(f, s.z, r), b = l / r, x = We(l, h, r, d), {extent2d: M, offset: S} = s, C = x * s.x, k = x * s.y;
            if (s.skinTileIds || (s.skinTileIds = {}), !s.skinTileIds[n]) {
                const i = new Set, r = [], a = Ve(e, s.x, s.y, y, o, S, g, x, 0);
                for (let s = 0; s < a.length; s++) {
                    const n = a[s];
                    if (i.has(n.id)) continue;
                    n.idx = n.x, n.idy = n.y, n.res = l, n.url = e.getTileUrl(n.x, n.y, n.z + e.options.zoomOffset);
                    const o = m * (n.x - C) * h, c = g * (n.skinY - k) * h, u = M.xmin * b + o, f = M.ymax * b + c, d = M.ymin * b + c;
                    n.extent2d = _ > 0 ? new t.PointExtent(u, d, u + h, d + h) : new t.PointExtent(u, f - h, u + h, f), 
                    i.add(n.id), r.push(n);
                }
                s.skinTileIds[n] = r;
            }
            const T = s.skinTileIds[n];
            for (let t = 0; t < T.length; t++) v.has(T[t].id) || (i < c ? p.push(T[t]) : w.push(T[t]), 
            v.add(T[t].id));
        }
        return {
            tileGrids: [ {
                extent: s.extent,
                tiles: w,
                parents: p,
                count: w.length
            } ],
            count: w.length
        };
    }
    getSkinLayer(t) {
        return this.getSkinLayers()[t];
    }
    getSkinLayers() {
        return this.Ys || Zi;
    }
    getSkinCount() {
        return this.Ys && this.Ys.length || 0;
    }
    queryTerrainByProjCoord(t, e) {
        e = e || [];
        const i = this.getRenderer();
        if (!i) return e[0] = null, e[1] = 0, e;
        const s = this.getMap(), n = i.bs(t);
        if (!n) return e[0] = null, e[1] = 0, e;
        const r = s._prjToPointAtRes(t, 1, Ji);
        return i.xs(e, n.id, n, r, 1);
    }
    queryTileTerrainByProjCoord(t, e, i, s) {
        s = s || [];
        const n = this.getRenderer();
        if (!n) return s[0] = null, s[1] = 0, s;
        const r = this.getMap()._prjToPointAtRes(t, 1, Ji);
        return n.xs(s, e, i, r, 1);
    }
    queryTileTerrainByPointAtRes(t, e, i, s, n) {
        n = n || [];
        const r = this.getRenderer();
        return r ? r.xs(n, i, s, t, e) : (n[0] = null, n[1] = 0, n);
    }
    queryTerrain(t, e) {
        e = e || [];
        if (!this.getRenderer()) return e[0] = null, e[1] = 0, e;
        const i = this.getMap().getProjection().project(t, Yi);
        return this.queryTerrainByProjCoord(i, e);
    }
    queryTileMesh(t, e) {
        const i = this.getRenderer();
        i && i.Xs(t, e);
    }
    getTerrainTiles(e) {
        const {x: i, y: s, z: n, res: r, offset: h} = e, o = e.extent2d.getWidth(), a = this._getTileConfig(), l = this.getSpatialReference(), {res: c, zoom: u} = qe(l, n, r), f = this.getTileSize().width, d = We(c, f, r, o);
        let m = e.nw;
        m || (m = e.nw = this.getMap().pointAtResToCoord(e.extent2d.getMin(Ji), e.res));
        const g = Be(this, i, s, u, m, h, a.tileSystem.scale.y, d, 1)[0];
        for (let e = 0; e < g.length; e++) {
            const {x: i, y: s} = g[e], n = a.getTilePointNW(i, s, c, Ji);
            g[e].res = c, g[e].extent2d = new t.PointExtent(n.x, n.y, n.x + f, n.y - f);
        }
        return g;
    }
    isTerrainTileLoaded(t) {
        const e = this.getRenderer();
        return !!e && e.isTileCached(t);
    }
    updateMaterial(t) {
        if (!t) return;
        this.options.material || (this.options.material = {}), ut(this.options.material, t);
        const e = this.getRenderer();
        e && e.updateMaterial(t);
    }
    setMaterial(t) {
        if (!t) return;
        this.options.material = t;
        const e = this.getRenderer();
        e && e.setMaterial(t);
    }
    _s(t, e, i, s, n, r, h, o, a, l) {
        const c = this.getMap(), u = this.options.zoomOffset;
        if (!a) {
            a = this._getTileConfig().getTilePrjExtent(t, e, r).convertTo((t => c._prjToPointAtRes(t, r, Xi)));
        }
        const f = this._getTileOffset(i);
        return {
            parent: o,
            layer: this.getId(),
            x: t,
            y: e,
            z: i,
            idx: s,
            idy: n,
            res: r,
            extent2d: a,
            id: l || this._getTileId(t, e, i),
            url: this.getTileUrl(t, e, i + u),
            offset: f,
            error: h,
            children: []
        };
    }
}

es.mergeOptions({
    "forceRenderOnMoving": !0,
    "forceRenderOnZooming": !0,
    "forceRenderOnRotating": !0,
    "fadeAnimation": !1,
    "fadeDuration": 1e3 / 60 * 15,
    "tileLimitPerFrame": 2,
    "newTerrainTileRenderLimitPerFrameOnInteracting": 1,
    "opacity": 1,
    "renderer": "gl",
    "pyramidMode": 1,
    "tileSize": 512,
    "terrainWidth": null,
    "backZoomOffset": 0,
    "depthMask": !0,
    "blendSrc": "one",
    "blendDst": "one minus src alpha",
    "requireSkuToken": !0,
    "cesiumIonTokenURL": "https://api.cesium.com/v1/assets/1/endpoint?access_token=",
    "tileRetryCount": 0,
    "shader": "default",
    "terrainTileMode": !0,
    "tempTileCacheSize": 64,
    "tileStackStartDepth": 7,
    "tileStackDepth": 6,
    "currentTilesFirst": !1,
    "exaggeration": 1,
    "colors": []
}), es.registerJSONType("TerrainLayer"), es.registerRenderer("gl", xi);

const is = [], ss = [], ns = [], rs = [], hs = new s(0, 0), os = [], as = [], ls = [], cs = [], us = [], fs = [], ds = [], ms = [], gs = [];

class ps {
    constructor(t, e, i = !0) {
        this.Js = t, this.Zs = e, this.Ks = i;
    }
    setFromPoint(t) {
        this.Js = Array.isArray(t) ? new e(t) : t;
    }
    setToPoint(t) {
        this.Zs = Array.isArray(t) ? new e(t) : t;
    }
    test(e, i, s = {}) {
        const n = s.count || 0, r = [];
        let h = this.Js, o = this.Zs;
        this.Ks && (h = vs(i, this.Js.x, this.Js.y, this.Js.z), o = vs(i, this.Zs.x, this.Zs.y, this.Zs.z));
        const a = new t.math.Ray(h, o);
        for (let t = 0; t < e.length; t++) {
            const s = e[t];
            if (!this.Qs(s.getBoundingBox(), a)) continue;
            const h = s.localTransform, o = s.geometry, c = o.data[o.desc.positionAttribute].array, u = o.data[o.desc.altitudeAttribute] && o.data[o.desc.altitudeAttribute].array || os, f = o.indices;
            if (!(c && c.length && f && f.length)) continue;
            const d = l.multiply(cs, h, s.positionMatrix), m = this.tn(s, a, i, c, u, f, o.desc.positionSize, d, n);
            if (m) {
                const t = {
                    mesh: s,
                    coordinates: m
                };
                if (r.push(t), 0 !== n && r.length >= n) break;
            }
        }
        return r;
    }
    tn(t, e, i, s, n, r, h, o, a) {
        const l = [];
        for (let u = 0; u < r.length && !(u > t.properties.skirtOffset); u += 3) {
            const t = r[u], f = r[u + 1], d = r[u + 2], m = c.set(us, s[t * h], s[t * h + 1], s[t * h + 2]), g = this.en(ss, i, m, n[t] / 100, o), p = c.set(fs, s[f * h], s[f * h + 1], s[f * h + 2]), w = this.en(ns, i, p, n[f] / 100, o), v = c.set(ds, s[d * h], s[d * h + 1], s[d * h + 2]), _ = this.en(rs, i, v, n[d] / 100, o), y = c.set(is, g, w, _), b = c.sub(as, g, w), x = c.sub(ls, g, _), M = this.sn(ms, y, e);
            if (M) {
                const e = i.pointAtResToAltitude(M[2], i.getGLRes());
                hs.x = M[0], hs.y = M[1];
                const s = i.pointAtResToCoordinate(hs, i.getGLRes());
                if (s.z = e, l.push({
                    coordinate: s,
                    indices: [ t, f, d ],
                    normal: c.cross([], b, x)
                }), 0 !== a && l.length >= a) break;
            }
        }
        return l.length ? l : null;
    }
    en(t, e, s, n, r) {
        let h;
        return i.isNumber(n) ? (h = e.altitudeToPoint(n, e.getGLRes()), g.set(t, s[0], s[1], 0, 1), 
        g.transformMat4(t, t, r), t[2] = h) : (g.set(t, s[0], s[1], s[2], 1), g.transformMat4(t, t, r)), 
        t;
    }
    sn(t, e, i) {
        return i.intersectTriangle(e[0], e[1], e[2], !0, t);
    }
    Qs(t, e) {
        return !!t && e.intersectBox(t, gs);
    }
}

const ws = new e(0, 0);

function vs(t, e, i, s) {
    if (!t) return null;
    ws.set(e, i);
    const n = t.coordinateToPointAtRes(ws, t.getGLRes()), r = t.altitudeToPoint(s || 0, t.getGLRes());
    return [ n.x, n.y, r ];
}

const _s = () => {}, ys = new t.Coordinate(0, 0), bs = [ 0, 0, 0 ], xs = [ 0, 0, 0 ], Ms = [ 0, 0, 0 ];

class Ss extends t.Layer {
    static fromJSON(e) {
        if (!e || "GroupGLLayer" !== e.type) return null;
        const i = e.layers.map((e => t.Layer.fromJSON(e)));
        return new Ss(e.id, i, e.options);
    }
    constructor(t, e, i) {
        super(t, i), this.layers = e && e.slice() || [], this.layers.forEach((t => {
            if (t.getMap()) throw new Error(`layer(${t.getId()} is already added on map`);
        })), this.nn(), this.sortLayersByZIndex(), this.rn = {};
    }
    sortLayersByZIndex() {
        if (this.layers && this.layers.length) {
            for (let t = 0, e = this.layers.length; t < e; t++) this.layers[t].__group_gl_order = t;
            this.layers.sort(ks);
        }
    }
    setSceneConfig(t) {
        this.options.sceneConfig = t;
        const e = this.getRenderer();
        return e && e.updateSceneConfig(), this;
    }
    getSceneConfig() {
        return JSON.parse(JSON.stringify(this.u()));
    }
    u() {
        return this.options.sceneConfig || {};
    }
    getGroundConfig() {
        return this.u().ground;
    }
    getWeatherConfig() {
        return this.u().weather;
    }
    addLayer(t, e) {
        if (t.getMap()) throw new Error(`layer(${t.getId()}) is already added on map`);
        if ("gl" !== t.options.renderer) throw new Error(`layer(${t.getId()})'s renderer is canvas, not supported to be added to GroupGLLayer`);
        void 0 === e ? this.layers.push(t) : this.layers.splice(e, 0, t), this.nn(), this.sortLayersByZIndex();
        const i = this.getRenderer();
        return i ? (this.hn(t), this.an(), i.setToRedraw(), this) : this;
    }
    removeLayer(e) {
        t.Util.isString(e) && (e = this.getChildLayer(e));
        const i = this.layers.indexOf(e);
        if (i < 0) return this;
        const s = e.getRenderer();
        s && s.setTerrainHelper && s.setTerrainHelper(null), e._doRemove(), this.ln(e), 
        delete this.rn[e.getId()], this.layers.splice(i, 1);
        const n = this.getRenderer();
        return n ? (this.an(), n.setToRedraw(), this) : this;
    }
    clearLayers() {
        const t = this.getLayers();
        for (let e = 0; e < t.length; e++) t[e] && t[e].remove();
        return this;
    }
    Te() {
        let t = 0;
        for (let e = 0; e < this.layers.length; e++) {
            const i = this.layers[e];
            i.setPolygonOffset && i.getPolygonOffsetCount && (t += i.getPolygonOffsetCount());
        }
        let e = 0;
        for (let i = this.layers.length - 1; i >= 0; i--) {
            const s = this.layers[i];
            s.setPolygonOffset && s.getPolygonOffsetCount && (s.setPolygonOffset(e, t), e += s.getPolygonOffsetCount());
        }
        this.cn = e;
    }
    getPolygonOffsetCount() {
        return this.cn;
    }
    getLayers() {
        return this.layers.slice();
    }
    ti() {
        return this.layers;
    }
    toJSON() {
        const t = [];
        if (this.layers) for (let e = 0; e < this.layers.length; e++) {
            const i = this.layers[e];
            i && (i && i.toJSON && t.push(i.toJSON()));
        }
        return {
            "type": this.getJSONType(),
            "id": this.getId(),
            "layers": t,
            "options": this.config()
        };
    }
    onLoadEnd() {
        this.layers.forEach((t => {
            this.hn(t);
        })), this.options.terrain && this.un(), super.onLoadEnd();
    }
    hn(t) {
        const e = this.getMap();
        this.rn[t.getId()] = t, t._canvas = this.getRenderer().canvas, t._bindMap(e), t.once("renderercreate", this.dn, this), 
        t.remove = () => (this.removeLayer(t), t.constructor.prototype.remove.call(t), delete t.remove, 
        this), t.load(), this.mn(t);
    }
    onRemove() {
        this.gn(), this.layers.forEach((t => {
            this.pn(t), t._doRemove(), this.ln(t);
        })), this.rn = {}, this.clearAnalysis(), super.onRemove();
    }
    getChildLayer(t) {
        return this.rn[t] || null;
    }
    getLayer(t) {
        return this.getChildLayer(t);
    }
    mn(t) {
        t.on("show hide", this.wn, this), t.on("idchange", this.vn, this);
    }
    ln(t) {
        t.off("show hide", this.wn, this), t.off("idchange", this.vn, this);
    }
    wn() {
        const t = this.getRenderer();
        t && t.setToRedraw();
    }
    vn(t) {
        const e = t.new, i = t.old, s = this.getLayer(i);
        delete this.rn[i], this.rn[e] = s;
    }
    dn(t) {
        t.renderer.clearCanvas = Cs;
    }
    nn() {
        const t = {};
        this.layers.forEach((e => {
            const i = e.getId();
            if (t[i]) throw new Error(`Duplicate child layer id (${i}) in the GroupGLLayer (${this.getId()})`);
            t[i] = 1;
        }));
    }
    addAnalysis(t) {
        this.ve = this.ve || [], this.ve.push(t);
        const e = this.getRenderer();
        e && e.setToRedraw();
    }
    removeAnalysis(t) {
        if (this.ve) {
            const e = this.ve.indexOf(t);
            e > -1 && (this.ve.splice(e, 1), t.remove());
        }
        const e = this.getRenderer();
        e && e.setToRedraw();
    }
    clearAnalysis() {
        this.ve && (this.ve.forEach((t => {
            t.remove();
        })), this.ve = []);
        const t = this.getRenderer();
        t && t.setToRedraw();
    }
    identify(e, i) {
        const s = this.getMap(), n = this.getRenderer();
        if (!s || !n) return [];
        const r = s.coordToContainerPoint(new t.Coordinate(e));
        return this.identifyAtPoint(r, i);
    }
    identifyAtPoint(t, e = {}) {
        const i = e.includeInternals, s = this.getLayers(), n = e && e.childLayers || s, r = this.getMap();
        if (!r) return [];
        const h = ft(e.count) ? 1 : e.count;
        let o = [];
        for (let r = n.length - 1; r >= 0; r--) {
            const h = n[r];
            if (s.indexOf(h) < 0 || !h.identifyAtPoint) continue;
            const a = h.options.geometryEvents;
            if (i && (void 0 === a || !1 === a || 0 === a)) continue;
            if (h.isGeometryListening && i && e.eventTypes.indexOf("mousemove") >= 0 && !h.isGeometryListening(e.eventTypes)) continue;
            const l = h.identifyAtPoint(t, e);
            if (!l || !l.length) continue;
            const c = h.getId();
            for (let t = 0; t < l.length; t++) l[t] && (l[t].layer = c);
            o.push(...l);
        }
        if (e.orderByCamera) {
            const t = r.cameraPosition;
            o.sort(((e, i) => i.point ? e.point ? c.dist(e.point, t) - c.dist(i.point, t) : 1 : -1));
        }
        return h && (o = o.slice(0, h)), o;
    }
    getTerrain() {
        return this.options.terrain;
    }
    setTerrain(t) {
        return this.options.terrain = t, this.getRenderer() ? (this.un(), this.getMap().updateCenterAltitude(), 
        this) : this;
    }
    removeTerrain() {
        return this.setTerrain(null);
    }
    updateTerrainMaterial(t) {
        this._n && t && (this.options.terrain.material ? ut(this.options.terrain.material, t) : this.options.terrain.material = t, 
        this._n.updateMaterial(t));
    }
    un() {
        const t = this.getRenderer();
        t && t.setToRedraw();
        const e = this.options.terrain;
        if (this._n) {
            const t = this._n, i = t.options;
            if (e && i.urlTemplate === e.urlTemplate && i.spatialReference === e.spatialReference) {
                for (const i in e) "material" === i ? t.setMaterial(e[i]) : "urlTemplate" !== i && "spatialReference" !== i && t.config(i, e[i]);
                return this;
            }
            this.gn();
        }
        if (this.yn(), !e) return this;
        this._n = new es("__terrain_in_group", e), this.an();
        const i = this._n;
        i.on("tileload", this.bn, this), this.hn(i);
        const s = e.masks;
        return s && s.length ? i.setMask(s) : i.removeMask(), this.fire("terrainlayercreated"), 
        this;
    }
    queryTerrain(t, e) {
        return this._n ? this._n.queryTerrain(t, e) : (e && (e[0] = null, e[1] = 0), [ null, 0 ]);
    }
    queryTerrainAtPoint(t) {
        if (!this._n) return null;
        const e = this._n.getRenderer().getAnalysisMeshes();
        return this.xn(t, e);
    }
    query3DTilesAtPoint(e) {
        const i = this.ti().filter((t => t && t.isGeo3DTilesLayer));
        if (!i.length) return null;
        const s = {
            excludeMasks: !0
        };
        for (let n = 0; n < i.length; n++) {
            if (!i[n].getRenderer()) continue;
            const r = i[n].identifyAtPoint(e, s);
            if (r.length) return new t.Coordinate(r[0].coordinate);
        }
        return null;
    }
    xn(e, i) {
        const s = this.getMap(), n = s.getGLRes();
        s.getContainerPointRay(xs, Ms, e);
        const r = new ps(xs, Ms, !1).test(i, s, {
            count: 1
        }), h = [];
        r.forEach((t => {
            t.coordinates.forEach((t => {
                h.push(t.coordinate);
            }));
        }));
        const o = s.pointAtResToCoordinate(new t.Point(xs[0], xs[1]), n, ys);
        o.z = xs[2] / s.altitudeToPoint(1, n);
        const a = c.set(bs, o.x, o.y, o.z);
        return h.sort(((t, e) => c.dist(t.toArray(), a) - c.dist(e.toArray(), a))), h[0];
    }
    queryTerrainByProjCoord(t, e) {
        return this._n ? this._n.queryTerrainByProjCoord(t, e) : (e && (e[0] = null, e[1] = 0), 
        [ null, 0 ]);
    }
    an() {
        if (!this._n) return;
        const t = this.layers, e = [];
        for (let i = 0; i < t.length; i++) {
            if (!t[i]) continue;
            const s = t[i], n = s.getRenderer();
            if (n.renderTerrainSkin) {
                if (n.deleteTile === _s) {
                    e.push(t[i]);
                    continue;
                }
                s.getTiles = () => this._n && this._n.getSkinTiles(s), n.drawTileOnTerrain ? n.drawTile = (...t) => n.drawTileOnTerrain(...t) : n.drawTile = _s, 
                n.deleteTile = _s, e.push(t[i]);
            }
            n.setTerrainHelper && n.setTerrainHelper(this._n);
        }
        this._n.setSkinLayers(e);
    }
    pn(t) {
        if (!function(t) {
            if (!t) return !1;
            const e = t.getRenderer();
            if (!e) return !1;
            return !!e.renderTerrainSkin;
        }(t)) return;
        const e = t.getRenderer();
        e && (e.setTerrainHelper && e.setTerrainHelper(null), e.clear && e.clear(), delete e.drawTile, 
        delete e.deleteTile), delete t.getTiles;
    }
    yn() {
        const t = this.layers;
        for (let e = 0; e < t.length; e++) t[e] && this.pn(t[e]);
    }
    bn() {
        const t = this.getRenderer();
        t && t.setToRedraw();
    }
    gn() {
        if (this._n) {
            const t = this._n;
            t.off("tileload", this.bn, this), this.ln(t), this._n._doRemove(), delete this._n, 
            this.fire("terrainlayerremoved");
        }
    }
    getTerrainLayer() {
        return this._n;
    }
    _bindMap(...t) {
        if (this.options.single) {
            const e = t[0].getLayers();
            for (let t = 0; t < e.length; t++) if (e[t] instanceof Ss) throw new Error("Only one GroupGLLayer is allowed in a map instance. Set options.single to false if you want to add two or more GroupGLLayers.");
        }
        return super._bindMap(...t);
    }
    fire(...t) {
        if ("layerload" === t[0]) {
            const t = this.ti();
            for (const e of t) {
                const t = e.getRenderer();
                t && t.isRenderComplete() && e.fire("layerload");
            }
        }
        super.fire(...t);
    }
}

function Cs() {}

function ks(t, e) {
    const i = t.getZIndex() - e.getZIndex();
    return 0 === i ? t.__group_gl_order - e.__group_gl_order : i;
}

var Ts;

Ss.mergeOptions({
    renderer: "gl",
    antialias: !0,
    extensions: [],
    single: !0,
    onlyWebGL1: !1,
    optionalExtensions: [ "ANGLE_instanced_arrays", "OES_element_index_uint", "OES_standard_derivatives", "OES_vertex_array_object", "OES_texture_half_float", "OES_texture_half_float_linear", "OES_texture_float", "OES_texture_float_linear", "WEBGL_depth_texture", "EXT_shader_texture_lod", "EXT_frag_depth", "EXT_texture_filter_anisotropic", "WEBGL_compressed_texture_astc", "WEBGL_compressed_texture_etc", "WEBGL_compressed_texture_etc1", "WEBGL_compressed_texture_pvrtc", "WEBGL_compressed_texture_s3tc", "WEBGL_compressed_texture_s3tc_srgb" ],
    forceRenderOnZooming: !0,
    forceRenderOnMoving: !0,
    forceRenderOnRotating: !0,
    viewMoveThreshold: 100,
    geometryEvents: !0,
    multiSamples: 4,
    forceRedrawPerFrame: !1
}), Ss.registerJSONType("GroupGLLayer"), Ss.registerRenderer("gl", Ee), Ss.registerRenderer("canvas", null), 
function(t) {
    t[t.AMBIENT = 0] = "AMBIENT", t[t.REALISTIC = 1] = "REALISTIC";
}(Ts || (Ts = {}));

class As {
    constructor(t) {
        this.Mn = t, this.B = new a.ResourceLoader;
    }
    getDirectionalLight() {
        return this.zt && this.zt.directional || {};
    }
    getAmbientLight() {
        return this.zt && this.zt.ambient || {};
    }
    getAmbientResource() {
        return this.Sn;
    }
    setConfig(t) {
        const e = this.zt;
        this.Cn = t.urlModifier, this.zt = JSON.parse(JSON.stringify(t));
        let i = !1;
        if (t && t.ambient && t.ambient.resource) {
            if (!(e && e.ambient && function(t, e) {
                if (!t.resource) return !1;
                if (t.resource.url !== e.resource.url) return !1;
                return !0;
            }(e.ambient, t.ambient))) return void this.kn();
            this.Sn && (t.ambient.prefilterCubeSize !== e.ambient && e.ambient.prefilterCubeSize && this.Tn(), 
            i = !0, t.ambient.resource.sh && (this.Sn.sh = t.ambient.resource.sh));
        } else this.An(), i = e && e.ambient && e.ambient.resource;
        this.Mn.fire("updatelights", {
            ambientUpdate: i
        });
    }
    On(t) {
        const e = t.getLayers();
        for (let t = 0; t < e.length; t++) {
            const i = e[t] && e[t].getRenderer();
            if (i && i.regl) return i.regl;
        }
        const i = document.createElement("canvas"), s = w({
            canvas: i,
            attributes: {
                depth: !1,
                stencil: !1,
                alpha: !1
            }
        });
        return s.In = !0, s;
    }
    kn() {
        const t = this.zt.ambient.resource, e = t && t.url;
        if (!e) return;
        const i = [];
        let s = 0, n = 0;
        const r = () => {
            n++, n >= s && this.Ln(i);
        }, h = function() {
            throw new Error(`skybox image with url(${this.src}) failed to load, please check the image's url.`);
        }, o = this.Cn;
        if (e.top || e.nx) {
            const {front: t, back: n, right: a, left: l, top: c, bottom: u} = e, {nx: f, ny: d, px: m, py: g, nz: p, pz: w} = e;
            let v;
            v = t ? [ l, a, n, t, c, u ] : [ f, m, p, w, g, d ], s = v.length;
            for (let t = 0; t < s; t++) {
                const e = new Image;
                e.onload = r, e.onerror = h, e.src = o && o(v[t]) || v[t], i[t] = e;
            }
        } else {
            const e = {
                url: t.url,
                arrayBuffer: !0,
                hdr: !0,
                flipY: !0
            };
            this.B.setURLModifier(o), this.En = new a.Texture2D(e, this.B), this.En.once("complete", (() => {
                this.Tn();
            })), this.En.once("error", (() => {
                this.Rn();
            }));
        }
    }
    dispose() {
        this.An();
    }
    Tn() {
        this.En && (this.Sn = this.Fn(this.En), this.Mn.fire("updatelights", {
            "ambientUpdate": !0
        }));
    }
    Rn() {
        this.Mn.fire("hdrerror");
    }
    Ln(t) {
        this.Sn = this.Fn(t), this.Mn.fire("updatelights", {
            "ambientUpdate": !0
        });
    }
    Fn(t) {
        const e = this.zt.ambient.resource, i = e.prefilterCubeSize || 512, s = this.On(this.Mn), n = a.pbr.PBRHelper.createIBLMaps(s, {
            envTexture: Array.isArray(t) ? t : t.getREGLTexture(s),
            ignoreSH: !!e.sh,
            envCubeSize: i,
            prefilterCubeSize: i,
            environmentExposure: this.zt.ambient.exposure,
            format: "array"
        });
        if (e.sh && (n.sh = e.sh, Array.isArray(n.sh[0]))) {
            const t = n.sh, e = [];
            for (let i = 0; i < t.length; i++) e.push(...t[i]);
            n.sh = e;
        }
        return s.In && (delete this.En, s.destroy()), n;
    }
    An() {
        this.En && (this.En.dispose(), delete this.En), delete this.Sn;
    }
}

let Os, Is, Ls, Es, Rs;

h.include({
    setLights(t) {
        return this.options.lights = t, this.Pn(), this;
    },
    getLights() {
        return this.options.lights;
    },
    Pn() {
        this.Hn || (this.Hn = new As(this)), this.Hn.setConfig(this.getLights());
    },
    getLightManager() {
        return this.Hn ? this.Hn : null;
    }
}), h.addOnLoadHook((function() {
    this.options.lights && this.Pn();
}));

const Fs = {
    color: [ 0, 0, 0, 0 ]
}, Ps = {
    enable: !1
};

h.include({
    setPostProcessConfig(t) {
        return this.options.postProcessConfig = t, this;
    },
    getPostProcessConfig() {
        return this.options.postProcessConfig;
    }
});

const Hs = o.MapCanvasRenderer.prototype.drawLayerCanvas;

o.MapCanvasRenderer.prototype.drawLayerCanvas = function() {
    const t = Hs.apply(this, arguments);
    return t && function(t, e) {
        const i = t.map.getPostProcessConfig();
        if (!i || !i.enable) return;
        Os || (s = e.width, n = e.height, Os = document.createElement("canvas", s, n), Is = w({
            canvas: Os,
            attributes: {
                depth: !1,
                stencil: !1,
                alpha: !0,
                antialias: !1,
                premultipliedAlpha: !1
            }
        }), Ls = Is.texture({
            mag: "linear",
            min: "linear",
            mipmap: !1,
            flipY: !0,
            width: s,
            height: n
        }), Es = Is.texture());
        var s, n;
        Os.width === e.width && Os.height === e.height || (Os.width = e.width, Os.height = e.height);
        Is.clear(Fs);
        const r = i.filmicGrain || Ps;
        void 0 === r.enable && (r.enable = !0);
        const h = i.vignette || Ps;
        void 0 === h.enable && (h.enable = !0);
        const o = i.colorLUT || Ps;
        void 0 === o.enable && (o.enable = !0);
        t.Dn || (t.Dn = {});
        const a = t.Dn;
        if (o.enable) {
            const e = o.lut;
            if (!a.lutTexture || a.lutTexture.url !== e) {
                const i = new Image;
                i.onload = function() {
                    const s = {
                        data: i,
                        min: "linear",
                        mag: "linear"
                    }, n = a.lutTexture ? a.lutTexture.texture(s) : Is.texture(s);
                    a.lutTexture = {
                        url: e,
                        texture: n
                    }, t.setLayerCanvasUpdated();
                }, i.src = e;
            }
        }
        const l = {
            "enableGrain": +!!r.enable,
            "grainFactor": void 0 === r.factor ? .15 : r.factor,
            "timeGrain": performance.now(),
            "enableVignette": +!!h.enable,
            "lensRadius": h.lensRadius || [ .8, .25 ],
            "frameMod": 1,
            "enableLut": +!!o.enable,
            "lookupTable": a.lutTexture ? a.lutTexture.texture : Es
        };
        Rs || (Rs = new be(Is));
        Rs.postprocess(null, l, Ls({
            width: Os.width,
            height: Os.height,
            data: e,
            flipY: !0,
            mag: "linear",
            min: "linear",
            mipmap: !1
        })), r.enable && t.setLayerCanvasUpdated();
        t.context.drawImage(Os, 0, 0, Os.width, Os.height);
    }(this, this.canvas), t;
};

const Ds = o.MapCanvasRenderer.prototype.renderFrame;

o.MapCanvasRenderer.prototype.renderFrame = function() {
    const t = Ds.apply(this, arguments), e = this.map.getPostProcessConfig(), i = e && e.filmicGrain;
    return !i || void 0 !== i.enable && !0 !== i.enable || this.setLayerCanvasUpdated(), 
    t;
};

const Gs = [];

function Ns(t) {
    t.properties.showOnlyTimestamp && (delete t.properties.showOnlyTimestamp, zs(t));
}

function js(t, e) {
    const i = t.geometry.properties;
    i.oldElementsBeforeHighlight || (i.oldElementsBeforeHighlight = t.geometry.elements), 
    i.elements && (i.oldElementsArrBeforeHighlight || (i.oldElementsArrBeforeHighlight = i.elements), 
    i.elements = e);
}

function zs(t) {
    const e = t.geometry.properties.oldElementsBeforeHighlight;
    e && t.geometry.elements !== e && (t.geometry.deleteElements(), t.geometry.setElements(t.geometry.properties.oldElementsBeforeHighlight), 
    t.geometry.properties.oldElementsArrBeforeHighlight && (t.geometry.properties.elements = t.geometry.properties.oldElementsArrBeforeHighlight, 
    delete t.geometry.properties.oldElementsArrBeforeHighlight), delete t.geometry.properties.hasInvisible, 
    delete t.geometry.properties.oldElementsBeforeHighlight);
}

function Bs(t) {
    if (!t.properties.highlightTimestamp) return;
    const e = t.defines;
    delete e.HAS_HIGHLIGHT_COLOR, delete e.HAS_HIGHLIGHT_OPACITY, t.setDefines(e), delete t.properties.highlightTimestamp, 
    zs(t), Us(t);
}

function Us(t) {
    if (!t) return;
    const {hlBloomMesh: e} = t.properties;
    if (e) {
        const i = e.geometry;
        i.elements && i.elements.destroy && i.deleteElements(), e.dispose(), delete t.properties.hlBloomMesh;
    }
}

var Vs = Object.freeze({
    __proto__: null,
    clearHighlight: Bs,
    clearShowOnly: Ns,
    deleteHighlightBloomMesh: Us,
    highlightMesh: function(t, e, i, s, n) {
        const {highlightTimestamp: r} = e.properties;
        if (!i) return void (r && Bs(e));
        if (s === r) return;
        const h = e.geometry.getVertexCount();
        let {aHighlightColor: o, aHighlightOpacity: c} = e.geometry.properties;
        o && o.fill(0), c && c.fill(255);
        let u = !1, f = !1;
        const d = i.keys();
        let m = null, p = null;
        for (const t of d) if (n.has(t)) {
            const e = i.get(t), {color: s, bloom: r, visible: a} = e;
            let l, {opacity: d} = e;
            if (s && (u || (o || (o = new Uint8Array(4 * h)), u = !0), l = yt(Gs, s)), d = ft(d) ? 1 : d, 
            d < 1 && (f || (c || (c = new Uint8Array(h), c.fill(255)), f = !0)), !1 === a && (p || (p = new Set), 
            p.add(t)), l || d < 1 || r) {
                const e = n.get(t);
                if (e) for (let t = 0; t < e.length; t++) {
                    const i = e[t];
                    l && g.set(o.subarray(4 * i, 4 * i + 4), ...l), d < 1 && (c[i] = 255 * d), r && (m || (m = []), 
                    m.push(i));
                }
            }
        }
        const w = e.defines;
        if (u ? (e.geometry.data.aHighlightColor ? e.geometry.updateData("aHighlightColor", o) : (e.geometry.data.aHighlightColor = o, 
        e.geometry.generateBuffers(t)), e.geometry.properties.aHighlightColor = o, w.HAS_HIGHLIGHT_COLOR = 1) : w.HAS_HIGHLIGHT_COLOR && (e.geometry.updateData("aHighlightColor", o), 
        delete w.HAS_HIGHLIGHT_COLOR), f ? (e.geometry.data.aHighlightOpacity ? e.geometry.updateData("aHighlightOpacity", c) : (e.geometry.data.aHighlightOpacity = c, 
        e.geometry.generateBuffers(t)), e.geometry.properties.aHighlightOpacity = c, w.HAS_HIGHLIGHT_OPACITY = 1) : w.HAS_HIGHLIGHT_OPACITY && (e.geometry.updateData("aHighlightOpacity", c), 
        delete w.HAS_HIGHLIGHT_OPACITY), p && p.size > 0) {
            let i = [];
            n.forEach(((t, e) => {
                p.has(e) || wt(i, t);
            })), e.geometry.properties.hasInvisible = !0, js(e, i);
            const s = {
                data: i,
                primitive: e.geometry.getPrimitive()
            };
            e.geometry.elements !== e.geometry.properties.oldElementsBeforeHighlight && e.geometry.elements.destroy && e.geometry.deleteElements(), 
            i = t.elements(s), e.geometry.setElements(i), e.geometry.generateBuffers(t);
        } else e.geometry.properties.hasInvisible && zs(e);
        e.setDefines(w), e.properties.highlightTimestamp = s;
        let v = e.properties.hlBloomMesh;
        if (m && m.length) {
            if (v) {
                const t = l.copy(v.localTransform, e.localTransform), i = l.copy(v.positionMatrix, e.positionMatrix);
                v.setLocalTransform(t), v.setPositionMatrix(i), e.properties.hlBloomMesh.geometry.setElements(m);
            } else {
                const i = new a.Geometry(e.geometry.data, m, 0, e.geometry.desc);
                i.generateBuffers(t);
                const s = e.material;
                v = new a.Mesh(i, s, e.config);
                const n = e.uniforms;
                for (const t in n) Object.defineProperty(v.uniforms, t, {
                    enumerable: !0,
                    get: function() {
                        return e.getUniform(t);
                    }
                });
                const r = ut({}, e.defines);
                r.HAS_BLOOM = 1;
                const h = l.copy([], e.localTransform), o = l.copy([], e.positionMatrix);
                v.setLocalTransform(h), v.setPositionMatrix(o), ut(v.properties, e.properties), 
                ut(i.properties, e.geometry.properties), v.setDefines(r), v.bloom = 1;
            }
            e.properties.hlBloomMesh = v;
        } else v && Us(e);
    },
    showOnly: function(t, e, i, s, n) {
        const {showOnlyTimestamp: r} = e.properties;
        if (!i) return void (r && Ns(e));
        if (s === r) return;
        e.properties.showOnlyTimestamp = s;
        const h = i.keys(), o = [];
        for (const t of h) {
            if (!n.has(t)) continue;
            const e = n.get(t);
            e && wt(o, e);
        }
        js(e, o), e.geometry.elements !== e.geometry.properties.oldElementsBeforeHighlight && e.geometry.elements.destroy && e.geometry.deleteElements();
        const a = {
            data: o,
            primitive: e.geometry.getPrimitive()
        };
        e.geometry.setElements(t.elements(a)), e.geometry.generateBuffers(t);
    }
});

const Ws = [ 0, 0, 0, 0 ];

class qs {
    constructor(t, e, i, s, n, r) {
        this.renderer = new a.Renderer(t), this.sceneConfig = e, this.h = i, this.Gn = s, 
        this.Nn = n, this.cn = r || {
            factor: 0,
            units: 0
        }, this.o(), this.jn = [];
    }
    render(t, e, i) {
        this.zn();
        const s = this.h.getMap();
        this.renderer.regl.clear({
            color: Ws,
            depth: 1,
            stencil: 255,
            framebuffer: this.Bn
        }), this.renderer.render(this.Un, e, t, this.Bn);
        const n = this.h.getRenderer().canvas;
        this.jn[0] = n.width, this.jn[1] = n.height;
        const r = ut({
            colorRamp: this.Vn,
            inputTexture: this.Bn,
            projViewMatrix: s.projViewMatrix,
            textureOutputSize: this.jn
        }, e);
        return this.M(), this.renderer.render(this.Wn, r, this.N, i);
    }
    dispose() {
        this.Un && (this.Un.dispose(), delete this.Un), this.Wn && (this.Wn.dispose(), delete this.Wn), 
        this.T && (this.T.geometry.dispose(), this.T.dispose(), delete this.T, delete this.N), 
        this.Bn && (this.Bn.destroy(), delete this.Bn);
    }
    qn() {
        const t = this.Gn;
        let e = this.$n, i = this.Yn;
        i ? i.clearRect(0, 0, 256, 1) : (e = this.$n = document.createElement("canvas"), 
        e.width = 256, e.height = 1, i = this.Yn = e.getContext("2d"));
        const s = i.createLinearGradient(0, 0, 256, 1);
        for (let e = 0; e < t.length; e++) s.addColorStop(t[e][0], t[e][1]);
        i.fillStyle = s, i.fillRect(0, 0, 256, 1), this.Vn && this.Vn.destroy();
        const n = this.renderer.regl;
        this.Vn = n.texture({
            width: 256,
            height: 1,
            data: e,
            min: "linear",
            mag: "linear",
            premultiplyAlpha: !0
        });
    }
    zn() {
        const t = this.h.getRenderer().canvas, e = Math.ceil(t.width / 4), i = Math.ceil(t.height / 4), s = this.Bn;
        s.width === e && s.height === i || s.resize(e, i);
    }
    o() {
        this.qn(), this.Xn(), this.Jn(), this._();
    }
    _() {
        const t = new a.Plane;
        t.generateBuffers(this.renderer.regl), this.T = new a.Mesh(t), this.N = new a.Scene([ this.T ]);
    }
    M() {
        const t = this.h.getMap(), e = Vt.getGroundTransform(this.T.localTransform, t);
        this.T.setLocalTransform(e);
    }
    Jn() {
        const t = this.h.getRenderer().canvas, e = this.renderer.regl, i = e.hasExtension("OES_texture_half_float") ? "half float" : "float", s = Math.ceil(t.width / 4), n = Math.ceil(t.height / 4), r = e.texture({
            width: s,
            height: n,
            type: i,
            min: "linear",
            mag: "linear",
            format: "rgba"
        });
        this.Bn = e.framebuffer({
            width: s,
            height: n,
            color: [ r ]
        });
    }
    Xn() {
        const t = this.h.getRenderer().canvas, e = this.sceneConfig.depthRange, i = {
            viewport: {
                x: 0,
                y: 0,
                width: () => t ? Math.ceil(t.width / 4) : 1,
                height: () => t ? Math.ceil(t.height / 4) : 1
            },
            depth: {
                enable: !0,
                func: "always"
            }
        };
        this.Nn && (i.stencil = this.Nn), this.Un = new a.HeatmapShader({
            extraCommandProps: i
        }), this.Wn = new a.HeatmapDisplayShader({
            x: 0,
            y: 0,
            width: () => t ? t.width : 1,
            height: () => t ? t.height : 1
        }, {
            extraCommandProps: {
                stencil: {
                    enable: !1
                },
                depth: {
                    enable: !0,
                    range: e || [ 0, 1 ],
                    func: "<="
                },
                polygonOffset: {
                    enable: !0,
                    offset: this.cn
                },
                scissor: {
                    enable: !1
                }
            }
        });
    }
}

class $s extends Gi {
    constructor(t, e) {
        super(t, e);
    }
    Pi(t) {
        const e = this.Fs(t), i = new a.Mesh(e);
        return this.Zn(i), this.Ns(i), i;
    }
    Rs(t, e, i) {
        const s = this.Hs();
        t.setUniform("maskMode", s);
        const n = this.Ds();
        if (t.setUniform("maskColor", n), dt(e)) {
            const s = this.Ws();
            s[0] = (s[0] - i) * e, s[1] = (s[1] - i) * e, t.setUniform("heightRange", s);
        }
    }
    setHeightRange(t) {
        this.options.heightRange = t, this._fireEvent("heightrangechange");
    }
    getHeightRange() {
        return this.options.heightRange;
    }
    Ws() {
        const t = [ 0, 0 ];
        return this.options.heightRange && (t[0] = this.Gs(this.options.heightRange[0]), 
        t[1] = this.Gs(this.options.heightRange[1])), t;
    }
    Zn(t) {
        const e = t.getDefines();
        e.HAS_MASK_COLOR = 1, t.setDefines(e);
    }
}

class Ys extends $s {
    constructor(t, e) {
        super(t, e), this.Ls = "clip-inside";
    }
}

class Xs extends $s {
    constructor(t, e) {
        super(t, e), this.Ls = "clip-outside";
    }
}

class Js extends Gi {
    constructor(t, e) {
        super(t, e);
    }
    setFlatheight(t) {
        this.options.flatHeight = t, this._fireEvent("flatheightchange");
    }
    Pi(t) {
        const e = this.Fs(t), i = new a.Mesh(e);
        return this.Zn(i), this.Ns(i), i;
    }
    Rs(t) {
        const e = this.Hs();
        t.setUniform("maskMode", e);
        const i = this.Ds();
        t.setUniform("maskColor", i);
        const s = this.Gs(this.options.flatHeight || 0);
        t.setUniform("flatHeight", s);
    }
    Zn(t) {
        const e = t.getDefines();
        e.HAS_MASK_FLAT = 1, t.setDefines(e);
    }
    Ws() {
        const t = [ 0, this.options.flatHeight ];
        return t[1] = this.Gs(t[1]), t;
    }
}

let Zs = class extends Js {
    constructor(t, e) {
        super(t, e), this.Ls = "flat-inside";
    }
};

class Ks extends Js {
    constructor(t, e) {
        super(t, e), this.Ls = "flat-outside";
    }
}

class Qs extends Gi {
    constructor(t, e) {
        super(t, e), this.Ls = "color";
    }
    setHeightRange(t) {
        this.options.heightRange = t, this._fireEvent("heightrangechange");
    }
    Pi(t) {
        const e = this.Fs(t), i = new a.Mesh(e);
        return this.Zn(i), this.Ns(i), i;
    }
    Rs(t, e, i) {
        const s = this.Hs();
        t.setUniform("maskMode", s);
        const n = this.Ds();
        if (t.setUniform("maskColor", n), dt(e)) {
            const s = this.Ws();
            s[0] = (s[0] - i) * e, s[1] = (s[1] - i) * e, t.setUniform("heightRange", s);
        }
    }
    Zn(t) {
        const e = t.getDefines();
        e.HAS_MASK_COLOR = 1, t.setDefines(e);
    }
    Ws() {
        const t = [ 0, 0 ];
        return this.options.heightRange && (t[0] = this.Gs(this.options.heightRange[0]), 
        t[1] = this.Gs(this.options.heightRange[1])), t;
    }
}

class tn extends Gi {
    constructor(t, e) {
        super(t, e), this.Ls = "video";
    }
    play() {
        this.Kn && this.Kn.play();
    }
    pause() {
        this.Kn && this.Kn.pause();
    }
    setAudio(t) {
        this.Kn && (this.video.muted = t);
    }
    setUrl(t) {
        this.options.url = t, this.Qn(t);
    }
    getState() {
        return this.tr;
    }
    Pi(t) {
        const e = this.Fs(t), i = new a.Mesh(e), s = this.er(t);
        return i.material = new a.Material({
            maskTexture: s
        }), this.Zn(i), this.Ns(i), i;
    }
    Rs(t) {
        const e = this.Hs();
        t.setUniform("maskMode", e);
        const i = this.Ds();
        t.setUniform("maskColor", i);
    }
    Zn(t) {
        const e = t.getDefines();
        e.HAS_VIDEO = 1, t.setDefines(e);
    }
    er(t) {
        this.Qn();
        return t.texture();
    }
    Qn() {
        this.tr = "stop";
        const t = this.options.url, e = this.options.elementId;
        let i = document.getElementById(e);
        if (t && (i = document.createElement("video"), i.src = t), !i) throw new Error("there is no element or url setting for video mask");
        i.autoplay = this.options.autoplay || !0, i.loop = this.options.loop || !0, i.muted = this.options.muted || !0, 
        i.play(), i.addEventListener("playing", (() => {
            this.tr = "playing";
        })), i.addEventListener("pause", (() => {
            this.tr = "pause";
        })), this.Kn = i;
    }
    Ei() {
        const t = this.xt;
        if (t && t.material) {
            const e = t.material.get("maskTexture");
            e && this.Kn && this.Ri() && e(this.Kn);
        }
    }
    Ri() {
        return "playing" === this.tr;
    }
}

class en extends Js {
    constructor(t, e) {
        super(t, e), this.setElevation(e.elevation), this.Ls = "elevate";
    }
    setElevation(t) {
        this.options.elevation = t, this.setFlatheight(this.options.elevation);
    }
}

const sn = new s(0, 0), nn = new s(0, 0), rn = new s(0, 0), hn = new s(0, 0);

class on extends $s {
    constructor(t, e) {
        super([], e), this.ir = t;
    }
    setPosition(t) {
        this.ir = t, this.Bs();
    }
    getPosition() {
        return this.ir;
    }
    setWidth(t) {
        this.options.width = t, this.Bs();
    }
    setLength(t) {
        this.options.length = t, this.Bs();
    }
    setHeight(t) {
        this.options.height = t, this.Bs();
    }
    setRotation(t) {
        this.options.rotation = t, this.Bs();
    }
    Bs() {
        const t = this.getLayer();
        if (!t) return;
        const e = t.getMap();
        if (e) {
            const {length: t, width: i, height: s} = this.options, n = this.ir, r = this.options.rotation || 0, {coordinates: h, heightRange: o} = this.sr(e, n, t, i, s, r);
            this.setCoordinates(h), this.setHeightRange(o);
        }
    }
    sr(t, e, i, s, n, r) {
        const h = t.getGLRes(), o = t.distanceToPointAtRes(s / 2, 0, h, sn), a = t.distanceToPointAtRes(0, i / 2, h, nn), l = t.coordinateToPointAtRes(e, h, rn), c = l.x - o.x, u = l.x + o.x, f = l.y + a.y, d = l.y - a.y, m = this.nr([ [ c, f ], [ u, f ], [ u, d ], [ c, d ] ], l, r);
        hn.set(m[0][0], m[0][1]);
        const g = t.pointAtResToCoordinate(hn, h);
        hn.set(m[1][0], m[1][1]);
        const p = t.pointAtResToCoordinate(hn, h);
        hn.set(m[2][0], m[2][1]);
        const w = t.pointAtResToCoordinate(hn, h);
        hn.set(m[3][0], m[3][1]);
        const v = t.pointAtResToCoordinate(hn, h), _ = e.z - n / 2, y = [ _, e.z + n / 2 ];
        return {
            coordinates: [ [ g.x, g.y, _ ], [ p.x, p.y, _ ], [ w.x, w.y, _ ], [ v.x, v.y, _ ], [ g.x, g.y, _ ] ],
            heightRange: y
        };
    }
    nr(t, e, i) {
        for (let s = 0; s < t.length; s++) u.rotate(t[s], t[s], [ e.x, e.y ], i * Math.PI / 180);
        return t;
    }
}

class an extends on {
    constructor(t, e) {
        super(t, e), this.Ls = "clip-inside";
    }
}

class ln extends on {
    constructor(t, e) {
        super(t, e), this.Ls = "clip-outside";
    }
}

class cn extends t.DrawTool {
    constructor(t) {
        super(t), this.on("enable", this.rr, this), this.on("disable", this.hr, this), this.ar = [];
    }
    addTo(t) {
        return t && (super.addTo(t), this.Mn = t, this.lr()), this;
    }
    lr() {
        const e = t.INTERNAL_LAYER_PREFIX + "drawtool";
        this.Mn.getLayer(e).hide();
    }
    rr() {
        this.on("drawstart", this.cr, this).on("drawvertex", this.ur, this).on("mousemove", this.dr, this).on("drawend", this.mr, this);
    }
    hr() {
        this.off("drawstart", this.cr, this).off("drawvertex", this.ur, this).off("mousemove", this.dr, this).off("drawend", this.mr, this);
    }
    gr(e) {
        const {coordinate: i, containerPoint: s} = e, n = this.Mn.getLayers((t => t.queryTerrainAtPoint))[0];
        if (!n) return i.z = i.z || 0, i;
        const r = n.identify(i, {
            includeInternals: !1
        })[0];
        let h = null;
        if (r && r.coordinate ? h = new t.Coordinate(r.coordinate) : (i.z = i.z || 0, h = i), 
        n.getTerrainLayer()) {
            const t = n.queryTerrainAtPoint(s);
            return t && t.z > h.z ? t : h;
        }
        return h;
    }
    cr(t) {
        const e = this.gr(t);
        e && (this.pr = !0, this.ar.push(e), this.wr(e));
    }
    ur(t) {
        const e = this.gr(t);
        e && (this.pr = !0, this.ar[this.ar.length - 1] = e, this.vr());
    }
    dr(t) {
        const e = this.gr(t);
        e && (this.pr ? this.ar.push(e) : this.ar[this.ar.length - 1] = e, this.vr(), this.pr = !1);
    }
    mr(t) {
        const e = this.gr(t);
        e && (this.ar.push(e), this._r());
    }
    _r() {
        this.vr(), this.ar = [], this.yr = null, this.br = null;
    }
    remove() {
        this.Mr && this.Mr.remove(), this.Sr && this.Sr.remove();
    }
    clear() {
        this.Mr && this.Mr.clear(), this.Sr && this.Sr.clear();
    }
}

cn.mergeOptions({
    "mode": "LineString",
    "language": "zh-CN",
    "metric": !0,
    "imperial": !1,
    "once": !0,
    "symbol": {
        "lineColor": "#e8542b",
        "lineWidth": 2,
        "polygonFill": "#eee",
        "polygonOpacity": .5
    },
    "vertexSymbol": {
        "markerType": "ellipse",
        "markerFill": "#e8542b",
        "markerLineColor": "#fff",
        "markerLineWidth": 2,
        "markerWidth": 10,
        "markerHeight": 10,
        "markerDy": 0
    },
    "labelSymbol": {
        "boxStyle": {
            "padding": [ 15, 6 ],
            "verticalAlignment": "top",
            "horizontalAlignment": "left",
            "minWidth": 150,
            "minHeight": 30,
            "symbol": {
                "markerType": "square",
                "markerFill": "rgb(60, 60, 60)",
                "markerFillOpacity": .8,
                "markerLineColor": "#fff",
                "markerLineWidth": 2,
                "textDx": -110
            }
        },
        "textSymbol": {
            "textFill": "#fff",
            "textSize": 16,
            "textVerticalAlignment": "top"
        }
    }
});

class un extends cn {
    lr() {
        super.lr(), this.Mr = new t.VectorLayer(t.INTERNAL_LAYER_PREFIX + "_distance3dtool", {
            enableAltitude: !0
        }).addTo(this.Mn), this.Sr = new t.VectorLayer(t.INTERNAL_LAYER_PREFIX + "_distance3dtool_marker", {
            enableAltitude: !0
        }).addTo(this.Mn);
    }
    vr() {
        this.yr.setCoordinates(this.ar);
        const e = this.Sr.getGeometries(), i = this.Mr.getGeometries().length;
        for (let t = 0; t < e.length; t++) {
            const s = e[t].getId();
            s !== "label" + i && s.indexOf(`${i}_`) > -1 && e[t].remove();
        }
        for (let e = 0; e < this.ar.length; e++) new t.Marker(this.ar[e], {
            id: i + "_" + e,
            symbol: this.options.vertexSymbol
        }).addTo(this.Sr);
        this.Cr();
    }
    Cr() {
        const e = this.getMeasureResult(), i = (("zh-CN" === this.options.language ? 0 : 1) ? "distance: " : "距离: ") + this.kr(e), s = this.ar[this.ar.length - 1], n = this.Mr.getGeometries().length, r = t.Util.extend({
            id: "label" + n
        }, this.options.labelSymbol);
        this.br ? (this.br.setContent(i), this.br.setCoordinates(s)) : this.br = new t.Label(i, s, r).addTo(this.Sr);
    }
    kr(t) {
        let e;
        e = "zh-CN" === this.options.language ? [ " 米", " 公里", " 英尺", " 英里" ] : [ " m", " km", " feet", " mile" ];
        let i = "";
        return this.options.metric && (this.Tr = t < 1e3 ? t.toFixed(1) : (t / 1e3).toFixed(2), 
        this.Ar = t < 1e3 ? e[0] : e[1]), this.options.imperial && (t *= 3.2808399, i.length > 0 && (i += "\n"), 
        this.Tr = t < 5280 ? t.toFixed(1) : (t / 5280).toFixed(2), this.Ar = t < 5280 ? e[2] : e[3]), 
        i += this.Tr + this.Ar, i;
    }
    wr(e) {
        this.yr || (this.yr = new t.LineString([ e ], {
            symbol: this.options.symbol
        }).addTo(this.Mr)), this.vr(), this.pr = !0;
    }
    getMeasureResult() {
        return this.yr.getLength();
    }
}

class fn extends cn {
    lr() {
        super.lr(), this.Mr = new t.VectorLayer(t.INTERNAL_LAYER_PREFIX + "_area3dtool", {
            enableAltitude: !0
        }).addTo(this.Mn), this.Sr = new t.VectorLayer(t.INTERNAL_LAYER_PREFIX + "_area3dtool_marker", {
            enableAltitude: !0
        }).addTo(this.Mn);
    }
    vr() {
        const e = this.Or(this.ar);
        this.yr.setCoordinates(e), this.Ir.setCoordinates(e);
        const i = this.Sr.getGeometries(), s = this.Mr.getGeometries().length;
        for (let t = 0; t < i.length; t++) {
            const e = i[t].getId();
            e !== "label" + s && e.indexOf(`${s}_`) > -1 && i[t].remove();
        }
        for (let e = 0; e < this.ar.length; e++) new t.Marker(this.ar[e], {
            id: s + "_" + e,
            symbol: this.options.vertexSymbol
        }).addTo(this.Sr);
        this.Cr();
    }
    Or(t) {
        const e = t.map((t => t));
        return t.length > 2 && e.push(t[0]), e;
    }
    Cr() {
        const e = this.getMeasureResult(), i = (("zh-CN" === this.options.language ? 0 : 1) ? "area: " : "面积: ") + this.kr(e), s = this.ar[this.ar.length - 1], n = this.Mr.getGeometries().length, r = t.Util.extend({
            id: "label" + n
        }, this.options.labelSymbol);
        this.br ? (this.br.setContent(i), this.br.setCoordinates(s)) : this.br = new t.Label(i, s, r).addTo(this.Sr);
    }
    kr(t) {
        let e;
        e = "zh-CN" === this.options.language ? [ " 平方米", " 平方公里", " 平方英尺", " 平方英里" ] : [ " sq.m", " sq.km", " sq.ft", " sq.mi" ];
        let i = "";
        if (this.options.metric && (this.Tr = t < 1e6 ? t.toFixed(2) : (t / 1e6).toFixed(2), 
        this.Ar = t < 1e6 ? e[0] : e[1]), this.options.imperial) {
            t *= 3.2808399, i.length > 0 && (i += "\n");
            const s = 27878400;
            this.Tr = t < s ? t.toFixed(2) : (t / s).toFixed(2), this.Ar = t < s ? e[2] : e[3];
        }
        return i += this.Tr + this.Ar, i;
    }
    wr(e) {
        this.yr || (this.yr = new t.LineString([ e ], {
            symbol: this.options.symbol
        }).addTo(this.Mr), this.Ir = new t.Polygon([ e ])), this.vr(), this.pr = !0;
    }
    getMeasureResult() {
        return this.Ir.getArea();
    }
}

const dn = [ [ "直线距离", "垂直高度", "水平距离" ], [ "spatial distance", "vertical height", "horizontal distance" ] ];

class mn extends cn {
    lr() {
        super.lr(), this.Sr = new t.VectorLayer(t.INTERNAL_LAYER_PREFIX + "_height3dtool_marker", {
            enableAltitude: !0
        }).addTo(this.Mn).bringToFront(), this.Mr = new t.VectorLayer(t.INTERNAL_LAYER_PREFIX + "_height3dtool", {
            enableAltitude: !0
        }).addTo(this.Mn).bringToFront();
    }
    ur(t) {
        super.ur(t), this.ar.length > 1 && (this._r(), this.disable());
    }
    vr() {
        const e = this.Sr.getGeometries(), i = this.Mr.getGeometries().length;
        for (let t = 0; t < e.length; t++) {
            const s = e[t].getId();
            s !== "label" + i + "_" + t && 0 === s.indexOf(`${i}_`) && e[t].remove();
        }
        for (let e = 0; e < this.ar.length; e++) new t.Marker(this.ar[e], {
            id: i + "_" + e,
            symbol: this.options.vertexSymbol
        }).addTo(this.Sr);
        const s = this.ar.length;
        if (s > 1) {
            const e = this.ar[s - 1].x, n = this.ar[s - 1].y, r = this.ar[s - 2].z, h = new t.Coordinate([ e, n, r ]);
            new t.Marker(h, {
                id: i + "_2",
                symbol: this.options.vertexSymbol
            }).addTo(this.Sr);
            const o = [].concat(this.ar);
            o.push(h), o.push(this.ar[0]);
            const a = o.map((t => t.z));
            this.yr.setCoordinates(o), this.yr.setProperties({
                altitude: a
            });
            const l = this.Mn.getProjection().measureLenBetween(o[0], o[2]), c = o[1].z - o[2].z, u = Math.sqrt(Math.pow(l, 2) + Math.pow(c, 2));
            this.Cr(o, [ u, c, l ]);
        }
    }
    Cr(e, i) {
        for (let s = 0; s < e.length - 1; s++) {
            const n = e[s], r = e[s + 1], h = i[s], o = "zh-CN" === this.options.language ? 0 : 1, a = this.kr(h), l = dn[o][s] + ":" + a, c = "label" + this.Mr.getGeometries().length + "_" + s, u = JSON.parse(JSON.stringify(this.options.labelSymbol));
            u.id = c, s < 2 && (u.boxStyle.symbol.textDx *= -1);
            const f = 1 === s ? n : new t.Coordinate((n.x + r.x) / 2, (n.y + r.y) / 2, (n.z + r.z) / 2), d = this.Sr.getGeometryById(c), m = `${c}_marker`, g = this.Sr.getGeometryById(m);
            d ? (d.setContent(l), d.setCoordinates(f), g.setCoordinates(f)) : (new t.Label(l, f, u).addTo(this.Sr), 
            new t.Marker(f, {
                id: m,
                symbol: this.options.vertexSymbol
            }).addTo(this.Sr));
        }
    }
    kr(t) {
        let e;
        e = "zh-CN" === this.options.language ? [ " 米", " 公里", " 英尺", " 英里" ] : [ " m", " km", " feet", " mile" ];
        let i = "";
        return this.options.metric && (this.Tr = t < 1e3 ? t.toFixed(1) : (t / 1e3).toFixed(2), 
        this.Ar = t < 1e3 ? e[0] : e[1]), this.options.imperial && (t *= 3.2808399, i.length > 0 && (i += "\n"), 
        this.Tr = t < 5280 ? t.toFixed(1) : (t / 5280).toFixed(2), this.Ar = t < 5280 ? e[2] : e[3]), 
        i += this.Tr + this.Ar, i;
    }
    wr(e) {
        this.yr || (this.yr = new t.LineString([ e ], {
            symbol: this.options.symbol
        }).addTo(this.Mr)), this.vr(), this.pr = !0;
    }
    getMeasureResult() {
        return this.yr.getLength();
    }
}

export { fn as Area3DTool, an as BoxInsideClipMask, ln as BoxOutsideClipMask, Ys as ClipInsideMask, Xs as ClipOutsideMask, Qs as ColorMask, Qe as ContextUtil, un as Distance3DTool, en as ElevateMask, Zs as FlatInsideMask, Ks as FlatOutsideMask, Vt as GroundPainter, Ss as GroupGLLayer, qs as HeatmapProcess, mn as Height3DTool, Vs as HighlightUtil, qi as MaskLayerMixin, mi as MaskRendererMixin, cn as Measure3DTool, ps as RayCaster, tn as VideoMask, at as color };
//# sourceMappingURL=gl.es.js.map
